import { QueryBuilderContext as un } from "@react-querybuilder/ctx";
export * from "@react-querybuilder/ctx";
import Ur, { useContext as Hr, useMemo as We, useEffect as Vt, useRef as Qr, Fragment as As, forwardRef as Os, useCallback as ht, useState as ks } from "react";
import Is, { produce as Ut } from "immer";
const D1 = "5.4.1";
var Kt = {}, Ls = {
  get exports() {
    return Kt;
  },
  set exports(e) {
    Kt = e;
  }
}, Ht = {};
var mr;
function Ts() {
  if (mr)
    return Ht;
  mr = 1;
  var e = Ur, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function _(d, c, S) {
    var b, m = {}, N = null, s = null;
    S !== void 0 && (N = "" + S), c.key !== void 0 && (N = "" + c.key), c.ref !== void 0 && (s = c.ref);
    for (b in c)
      r.call(c, b) && !u.hasOwnProperty(b) && (m[b] = c[b]);
    if (d && d.defaultProps)
      for (b in c = d.defaultProps, c)
        m[b] === void 0 && (m[b] = c[b]);
    return { $$typeof: t, type: d, key: N, ref: s, props: m, _owner: o.current };
  }
  return Ht.Fragment = n, Ht.jsx = _, Ht.jsxs = _, Ht;
}
var Qt = {};
var br;
function ws() {
  return br || (br = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ur, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), _ = Symbol.for("react.provider"), d = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), S = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), N = Symbol.for("react.lazy"), s = Symbol.for("react.offscreen"), g = Symbol.iterator, v = "@@iterator";
    function p(l) {
      if (l === null || typeof l != "object")
        return null;
      var L = g && l[g] || l[v];
      return typeof L == "function" ? L : null;
    }
    var y = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(l) {
      {
        for (var L = arguments.length, D = new Array(L > 1 ? L - 1 : 0), ie = 1; ie < L; ie++)
          D[ie - 1] = arguments[ie];
        h("error", l, D);
      }
    }
    function h(l, L, D) {
      {
        var ie = y.ReactDebugCurrentFrame, Ce = ie.getStackAddendum();
        Ce !== "" && (L += "%s", D = D.concat([Ce]));
        var Ie = D.map(function(_e) {
          return String(_e);
        });
        Ie.unshift("Warning: " + L), Function.prototype.apply.call(console[l], console, Ie);
      }
    }
    var f = !1, E = !1, C = !1, k = !1, x = !1, O;
    O = Symbol.for("react.module.reference");
    function Q(l) {
      return !!(typeof l == "string" || typeof l == "function" || l === r || l === u || x || l === o || l === S || l === b || k || l === s || f || E || C || typeof l == "object" && l !== null && (l.$$typeof === N || l.$$typeof === m || l.$$typeof === _ || l.$$typeof === d || l.$$typeof === c || l.$$typeof === O || l.getModuleId !== void 0));
    }
    function T(l, L, D) {
      var ie = l.displayName;
      if (ie)
        return ie;
      var Ce = L.displayName || L.name || "";
      return Ce !== "" ? D + "(" + Ce + ")" : D;
    }
    function P(l) {
      return l.displayName || "Context";
    }
    function w(l) {
      if (l == null)
        return null;
      if (typeof l.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
        return l.displayName || l.name || null;
      if (typeof l == "string")
        return l;
      switch (l) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case u:
          return "Profiler";
        case o:
          return "StrictMode";
        case S:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case d:
            var L = l;
            return P(L) + ".Consumer";
          case _:
            var D = l;
            return P(D._context) + ".Provider";
          case c:
            return T(l, l.render, "ForwardRef");
          case m:
            var ie = l.displayName || null;
            return ie !== null ? ie : w(l.type) || "Memo";
          case N: {
            var Ce = l, Ie = Ce._payload, _e = Ce._init;
            try {
              return w(_e(Ie));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, j = 0, q, M, V, B, J, X, be;
    function F() {
    }
    F.__reactDisabledLog = !0;
    function W() {
      {
        if (j === 0) {
          q = console.log, M = console.info, V = console.warn, B = console.error, J = console.group, X = console.groupCollapsed, be = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: F,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        j++;
      }
    }
    function Y() {
      {
        if (j--, j === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, l, {
              value: q
            }),
            info: $({}, l, {
              value: M
            }),
            warn: $({}, l, {
              value: V
            }),
            error: $({}, l, {
              value: B
            }),
            group: $({}, l, {
              value: J
            }),
            groupCollapsed: $({}, l, {
              value: X
            }),
            groupEnd: $({}, l, {
              value: be
            })
          });
        }
        j < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var te = y.ReactCurrentDispatcher, pe;
    function ee(l, L, D) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (Ce) {
            var ie = Ce.stack.trim().match(/\n( *(at )?)/);
            pe = ie && ie[1] || "";
          }
        return `
` + pe + l;
      }
    }
    var I = !1, ce;
    {
      var A = typeof WeakMap == "function" ? WeakMap : Map;
      ce = new A();
    }
    function z(l, L) {
      if (!l || I)
        return "";
      {
        var D = ce.get(l);
        if (D !== void 0)
          return D;
      }
      var ie;
      I = !0;
      var Ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ie;
      Ie = te.current, te.current = null, W();
      try {
        if (L) {
          var _e = function() {
            throw Error();
          };
          if (Object.defineProperty(_e.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_e, []);
            } catch (ot) {
              ie = ot;
            }
            Reflect.construct(l, [], _e);
          } else {
            try {
              _e.call();
            } catch (ot) {
              ie = ot;
            }
            l.call(_e.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ot) {
            ie = ot;
          }
          l();
        }
      } catch (ot) {
        if (ot && ie && typeof ot.stack == "string") {
          for (var ye = ot.stack.split(`
`), Je = ie.stack.split(`
`), xe = ye.length - 1, Ve = Je.length - 1; xe >= 1 && Ve >= 0 && ye[xe] !== Je[Ve]; )
            Ve--;
          for (; xe >= 1 && Ve >= 0; xe--, Ve--)
            if (ye[xe] !== Je[Ve]) {
              if (xe !== 1 || Ve !== 1)
                do
                  if (xe--, Ve--, Ve < 0 || ye[xe] !== Je[Ve]) {
                    var Ke = `
` + ye[xe].replace(" at new ", " at ");
                    return l.displayName && Ke.includes("<anonymous>") && (Ke = Ke.replace("<anonymous>", l.displayName)), typeof l == "function" && ce.set(l, Ke), Ke;
                  }
                while (xe >= 1 && Ve >= 0);
              break;
            }
        }
      } finally {
        I = !1, te.current = Ie, Y(), Error.prepareStackTrace = Ce;
      }
      var ct = l ? l.displayName || l.name : "", Gt = ct ? ee(ct) : "";
      return typeof l == "function" && ce.set(l, Gt), Gt;
    }
    function ue(l, L, D) {
      return z(l, !1);
    }
    function le(l) {
      var L = l.prototype;
      return !!(L && L.isReactComponent);
    }
    function ve(l, L, D) {
      if (l == null)
        return "";
      if (typeof l == "function")
        return z(l, le(l));
      if (typeof l == "string")
        return ee(l);
      switch (l) {
        case S:
          return ee("Suspense");
        case b:
          return ee("SuspenseList");
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case c:
            return ue(l.render);
          case m:
            return ve(l.type, L, D);
          case N: {
            var ie = l, Ce = ie._payload, Ie = ie._init;
            try {
              return ve(Ie(Ce), L, D);
            } catch {
            }
          }
        }
      return "";
    }
    var se = Object.prototype.hasOwnProperty, he = {}, Ue = y.ReactDebugCurrentFrame;
    function Pe(l) {
      if (l) {
        var L = l._owner, D = ve(l.type, l._source, L ? L.type : null);
        Ue.setExtraStackFrame(D);
      } else
        Ue.setExtraStackFrame(null);
    }
    function je(l, L, D, ie, Ce) {
      {
        var Ie = Function.call.bind(se);
        for (var _e in l)
          if (Ie(l, _e)) {
            var ye = void 0;
            try {
              if (typeof l[_e] != "function") {
                var Je = Error((ie || "React class") + ": " + D + " type `" + _e + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[_e] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Je.name = "Invariant Violation", Je;
              }
              ye = l[_e](L, _e, ie, D, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (xe) {
              ye = xe;
            }
            ye && !(ye instanceof Error) && (Pe(Ce), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ie || "React class", D, _e, typeof ye), Pe(null)), ye instanceof Error && !(ye.message in he) && (he[ye.message] = !0, Pe(Ce), R("Failed %s type: %s", D, ye.message), Pe(null));
          }
      }
    }
    var ge = Array.isArray;
    function Ee(l) {
      return ge(l);
    }
    function Le(l) {
      {
        var L = typeof Symbol == "function" && Symbol.toStringTag, D = L && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return D;
      }
    }
    function fe(l) {
      try {
        return Te(l), !1;
      } catch {
        return !0;
      }
    }
    function Te(l) {
      return "" + l;
    }
    function Ne(l) {
      if (fe(l))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Le(l)), Te(l);
    }
    var Oe = y.ReactCurrentOwner, $e = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, oe, re, U;
    U = {};
    function K(l) {
      if (se.call(l, "ref")) {
        var L = Object.getOwnPropertyDescriptor(l, "ref").get;
        if (L && L.isReactWarning)
          return !1;
      }
      return l.ref !== void 0;
    }
    function He(l) {
      if (se.call(l, "key")) {
        var L = Object.getOwnPropertyDescriptor(l, "key").get;
        if (L && L.isReactWarning)
          return !1;
      }
      return l.key !== void 0;
    }
    function it(l, L) {
      if (typeof l.ref == "string" && Oe.current && L && Oe.current.stateNode !== L) {
        var D = w(Oe.current.type);
        U[D] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', w(Oe.current.type), l.ref), U[D] = !0);
      }
    }
    function ut(l, L) {
      {
        var D = function() {
          oe || (oe = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
        };
        D.isReactWarning = !0, Object.defineProperty(l, "key", {
          get: D,
          configurable: !0
        });
      }
    }
    function Xe(l, L) {
      {
        var D = function() {
          re || (re = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
        };
        D.isReactWarning = !0, Object.defineProperty(l, "ref", {
          get: D,
          configurable: !0
        });
      }
    }
    var Be = function(l, L, D, ie, Ce, Ie, _e) {
      var ye = {
        $$typeof: t,
        type: l,
        key: L,
        ref: D,
        props: _e,
        _owner: Ie
      };
      return ye._store = {}, Object.defineProperty(ye._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ye, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ie
      }), Object.defineProperty(ye, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ce
      }), Object.freeze && (Object.freeze(ye.props), Object.freeze(ye)), ye;
    };
    function Fe(l, L, D, ie, Ce) {
      {
        var Ie, _e = {}, ye = null, Je = null;
        D !== void 0 && (Ne(D), ye = "" + D), He(L) && (Ne(L.key), ye = "" + L.key), K(L) && (Je = L.ref, it(L, Ce));
        for (Ie in L)
          se.call(L, Ie) && !$e.hasOwnProperty(Ie) && (_e[Ie] = L[Ie]);
        if (l && l.defaultProps) {
          var xe = l.defaultProps;
          for (Ie in xe)
            _e[Ie] === void 0 && (_e[Ie] = xe[Ie]);
        }
        if (ye || Je) {
          var Ve = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
          ye && ut(_e, Ve), Je && Xe(_e, Ve);
        }
        return Be(l, ye, Je, Ce, ie, Oe.current, _e);
      }
    }
    var at = y.ReactCurrentOwner, St = y.ReactDebugCurrentFrame;
    function st(l) {
      if (l) {
        var L = l._owner, D = ve(l.type, l._source, L ? L.type : null);
        St.setExtraStackFrame(D);
      } else
        St.setExtraStackFrame(null);
    }
    var Nt;
    Nt = !1;
    function Ct(l) {
      return typeof l == "object" && l !== null && l.$$typeof === t;
    }
    function Tt() {
      {
        if (at.current) {
          var l = w(at.current.type);
          if (l)
            return `

Check the render method of \`` + l + "`.";
        }
        return "";
      }
    }
    function G(l) {
      {
        if (l !== void 0) {
          var L = l.fileName.replace(/^.*[\\\/]/, ""), D = l.lineNumber;
          return `

Check your code at ` + L + ":" + D + ".";
        }
        return "";
      }
    }
    var H = {};
    function Z(l) {
      {
        var L = Tt();
        if (!L) {
          var D = typeof l == "string" ? l : l.displayName || l.name;
          D && (L = `

Check the top-level render call using <` + D + ">.");
        }
        return L;
      }
    }
    function ke(l, L) {
      {
        if (!l._store || l._store.validated || l.key != null)
          return;
        l._store.validated = !0;
        var D = Z(L);
        if (H[D])
          return;
        H[D] = !0;
        var ie = "";
        l && l._owner && l._owner !== at.current && (ie = " It was passed a child from " + w(l._owner.type) + "."), st(l), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', D, ie), st(null);
      }
    }
    function nt(l, L) {
      {
        if (typeof l != "object")
          return;
        if (Ee(l))
          for (var D = 0; D < l.length; D++) {
            var ie = l[D];
            Ct(ie) && ke(ie, L);
          }
        else if (Ct(l))
          l._store && (l._store.validated = !0);
        else if (l) {
          var Ce = p(l);
          if (typeof Ce == "function" && Ce !== l.entries)
            for (var Ie = Ce.call(l), _e; !(_e = Ie.next()).done; )
              Ct(_e.value) && ke(_e.value, L);
        }
      }
    }
    function ft(l) {
      {
        var L = l.type;
        if (L == null || typeof L == "string")
          return;
        var D;
        if (typeof L == "function")
          D = L.propTypes;
        else if (typeof L == "object" && (L.$$typeof === c || L.$$typeof === m))
          D = L.propTypes;
        else
          return;
        if (D) {
          var ie = w(L);
          je(D, l.props, "prop", ie, l);
        } else if (L.PropTypes !== void 0 && !Nt) {
          Nt = !0;
          var Ce = w(L);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ce || "Unknown");
        }
        typeof L.getDefaultProps == "function" && !L.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function At(l) {
      {
        for (var L = Object.keys(l.props), D = 0; D < L.length; D++) {
          var ie = L[D];
          if (ie !== "children" && ie !== "key") {
            st(l), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ie), st(null);
            break;
          }
        }
        l.ref !== null && (st(l), R("Invalid attribute `ref` supplied to `React.Fragment`."), st(null));
      }
    }
    function bt(l, L, D, ie, Ce, Ie) {
      {
        var _e = Q(l);
        if (!_e) {
          var ye = "";
          (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (ye += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Je = G(Ce);
          Je ? ye += Je : ye += Tt();
          var xe;
          l === null ? xe = "null" : Ee(l) ? xe = "array" : l !== void 0 && l.$$typeof === t ? (xe = "<" + (w(l.type) || "Unknown") + " />", ye = " Did you accidentally export a JSX literal instead of a component?") : xe = typeof l, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", xe, ye);
        }
        var Ve = Fe(l, L, D, Ce, Ie);
        if (Ve == null)
          return Ve;
        if (_e) {
          var Ke = L.children;
          if (Ke !== void 0)
            if (ie)
              if (Ee(Ke)) {
                for (var ct = 0; ct < Ke.length; ct++)
                  nt(Ke[ct], l);
                Object.freeze && Object.freeze(Ke);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              nt(Ke, l);
        }
        return l === r ? At(Ve) : ft(Ve), Ve;
      }
    }
    function $t(l, L, D) {
      return bt(l, L, D, !0);
    }
    function Zt(l, L, D) {
      return bt(l, L, D, !1);
    }
    var en = Zt, tn = $t;
    Qt.Fragment = r, Qt.jsx = en, Qt.jsxs = tn;
  }()), Qt;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Ts() : e.exports = ws();
})(Ls);
const gr = Kt.Fragment, de = Kt.jsx, _t = Kt.jsxs, Et = ({
  className: e,
  handleOnClick: t,
  label: n,
  title: r,
  disabled: o,
  disabledTranslation: u,
  testID: _
}) => /* @__PURE__ */ de(
  "button",
  {
    type: "button",
    "data-testid": _,
    disabled: o && !u,
    className: e,
    title: u && o ? u.title : r,
    onClick: (d) => t(d),
    children: u && o ? u.label : n
  }
);
Et.displayName = "ActionElement";
const qr = "~", gn = "------", Mn = qr, xs = gn, Ps = gn, Un = qr, Vs = gn, Ds = gn, zn = ",", Hn = {
  fields: {
    title: "Fields",
    placeholderName: Mn,
    placeholderLabel: xs,
    placeholderGroupLabel: Ps
  },
  operators: {
    title: "Operators",
    placeholderName: Un,
    placeholderLabel: Vs,
    placeholderGroupLabel: Ds
  },
  value: {
    title: "Value"
  },
  removeRule: {
    label: "x",
    title: "Remove rule"
  },
  removeGroup: {
    label: "x",
    title: "Remove group"
  },
  addRule: {
    label: "+Rule",
    title: "Add rule"
  },
  addGroup: {
    label: "+Group",
    title: "Add group"
  },
  combinators: {
    title: "Combinators"
  },
  notToggle: {
    label: "Not",
    title: "Invert this group"
  },
  cloneRule: {
    label: "⧉",
    title: "Clone rule"
  },
  cloneRuleGroup: {
    label: "⧉",
    title: "Clone group"
  },
  dragHandle: {
    label: "⁞⁞",
    title: "Drag handle"
  },
  lockRule: {
    label: "🔓",
    title: "Lock rule"
  },
  lockGroup: {
    label: "🔓",
    title: "Lock group"
  },
  lockRuleDisabled: {
    label: "🔒",
    title: "Unlock rule"
  },
  lockGroupDisabled: {
    label: "🔒",
    title: "Unlock group"
  },
  valueSourceSelector: {
    title: "Value source"
  }
}, $s = [
  { name: "=", label: "=" },
  { name: "!=", label: "!=" },
  { name: "<", label: "<" },
  { name: ">", label: ">" },
  { name: "<=", label: "<=" },
  { name: ">=", label: ">=" },
  { name: "contains", label: "contains" },
  { name: "beginsWith", label: "begins with" },
  { name: "endsWith", label: "ends with" },
  { name: "doesNotContain", label: "does not contain" },
  { name: "doesNotBeginWith", label: "does not begin with" },
  { name: "doesNotEndWith", label: "does not end with" },
  { name: "null", label: "is null" },
  { name: "notNull", label: "is not null" },
  { name: "in", label: "in" },
  { name: "notIn", label: "not in" },
  { name: "between", label: "between" },
  { name: "notBetween", label: "not between" }
], Jr = {
  "=": "!=",
  "!=": "=",
  "<": ">=",
  "<=": ">",
  ">": "<=",
  ">=": "<",
  beginsWith: "doesNotBeginWith",
  doesNotBeginWith: "beginsWith",
  endsWith: "doesNotEndWith",
  doesNotEndWith: "endsWith",
  contains: "doesNotContain",
  doesNotContain: "contains",
  between: "notBetween",
  notBetween: "between",
  in: "notIn",
  notIn: "in",
  notNull: "null",
  null: "notNull"
}, Dt = [
  { name: "and", label: "AND" },
  { name: "or", label: "OR" }
], $1 = [
  ...Dt,
  { name: "xor", label: "XOR" }
], Se = {
  queryBuilder: "queryBuilder",
  ruleGroup: "ruleGroup",
  header: "ruleGroup-header",
  body: "ruleGroup-body",
  combinators: "ruleGroup-combinators",
  addRule: "ruleGroup-addRule",
  addGroup: "ruleGroup-addGroup",
  cloneRule: "rule-cloneRule",
  cloneGroup: "ruleGroup-cloneGroup",
  removeGroup: "ruleGroup-remove",
  notToggle: "ruleGroup-notToggle",
  rule: "rule",
  fields: "rule-fields",
  operators: "rule-operators",
  value: "rule-value",
  removeRule: "rule-remove",
  betweenRules: "betweenRules",
  valid: "queryBuilder-valid",
  invalid: "queryBuilder-invalid",
  dndDragging: "dndDragging",
  dndOver: "dndOver",
  dndCopy: "dndCopy",
  dragHandle: "queryBuilder-dragHandle",
  disabled: "queryBuilder-disabled",
  lockRule: "rule-lock",
  lockGroup: "ruleGroup-lock",
  valueSource: "rule-valueSource",
  valueListItem: "rule-value-list-item",
  branches: "queryBuilder-branches"
}, Gs = {
  queryBuilder: "",
  ruleGroup: "",
  header: "",
  body: "",
  combinators: "",
  addRule: "",
  addGroup: "",
  cloneRule: "",
  cloneGroup: "",
  removeGroup: "",
  notToggle: "",
  rule: "",
  fields: "",
  operators: "",
  value: "",
  removeRule: "",
  dragHandle: "",
  lockRule: "",
  lockGroup: "",
  valueSource: ""
}, $n = {
  empty: "empty",
  invalidCombinator: "invalid combinator",
  invalidIndependentCombinators: "invalid independent combinators"
}, qe = {
  rule: "rule",
  ruleGroup: "rule-group",
  inlineCombinator: "inline-combinator",
  addGroup: "add-group",
  removeGroup: "remove-group",
  cloneGroup: "clone-group",
  cloneRule: "clone-rule",
  addRule: "add-rule",
  removeRule: "remove-rule",
  combinators: "combinators",
  fields: "fields",
  operators: "operators",
  valueEditor: "value-editor",
  notToggle: "not-toggle",
  dragHandle: "drag-handle",
  lockRule: "lock-rule",
  lockGroup: "lock-group",
  valueSourceSelector: "value-source-selector"
}, vt = {
  parentPathDisabled: "action aborted: parent path disabled",
  pathDisabled: "action aborted: path is disabled",
  queryUpdate: "query updated",
  onAddRuleFalse: "onAddRule callback returned false",
  onAddGroupFalse: "onAddGroup callback returned false",
  onRemoveFalse: "onRemove callback returned false"
}, Yr = ({
  component: e,
  path: t,
  independentCombinators: n,
  ...r
}) => /* @__PURE__ */ de(
  "div",
  {
    className: Se.betweenRules,
    "data-testid": qe.inlineCombinator,
    children: /* @__PURE__ */ de(e, { ...r, path: t, testID: qe.combinators })
  },
  "no-dnd"
);
Yr.displayName = "InlineCombinator";
function zr(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = zr(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function De() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = zr(e)) && (r && (r += " "), r += t);
  return r;
}
const yt = (e) => Array.isArray(e) && e.length > 0 && "options" in e[0], Xr = (e, t) => (yt(e) ? e.flatMap((n) => n.options) : e).find((n) => n.name === t), Pt = (e) => !Array.isArray(e) || e.length === 0 ? null : yt(e) ? e[0].options[0].name : e[0].name, Xn = (e, t, n) => {
  if (!e.comparator) {
    const o = (u) => u.name !== e.name;
    return yt(t) ? t.map((u) => ({
      ...u,
      options: u.options.filter(o)
    })) : t.filter(o);
  }
  const r = (o) => e.name === o.name ? !1 : typeof e.comparator == "string" ? e[e.comparator] === o[e.comparator] : e.comparator(o, n);
  return yt(t) ? t.map((o) => ({ ...o, options: o.options.filter(r) })).filter((o) => o.options.length > 0) : t.filter(r);
}, Kr = (e) => {
  const t = typeof e == "boolean" ? e : typeof e == "object" && e !== null ? e.valid : null;
  return typeof t == "boolean" ? t ? Se.valid : Se.invalid : "";
}, Qn = (e, t, n) => {
  const r = e ?? {};
  if (r.valueSources)
    return typeof r.valueSources == "function" ? r.valueSources(t) : r.valueSources;
  if (n) {
    const o = n(r.name, t);
    if (o)
      return o;
  }
  return ["value"];
}, Bs = (e, t = zn) => typeof e == "string" ? e.split(`\\${t}`).map((n) => n.split(t)).reduce((n, r, o) => o === 0 ? r : [
  ...n.slice(0, n.length - 1),
  `${n[n.length - 1]}${t}${r[0]}`,
  ...r.slice(1)
], []) : [], fn = (e, t = zn) => e.map((n) => (n ?? "").replaceAll(t, `\\${t}`)).join(t), ze = (e) => typeof e == "string" ? e.trim() : e, tt = (e) => (Array.isArray(e) ? e : typeof e == "string" ? Bs(e, zn).filter((t) => !/^\s*$/.test(t)) : []).map(ze), G1 = (e) => e.every(Boolean), B1 = (...e) => e.filter(Boolean).join(" "), Zr = (e) => typeof e == "object" && "rules" in e && Array.isArray(e.rules), hn = (e) => Zr(e) && "combinator" in e, Fs = (e) => Zr(e) && !("combinator" in e), vr = (e) => typeof e == "object" && "rules" in e ? es(e) : e, es = (e) => {
  const t = [], n = (o) => t.push(vr(o));
  let r = 0;
  for (let o = 0; o < e.rules.length; o += 2)
    if (e.rules.length === 1)
      n(e.rules[0]);
    else if (e.rules[o + 1] === "and") {
      r = o;
      let u = 1;
      for (; e.rules[r + u] === "and"; )
        o += 2, u += 2;
      t.push({
        rules: e.rules.slice(r, o + 1).map(vr)
      }), o -= 2;
    } else
      e.rules[o + 1] === "or" && (o === 0 || o === e.rules.length - 3 ? ((o === 0 || e.rules[o - 1] === "or") && n(e.rules[o]), n(e.rules[o + 1]), o === e.rules.length - 3 && n(e.rules[o + 2])) : (e.rules[o - 1] === "and" || n(e.rules[o]), n(e.rules[o + 1])));
  return t.length === 1 && typeof t[0] == "object" && "rules" in t[0] ? { ...e, ...t[0] } : { ...e, rules: t };
}, dn = (e) => {
  const t = es(e), n = t.rules.map(
    (u) => typeof u == "string" || !("rules" in u) ? u : dn(u)
  ), r = n.length < 2 ? "and" : n[1], o = n.filter((u) => typeof u != "string");
  return { ...t, combinator: r, rules: o };
}, vn = (e) => {
  const { combinator: t, ...n } = e, r = [];
  return e.rules.forEach((o, u, _) => {
    "rules" in o ? r.push(vn(o)) : r.push(o), u < _.length - 1 && r.push(t);
  }), { ...n, rules: r };
};
function F1(e) {
  return Fs(e) ? dn(e) : vn(e);
}
const W1 = (e) => {
  const t = {}, n = (r) => {
    const o = [];
    if (r.rules.length === 0)
      o.push($n.empty);
    else if (!("combinator" in r)) {
      let u = !1;
      for (let _ = 0; _ < r.rules.length && !u; _++)
        (_ % 2 === 0 && typeof r.rules[_] == "string" || _ % 2 === 1 && typeof r.rules[_] != "string" || _ % 2 === 1 && typeof r.rules[_] == "string" && !Dt.map((d) => d.name).includes(r.rules[_])) && (u = !0);
      u && o.push($n.invalidIndependentCombinators);
    }
    "combinator" in r && !Dt.map((u) => u.name).includes(r.combinator) && r.rules.length > 1 && o.push($n.invalidCombinator), r.id && (o.length ? t[r.id] = { valid: !1, reasons: o } : t[r.id] = !0), r.rules.forEach((u) => {
      typeof u == "string" || "rules" in u && n(u);
    });
  };
  return n(e), t;
}, ts = /^\s*[+-]?(\d+|\d*\.\d+|\d+\.\d*)([Ee][+-]?\d+)?\s*$/, Ws = (e) => {
  switch (e.toLowerCase()) {
    case "null":
      return "is null";
    case "notnull":
      return "is not null";
    case "notin":
      return "not in";
    case "notbetween":
      return "not between";
    case "contains":
    case "beginswith":
    case "endswith":
      return "like";
    case "doesnotcontain":
    case "doesnotbeginwith":
    case "doesnotendwith":
      return "not like";
    default:
      return e;
  }
}, Er = {
  "=": "$eq",
  "!=": "$ne",
  "<": "$lt",
  "<=": "$lte",
  ">": "$gt",
  ">=": "$gte",
  in: "$in",
  notIn: "$nin"
}, _r = {
  and: "&&",
  or: "||"
}, j1 = {
  startsWith: (e, t) => e.startsWith(t),
  endsWith: (e, t) => e.endsWith(t)
}, ns = (e) => ({
  ...e,
  rules: e.rules.map((t) => {
    if (typeof t == "string")
      return t;
    if ("rules" in t)
      return ns(t);
    let { value: n } = t;
    return typeof n == "string" && ts.test(n) && (n = parseFloat(n)), { ...t, value: n };
  })
}), Mt = (e) => typeof e == "string" && e.length > 0 || typeof e == "number" && !isNaN(e) || typeof e != "string" && typeof e != "number", Ge = (e, t) => !!t && (typeof e == "number" || typeof e == "bigint" || typeof e == "string" && ts.test(e)), js = (e) => e.length >= 3, on = (e) => /^(does)?not/i.test(e), pn = ({ field: e, operator: t, value: n, valueSource: r }, { escapeQuotes: o, parseNumbers: u } = {}) => {
  const _ = (b) => typeof b != "string" || !o ? b : b.replaceAll('"', '\\"'), d = r === "field", c = t.replace(/^=$/, "=="), S = typeof n == "number" || typeof n == "boolean" || typeof n == "bigint" || Ge(n, u);
  if (c === "<" || c === "<=" || c === "==" || c === "!=" || c === ">" || c === ">=")
    return `${e} ${c} ${d || S ? ze(n) : `"${_(n)}"`}`;
  if (c === "contains" || c === "doesNotContain")
    return `${on(c) ? "!" : ""}${e}.contains(${d ? ze(n) : `"${_(n)}"`})`;
  if (c === "beginsWith" || c === "doesNotBeginWith")
    return `${on(c) ? "!" : ""}${e}.startsWith(${d ? ze(n) : `"${_(n)}"`})`;
  if (c === "endsWith" || c === "doesNotEndWith")
    return `${on(c) ? "!" : ""}${e}.endsWith(${d ? ze(n) : `"${_(n)}"`})`;
  if (c === "null")
    return `${e} == null`;
  if (c === "notNull")
    return `${e} != null`;
  if (c === "in" || c === "notIn") {
    const b = on(c), m = tt(n);
    return m.length > 0 ? `${b ? "!(" : ""}${e} in [${m.map(
      (N) => d || Ge(N, u) ? `${ze(N)}` : `"${_(N)}"`
    ).join(", ")}]${b ? ")" : ""}` : "";
  } else if (c === "between" || c === "notBetween") {
    const b = tt(n);
    if (b.length >= 2 && !!b[0] && !!b[1]) {
      const [m, N] = b, s = Ge(m, !0) ? parseFloat(m) : NaN, g = Ge(N, !0) ? parseFloat(N) : NaN;
      let v = isNaN(s) ? d ? `${m}` : `"${_(m)}"` : s, p = isNaN(g) ? d ? `${N}` : `"${_(N)}"` : g;
      if (v === s && p === g && g < s) {
        const y = g;
        p = s, v = y;
      }
      return t === "between" ? `(${e} >= ${v} && ${e} <= ${p})` : `(${e} < ${v} || ${e} > ${p})`;
    } else
      return "";
  }
  return "";
}, yn = ({ field: e, operator: t, value: n, valueSource: r }, { parseNumbers: o } = {}) => {
  const u = (c) => typeof c != "string" ? c : c.replaceAll("\\", "\\\\").replaceAll('"', '\\"'), _ = r === "field", d = typeof n == "number" || typeof n == "boolean" || typeof n == "bigint" || Ge(n, o);
  if (t === "=" && !_)
    return `{"${e}":${d ? ze(n) : `"${u(n)}"`}}`;
  if (t === "<" || t === "<=" || t === "=" || t === "!=" || t === ">" || t === ">=") {
    const c = Er[t];
    return _ ? `{"$expr":{"${c}":["$${e}","$${n}"]}}` : `{"${e}":{"${c}":${d ? ze(n) : `"${u(n)}"`}}}`;
  } else {
    if (t === "contains")
      return _ ? `{"$where":"this.${e}.includes(this.${n})"}` : `{"${e}":{"$regex":"${u(n)}"}}`;
    if (t === "beginsWith")
      return _ ? `{"$where":"this.${e}.startsWith(this.${n})"}` : `{"${e}":{"$regex":"^${u(n)}"}}`;
    if (t === "endsWith")
      return _ ? `{"$where":"this.${e}.endsWith(this.${n})"}` : `{"${e}":{"$regex":"${u(n)}$"}}`;
    if (t === "doesNotContain")
      return _ ? `{"$where":"!this.${e}.includes(this.${n})"}` : `{"${e}":{"$not":{"$regex":"${u(n)}"}}}`;
    if (t === "doesNotBeginWith")
      return _ ? `{"$where":"!this.${e}.startsWith(this.${n})"}` : `{"${e}":{"$not":{"$regex":"^${u(n)}"}}}`;
    if (t === "doesNotEndWith")
      return _ ? `{"$where":"!this.${e}.endsWith(this.${n})"}` : `{"${e}":{"$not":{"$regex":"${u(n)}$"}}}`;
    if (t === "null")
      return `{"${e}":null}`;
    if (t === "notNull")
      return `{"${e}":{"$ne":null}}`;
    if (t === "in" || t === "notIn") {
      const c = tt(n);
      return c.length > 0 ? _ ? `{"$where":"${t === "notIn" ? "!" : ""}[${c.map((S) => `this.${S}`).join(",")}].includes(this.${e})"}` : `{"${e}":{"${Er[t]}":[${c.map(
        (S) => Ge(S, o) ? `${ze(S)}` : `"${u(S)}"`
      ).join(",")}]}}` : "";
    } else if (t === "between" || t === "notBetween") {
      const c = tt(n);
      if (c.length >= 2 && Mt(c[0]) && Mt(c[1])) {
        const [S, b] = c, m = Ge(S, !0) ? parseFloat(S) : NaN, N = Ge(b, !0) ? parseFloat(b) : NaN, s = _ || !isNaN(m) ? `${S}` : `"${u(S)}"`, g = _ || !isNaN(N) ? `${b}` : `"${u(b)}"`;
        return t === "between" ? _ ? `{"$and":[{"$expr":{"$gte":["$${e}","$${s}"]}},{"$expr":{"$lte":["$${e}","$${g}"]}}]}` : `{"${e}":{"$gte":${s},"$lte":${g}}}` : _ ? `{"$or":[{"$expr":{"$lt":["$${e}","$${s}"]}},{"$expr":{"$gt":["$${e}","$${g}"]}}]}` : `{"$or":[{"${e}":{"$lt":${s}}},{"${e}":{"$gt":${g}}}]}`;
      } else
        return "";
    }
  }
  return "";
}, an = (e) => /^(does)?not/i.test(e), Gn = (e, t) => `${t ? "!(" : ""}${e}${t ? ")" : ""}`, mn = ({ field: e, operator: t, value: n, valueSource: r }, { escapeQuotes: o, parseNumbers: u } = {}) => {
  const _ = (b) => typeof b != "string" || !o ? b : b.replaceAll("'", "\\'"), d = r === "field", c = t.replace(/^=$/, "=="), S = typeof n == "number" || typeof n == "boolean" || typeof n == "bigint" || Ge(n, u);
  if (c === "<" || c === "<=" || c === "==" || c === "!=" || c === ">" || c === ">=")
    return `${e} ${c} ${d || S ? ze(n) : `'${_(n)}'`}`;
  if (c === "contains" || c === "doesNotContain")
    return Gn(
      `${e} matches ${d || S ? ze(n) : `'${_(n)}'`}`,
      an(c)
    );
  if (c === "beginsWith" || c === "doesNotBeginWith") {
    const b = d ? `'^'.concat(${ze(n)})` : `'${typeof n == "string" && !n.startsWith("^") || S ? "^" : ""}${_(n)}'`;
    return Gn(`${e} matches ${b}`, an(c));
  } else if (c === "endsWith" || c === "doesNotEndWith") {
    const b = d ? `${ze(n)}.concat('$')` : `'${_(n)}${typeof n == "string" && !n.endsWith("$") || S ? "$" : ""}'`;
    return Gn(`${e} matches ${b}`, an(c));
  } else {
    if (c === "null")
      return `${e} == null`;
    if (c === "notNull")
      return `${e} != null`;
    if (c === "in" || c === "notIn") {
      const b = an(c) ? "!" : "", m = tt(n);
      return m.length > 0 ? `${b}(${m.map(
        (N) => `${e} == ${d || Ge(N, u) ? `${ze(N)}` : `'${_(N)}'`}`
      ).join(" or ")})` : "";
    } else if (c === "between" || c === "notBetween") {
      const b = tt(n);
      if (b.length >= 2 && !!b[0] && !!b[1]) {
        const [m, N] = b, s = Ge(m, !0) ? parseFloat(m) : NaN, g = Ge(N, !0) ? parseFloat(N) : NaN;
        let v = isNaN(s) ? d ? `${m}` : `'${_(m)}'` : s, p = isNaN(g) ? d ? `${N}` : `'${_(N)}'` : g;
        if (v === s && p === g && g < s) {
          const y = g;
          p = s, v = y;
        }
        return t === "between" ? `(${e} >= ${v} and ${e} <= ${p})` : `(${e} < ${v} or ${e} > ${p})`;
      } else
        return "";
    }
  }
  return "";
}, qn = ({ operator: e, value: t, valueSource: n }, { escapeQuotes: r, parseNumbers: o } = {}) => {
  const u = (c) => typeof c != "string" || !r ? c : c.replaceAll("'", "''"), _ = n === "field", d = e.toLowerCase();
  if (d === "null" || d === "notnull")
    return "";
  if (d === "in" || d === "notin") {
    const c = tt(t);
    return c.length > 0 ? `(${c.map(
      (S) => _ || Ge(S, o) ? `${ze(S)}` : `'${u(S)}'`
    ).join(", ")})` : "";
  } else if (d === "between" || d === "notbetween") {
    const c = tt(t);
    if (c.length >= 2 && Mt(c[0]) && Mt(c[1])) {
      const [S, b] = c;
      return _ || Ge(S, o) && Ge(b, o) ? `${ze(S)} and ${ze(b)}` : `'${u(S)}' and '${u(b)}'`;
    }
    return "";
  } else {
    if (d === "contains" || d === "doesnotcontain")
      return _ ? `'%' || ${t} || '%'` : `'%${u(t)}%'`;
    if (d === "beginswith" || d === "doesnotbeginwith")
      return _ ? `${t} || '%'` : `'${u(t)}%'`;
    if (d === "endswith" || d === "doesnotendwith")
      return _ ? `'%' || ${t}` : `'%${u(t)}'`;
    if (typeof t == "boolean")
      return `${t}`.toUpperCase();
  }
  return _ || Ge(t, o) ? `${ze(t)}` : `'${u(t)}'`;
}, Ms = (e) => e.replace(/^(=)$/, "$1=").replace(/^notNull$/i, "!=").replace(/^null$/i, "=="), qt = (e, t) => /^(does)?not/i.test(e) ? { "!": t } : t, Rr = ({ field: e, operator: t, value: n, valueSource: r }, { parseNumbers: o } = {}) => {
  const u = r === "field", _ = { var: e }, d = (c) => u ? { var: `${c}` } : Ge(c, o) ? parseFloat(c) : c;
  if (t === "<" || t === "<=" || t === "=" || t === "!=" || t === ">" || t === ">=")
    return {
      [Ms(t)]: [_, d(n)]
    };
  if (t === "null" || t === "notNull")
    return {
      [`${t === "notNull" ? "!" : "="}=`]: [_, null]
    };
  if (t === "in" || t === "notIn") {
    const c = tt(n).map(d);
    return c.length > 0 ? qt(t, { in: [_, c] }) : !1;
  } else if (t === "between" || t === "notBetween") {
    const c = tt(n);
    if (c.length >= 2 && Mt(c[0]) && Mt(c[1])) {
      let [S, b] = c;
      if (!u && Ge(S, !0) && Ge(b, !0)) {
        const N = parseFloat(S), s = parseFloat(b);
        if (s < N) {
          const g = s;
          b = N, S = g;
        } else
          S = N, b = s;
      } else
        u && (S = { var: S }, b = { var: b });
      return qt(t, { "<=": [S, _, b] });
    }
    return !1;
  } else if (t === "contains" || t === "doesNotContain") {
    const c = {
      in: [d(n), _]
    };
    return qt(t, c);
  } else if (t === "beginsWith" || t === "doesNotBeginWith") {
    const c = {
      startsWith: [_, d(n)]
    };
    return qt(t, c);
  } else if (t === "endsWith" || t === "doesNotEndWith") {
    const c = {
      endsWith: [_, d(n)]
    };
    return qt(t, c);
  }
  return !1;
}, jt = (e) => {
  const t = /* @__PURE__ */ new Set(), n = [];
  return e.forEach((r) => {
    t.has(r.name) || (t.add(r.name), n.push(r));
  }), n;
}, Bn = (e) => {
  const t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = [];
  return e.forEach((o) => {
    if (!t.has(o.label)) {
      t.add(o.label);
      const u = [];
      o.options.forEach((_) => {
        n.has(_.name) || (n.add(_.name), u.push(_));
      }), r.push({ ...o, options: u });
    }
  }), r;
}, Ae = (e) => e === null || typeof e != "object" ? !1 : Object.getPrototypeOf(e) === Object.prototype, En = (e) => {
  let t = [];
  const n = e ? Array.isArray(e) ? e : Object.keys(e).map((r) => ({ ...e[r], name: r })).sort((r, o) => r.label.localeCompare(o.label)) : [];
  return yt(n) ? t = jt(t.concat(...n.map((r) => r.options))) : t = jt(n), t;
};
function _n({
  fieldsFlat: e,
  fieldName: t,
  operator: n,
  subordinateFieldName: r,
  getValueSources: o
}) {
  if (e.length === 0)
    return !0;
  let u = !1;
  const _ = e.find((d) => d.name === t);
  return _ && (!r && n !== "notNull" && n !== "null" && !Qn(_, n, o).some((d) => d === "value") ? u = !1 : u = !0, u && !!r && (Qn(_, n, o).some((d) => d === "field") && t !== r && Xn(
    _,
    e,
    n
  ).find((c) => c.name === r) || (u = !1))), u;
}
const Sr = (e) => Ae(e) && typeof e.valid == "boolean", dt = (e, t, n) => {
  if (typeof t == "boolean")
    return t;
  if (Sr(t))
    return t.valid;
  if (typeof n == "function" && !("rules" in e)) {
    const r = n(e);
    if (typeof r == "boolean")
      return r;
    if (Sr(r))
      return r.valid;
  }
  return !0;
};
function M1(e, t = {}) {
  let n = "json", r = qn, o = null, u = "", _ = () => !0, d = [], c = {}, S = "", b = ":", m = !1, N = Mn, s = Un;
  if (typeof t == "string")
    n = t.toLowerCase(), n === "mongodb" ? o = yn : n === "cel" ? o = pn : n === "spel" ? o = mn : n === "jsonlogic" && (o = Rr);
  else {
    n = (t.format ?? "json").toLowerCase();
    const { valueProcessor: g = null, ruleProcessor: v = null } = t;
    typeof v == "function" && (o = v), r = typeof g == "function" ? (p) => js(g) ? g(p.field, p.operator, p.value, p.valueSource) : g(p, { parseNumbers: m }) : n === "mongodb" ? o ?? yn : n === "cel" ? o ?? pn : n === "spel" ? o ?? mn : n === "jsonlogic" ? o ?? Rr : qn, u = t.quoteFieldNamesWith ?? "", _ = t.validator ?? (() => !0), d = t.fields ?? [], S = t.fallbackExpression ?? "", b = t.paramPrefix ?? ":", m = !!t.parseNumbers, N = t.placeholderFieldName ?? Mn, s = t.placeholderOperatorName ?? Un;
  }
  if (S || (S = n === "mongodb" ? '"$and":[{"$expr":true}]' : n === "cel" || n === "spel" ? "1 == 1" : "(1 = 1)"), n === "json" || n === "json_without_ids") {
    const g = m ? ns(e) : e;
    return n === "json" ? JSON.stringify(g, null, 2) : JSON.stringify(g, [
      "rules",
      "field",
      "value",
      "operator",
      "combinator",
      "not",
      "valueSource"
    ]);
  } else {
    if (typeof _ == "function") {
      const y = _(e);
      if (typeof y == "boolean") {
        if (y === !1)
          return n === "parameterized" ? { sql: S, params: [] } : n === "parameterized_named" ? { sql: S, params: {} } : n === "mongodb" ? `{${S}}` : n === "jsonlogic" ? !1 : S;
      } else
        c = y;
    }
    const g = {};
    jt(d).forEach((y) => {
      typeof y.validator == "function" && (g[y.name] = y.validator);
    });
    const p = (y) => {
      let R, h;
      if (y.id && (R = c[y.id]), d.length) {
        const f = d.filter((E) => E.name === y.field);
        if (f.length) {
          const E = f[0];
          typeof E.validator == "function" && (h = E.validator);
        }
      }
      return [R, h];
    };
    if (n === "sql" || n === "parameterized" || n === "parameterized_named") {
      const y = n === "parameterized", R = n === "parameterized_named", h = [], f = {}, E = {}, C = (O) => (E[O] = (E[O] ?? 0) + 1, `${O}_${E[O]}`), k = (O) => {
        const [Q, T] = p(O);
        if (!dt(O, Q, T) || O.field === N || O.operator === s)
          return "";
        const P = r(O, {
          parseNumbers: m,
          escapeQuotes: n === "sql" && (O.valueSource ?? "value") === "value"
        }), w = Ws(O.operator);
        if ((y || R) && (O.valueSource ?? "value") === "value") {
          if (w.toLowerCase() === "is null" || w.toLowerCase() === "is not null")
            return `${u}${O.field}${u} ${w}`;
          if (w.toLowerCase() === "in" || w.toLowerCase() === "not in")
            if (P) {
              const q = tt(O.value);
              if (y)
                return q.forEach(
                  (V) => h.push(Ge(V, m) ? parseFloat(V) : V)
                ), `${u}${O.field}${u} ${w} (${q.map(() => "?").join(", ")})`;
              const M = [];
              return q.forEach((V) => {
                const B = C(O.field);
                M.push(`${b}${B}`), f[B] = Ge(V, m) ? parseFloat(V) : V;
              }), `${u}${O.field}${u} ${w} (${M.join(", ")})`;
            } else
              return "";
          else if (w.toLowerCase() === "between" || w.toLowerCase() === "not between")
            if (P) {
              const q = tt(O.value), [M, V] = q.slice(0, 2).map((X) => Ge(X, m) ? parseFloat(X) : X);
              if (y)
                return h.push(M), h.push(V), `${u}${O.field}${u} ${w} ? and ?`;
              const B = C(O.field), J = C(O.field);
              return f[B] = M, f[J] = V, `${u}${O.field}${u} ${w} ${b}${B} and ${b}${J}`;
            } else
              return "";
          let $ = O.value;
          typeof O.value == "string" && (Ge(O.value, m) ? $ = parseFloat(O.value) : $ = /^'.*'$/g.test(P) ? P.replace(/(^'|'$)/g, "") : P);
          let j = "";
          return y ? h.push($) : (j = C(O.field), f[j] = $), `${u}${O.field}${u} ${w} ${y ? "?" : `${b}${j}`}`.trim();
        } else {
          const $ = w.toLowerCase();
          if (($ === "in" || $ === "not in" || $ === "between" || $ === "not between") && !P)
            return "";
        }
        return `${u}${O.field}${u} ${w} ${P}`.trim();
      }, x = (O, Q) => {
        if (!dt(O, c[O.id ?? ""]))
          return Q ? S : "";
        const T = O.rules.map((P) => typeof P == "string" ? P : "rules" in P ? x(P) : k(P));
        return T.length === 0 ? S : `${O.not ? "NOT " : ""}(${T.filter(Boolean).join("combinator" in O ? ` ${O.combinator} ` : " ")})`;
      };
      return y ? { sql: x(e, !0), params: h } : R ? { sql: x(e, !0), params: f } : x(e, !0);
    } else if (n === "mongodb") {
      const y = (f, E) => {
        if (!dt(f, c[f.id ?? ""]))
          return E ? S : "";
        const C = `"$${f.combinator.toLowerCase()}"`;
        let k = !1;
        const x = f.rules.map((O) => {
          if ("rules" in O) {
            const P = y(O);
            return P ? (k = !0, /^\{.+\}$/.test(P) ? P : `{${P}}`) : "";
          }
          const [Q, T] = p(O);
          return !dt(O, Q, T) || O.field === N || O.operator === s ? "" : (o ?? r)(O, { parseNumbers: m });
        }).filter(Boolean);
        return x.length > 0 ? x.length === 1 && !k ? x[0] : `${C}:[${x.join(",")}]` : S;
      }, R = "combinator" in e ? e : dn(e), h = y(R, !0);
      return /^\{.+\}$/.test(h) ? h : `{${h}}`;
    } else if (n === "cel") {
      const y = (R, h) => {
        if (!dt(R, c[R.id ?? ""]))
          return h ? S : "";
        const f = R.rules.map((k) => {
          if (typeof k == "string")
            return _r[k];
          if ("rules" in k)
            return y(k);
          const [x, O] = p(k);
          return !dt(k, x, O) || k.field === N || k.operator === s ? "" : (o ?? r)(k, {
            parseNumbers: m,
            escapeQuotes: (k.valueSource ?? "value") === "value"
          });
        }).filter(Boolean).join(
          "combinator" in R ? ` ${_r[R.combinator]} ` : " "
        ), [E, C] = R.not || !h ? [`${R.not ? "!" : ""}(`, ")"] : ["", ""];
        return f ? `${E}${f}${C}` : S;
      };
      return y(e, !0);
    } else if (n === "spel") {
      const y = (R, h) => {
        if (!dt(R, c[R.id ?? ""]))
          return h ? S : "";
        const f = R.rules.map((k) => {
          if (typeof k == "string")
            return k;
          if ("rules" in k)
            return y(k);
          const [x, O] = p(k);
          return !dt(k, x, O) || k.field === N || k.operator === s ? "" : (o ?? r)(k, {
            parseNumbers: m,
            escapeQuotes: (k.valueSource ?? "value") === "value"
          });
        }).filter(Boolean).join("combinator" in R ? ` ${R.combinator} ` : " "), [E, C] = R.not || !h ? [`${R.not ? "!" : ""}(`, ")"] : ["", ""];
        return f ? `${E}${f}${C}` : S;
      };
      return y(e, !0);
    } else if (n === "jsonlogic") {
      const y = "combinator" in e ? e : dn(e), R = (h) => {
        if (!dt(h, c[h.id ?? ""]))
          return !1;
        const f = h.rules.map((C) => {
          if ("rules" in C)
            return R(C);
          const [k, x] = p(C);
          return !dt(C, k, x) || C.field === N || C.operator === s ? !1 : (o ?? r)(C, { parseNumbers: m });
        }).filter(Boolean);
        if (f.length === 0)
          return !1;
        const E = f.length === 1 ? f[0] : {
          [h.combinator]: f
        };
        return h.not ? { "!": E } : E;
      };
      return R(y);
    } else
      return "";
  }
}
const Us = {
  default: qn,
  mongodb: yn,
  cel: pn,
  spel: mn
}, Rn = (e) => (t, n, r, o) => Us[e](
  { field: t, operator: n, value: r, valueSource: o },
  { parseNumbers: !1 }
), U1 = Rn("default"), H1 = Rn("mongodb"), Q1 = Rn("cel"), q1 = Rn("spel"), J1 = pn, Y1 = yn, z1 = mn, Jt = globalThis.crypto;
let mt = () => "00-0-4-2-000".replace(
  /[^-]/g,
  (e) => ((Math.random() + ~~e) * 65536 >> e).toString(16).padStart(4, "0")
);
if (Jt) {
  if (typeof Jt.randomUUID == "function")
    mt = () => Jt.randomUUID();
  else if (typeof Jt.getRandomValues == "function") {
    const e = [
      `${"".padEnd(8, "x")}`,
      `${"".padEnd(4, "x")}`,
      `${"4".padEnd(4, "x")}`,
      `${"y".padEnd(4, "x")}`,
      `${"".padEnd(12, "x")}`
    ].join("-"), t = ["8", "9", "a", "b"], n = /[xy]/g, r = new Uint32Array(32);
    mt = () => {
      Jt.getRandomValues(r);
      let o = -1;
      return e.replaceAll(n, (u) => (o++, u === "y" ? t[r[o] % 4] : (r[o] % 16).toString(16)));
    };
  }
}
const rs = (...e) => {
  const t = (n) => De(e.filter(Boolean).map((r) => De(r[n])));
  return {
    queryBuilder: t("queryBuilder"),
    ruleGroup: t("ruleGroup"),
    header: t("header"),
    body: t("body"),
    combinators: t("combinators"),
    addRule: t("addRule"),
    addGroup: t("addGroup"),
    cloneRule: t("cloneRule"),
    cloneGroup: t("cloneGroup"),
    removeGroup: t("removeGroup"),
    rule: t("rule"),
    fields: t("fields"),
    operators: t("operators"),
    value: t("value"),
    removeRule: t("removeRule"),
    notToggle: t("notToggle"),
    dragHandle: t("dragHandle"),
    lockRule: t("lockRule"),
    lockGroup: t("lockGroup"),
    valueSource: t("valueSource")
  };
}, X1 = ({
  key: e,
  controlClassnames: t,
  controlElements: n
}) => (r) => {
  const o = Hr(un), u = We(
    () => t ? {
      controlClassnames: rs(
        o.controlClassnames,
        r.controlClassnames,
        t
      )
    } : {},
    [r.controlClassnames, o.controlClassnames]
  ), _ = We(
    () => ({
      ...o,
      ...u,
      controlElements: {
        ...o.controlElements,
        ...n,
        ...r.controlElements
      }
    }),
    [u, r.controlElements, o]
  );
  return /* @__PURE__ */ de(un.Provider, { value: _, children: r.children }, e);
}, et = (e) => Object.keys(e), Hs = (e, t) => e === !1 ? !1 : e ? !0 : t !== !1, Qs = (e, t) => e ? !0 : e === !1 ? !1 : !!t, qs = (e, t, n) => e ? Hs(t, n) : Qs(t, n), Fn = (e, t, n) => We(() => qs(e, t, n), [n, e, t]), Js = (e) => {
  const t = Hr(un), n = Fn(
    !0,
    e.enableMountQueryChange,
    t.enableMountQueryChange
  ), r = Fn(!1, e.enableDragAndDrop, t.enableDragAndDrop) && t.enableDragAndDrop !== !1, o = Fn(!1, e.debugMode, t.debugMode), u = We(
    () => rs(
      Gs,
      t.controlClassnames,
      e.controlClassnames
    ),
    [t.controlClassnames, e.controlClassnames]
  ), _ = We(
    () => ({
      ...L1,
      ...t.controlElements,
      ...e.controlElements
    }),
    [e.controlElements, t.controlElements]
  ), d = We(() => {
    const v = {};
    return et(e.translations).forEach((p) => {
      const y = t.translations;
      v[p] = {
        ...Hn[p],
        ...y,
        ...e.translations[p]
      };
    }), { ...Hn, ...v };
  }, [t.translations, e.translations]), {
    controlClassnames: c,
    controlElements: S,
    debugMode: b,
    enableDragAndDrop: m,
    enableMountQueryChange: N,
    translations: s,
    ...g
  } = t;
  return {
    controlClassnames: u,
    controlElements: _,
    debugMode: o,
    enableDragAndDrop: r,
    enableMountQueryChange: n,
    translations: d,
    ...g
  };
}, Ys = ({
  handleOnChange: e,
  inputType: t,
  operator: n,
  value: r
}) => {
  Vt(() => {
    t === "number" && !["between", "notBetween", "in", "notIn"].includes(n) && (typeof r == "string" && r.includes(",") || Array.isArray(r)) && e(tt(r)[0] ?? "");
  }, [e, t, n, r]);
};
var zs = function() {
  var e = function(F, W, Y, te) {
    for (Y = Y || {}, te = F.length; te--; Y[F[te]] = W)
      ;
    return Y;
  }, t = [1, 27], n = [1, 31], r = [1, 32], o = [1, 28], u = [1, 29], _ = [1, 30], d = [1, 33], c = [1, 34], S = [1, 18], b = [1, 26], m = [1, 12], N = [1, 13], s = [1, 19], g = [1, 20], v = [1, 40], p = [1, 39], y = [1, 41], R = [1, 42], h = [1, 43], f = [1, 36], E = [1, 37], C = [1, 38], k = [5, 37, 43, 45, 49, 50, 53, 54, 55, 56, 60, 61, 62, 63], x = [1, 44], O = [1, 45], Q = [1, 46], T = [5, 23, 24, 25, 26, 27, 28, 31, 37, 40, 43, 44, 45, 46, 49, 50, 53, 54, 55, 56, 60, 61, 62, 63], P = [7, 9, 10, 12, 13, 14, 16, 18, 21, 35, 40, 41, 44, 46], w = [2, 36], $ = [1, 85], j = [43, 45, 50], q = [5, 37, 43, 45, 49, 50, 53, 61, 62, 63], M = [5, 37, 43, 45, 49, 50, 53, 54, 55, 56, 61, 62, 63], V = [2, 37], B = [49, 50], J = {
    trace: function() {
    },
    yy: {},
    symbols_: { error: 2, main: 3, expr: 4, EOF: 5, string_literal: 6, STRING_LIT: 7, bytes_literal: 8, b: 9, B: 10, number_literal: 11, INT_LIT: 12, UINT_LIT: 13, FLOAT_LIT: 14, boolean_literal: 15, BOOL_LIT: 16, null_literal: 17, NULL_LIT: 18, literal: 19, ident: 20, IDENT: 21, relop: 22, "==": 23, ">=": 24, ">": 25, "<=": 26, "<": 27, "!=": 28, relation: 29, member: 30, in: 31, list: 32, map: 33, negation: 34, "!": 35, negative: 36, "-": 37, unary: 38, primary: 39, DOT: 40, "(": 41, expr_list: 42, ")": 43, "[": 44, "]": 45, "{": 46, field_inits: 47, trailing_comma: 48, "}": 49, ",": 50, map_inits: 51, math_operation: 52, "+": 53, "*": 54, "/": 55, "%": 56, conditional_expr: 57, conditional_and: 58, conditional_or: 59, "?": 60, ":": 61, "&&": 62, "||": 63, $accept: 0, $end: 1 },
    terminals_: { 2: "error", 5: "EOF", 7: "STRING_LIT", 9: "b", 10: "B", 12: "INT_LIT", 13: "UINT_LIT", 14: "FLOAT_LIT", 16: "BOOL_LIT", 18: "NULL_LIT", 21: "IDENT", 23: "==", 24: ">=", 25: ">", 26: "<=", 27: "<", 28: "!=", 31: "in", 35: "!", 37: "-", 40: "DOT", 41: "(", 43: ")", 44: "[", 45: "]", 46: "{", 49: "}", 50: ",", 53: "+", 54: "*", 55: "/", 56: "%", 60: "?", 61: ":", 62: "&&", 63: "||" },
    productions_: [0, [3, 2], [6, 1], [8, 2], [8, 2], [11, 1], [11, 1], [11, 1], [15, 1], [17, 1], [19, 1], [19, 1], [19, 1], [19, 1], [19, 1], [20, 1], [22, 1], [22, 1], [22, 1], [22, 1], [22, 1], [22, 1], [29, 3], [29, 3], [29, 3], [34, 1], [34, 2], [36, 1], [36, 2], [38, 2], [30, 1], [30, 1], [30, 3], [30, 6], [30, 4], [30, 5], [48, 0], [48, 1], [39, 1], [39, 2], [39, 5], [39, 6], [39, 3], [39, 1], [39, 1], [39, 1], [32, 4], [33, 4], [52, 3], [52, 3], [52, 3], [52, 3], [52, 3], [4, 1], [4, 1], [4, 1], [4, 1], [4, 1], [4, 1], [57, 5], [58, 3], [59, 3], [42, 1], [42, 3], [47, 3], [47, 5], [51, 3], [51, 5]],
    performAction: function(W, Y, te, pe, ee, I, ce) {
      var A = I.length - 1;
      switch (ee) {
        case 1:
          return { nodeType: "Main", value: I[A - 1] };
        case 2:
          this.$ = { type: "StringLiteral", value: I[A] };
          break;
        case 3:
        case 4:
          this.$ = { type: "BytesLiteral", value: I[A] };
          break;
        case 5:
          this.$ = { type: "IntegerLiteral", value: parseInt(I[A], /x/.test(I[A]) ? 16 : 10) };
          break;
        case 6:
          this.$ = { type: "UnsignedIntegerLiteral", value: parseInt(I[A].replace(/u$/i, ""), /^0x/.test(I[A]) ? 16 : 10) };
          break;
        case 7:
          this.$ = { type: "FloatLiteral", value: parseFloat(I[A]) };
          break;
        case 8:
          this.$ = { type: "BooleanLiteral", value: I[A] === "true" };
          break;
        case 9:
          this.$ = { type: "NullLiteral", value: null };
          break;
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
        case 38:
        case 43:
        case 44:
        case 45:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
        case 58:
          this.$ = I[A];
          break;
        case 15:
          this.$ = { type: "Identifier", value: I[A] };
          break;
        case 22:
        case 23:
        case 24:
          this.$ = { type: "Relation", left: I[A - 2], operator: I[A - 1], right: I[A] };
          break;
        case 25:
        case 27:
          this.$ = 1;
          break;
        case 26:
        case 28:
          this.$ = this.$ += 1;
          break;
        case 29:
          this.$ = { type: "Negation", negations: I[A - 1], value: I[A] };
          break;
        case 30:
        case 31:
          this.$ = I[A];
          break;
        case 32:
          this.$ = { type: "Member", left: I[A - 2], right: I[A] };
          break;
        case 33:
          this.$ = { type: "Member", left: I[A - 5], right: I[A - 3], list: I[A - 1] };
          break;
        case 34:
          this.$ = { type: "DynamicPropertyAccessor", left: I[A - 3], right: I[A - 1] };
          break;
        case 35:
          this.$ = { type: "FieldsObject", left: I[A - 4], list: I[A - 2], trailingComma: I[A - 1] };
          break;
        case 36:
          this.$ = !1;
          break;
        case 37:
          this.$ = !0;
          break;
        case 39:
          this.$ = { type: "Property", value: I[A] };
          break;
        case 40:
          this.$ = { type: "FunctionCall", name: I[A - 4], args: I[A - 2], trailingComma: I[A - 1] };
          break;
        case 41:
          this.$ = { type: "Property", value: I[A - 4], args: I[A - 2], trailingComma: I[A - 1] };
          break;
        case 42:
          this.$ = { type: "ExpressionGroup", value: I[A - 1] };
          break;
        case 46:
          this.$ = { type: "List", value: I[A - 2], trailingComma: I[A - 1] };
          break;
        case 47:
          this.$ = { type: "Map", value: I[A - 2], trailingComma: I[A - 1] };
          break;
        case 48:
          this.$ = { type: "Addition", left: I[A - 2], right: I[A] };
          break;
        case 49:
          this.$ = { type: "Subtraction", left: I[A - 2], right: I[A] };
          break;
        case 50:
          this.$ = { type: "Multiplication", left: I[A - 2], right: I[A] };
          break;
        case 51:
          this.$ = { type: "Division", left: I[A - 2], right: I[A] };
          break;
        case 52:
          this.$ = { type: "Modulo", left: I[A - 2], right: I[A] };
          break;
        case 59:
          this.$ = { type: "ConditionalExpr", condition: I[A - 4], valueIfTrue: I[A - 2], valueIfFalse: I[A] };
          break;
        case 60:
          this.$ = { type: "ConditionalAnd", left: I[A - 2], right: I[A] };
          break;
        case 61:
          this.$ = { type: "ConditionalOr", left: I[A - 2], right: I[A] };
          break;
        case 62:
          this.$ = { type: "ExpressionList", value: [I[A]] };
          break;
        case 63:
          this.$ = I[A - 2], this.$.value.push(I[A]);
          break;
        case 64:
          this.$ = { type: "FieldInits", value: [{ type: "FieldInit", left: I[A - 2], right: I[A] }] };
          break;
        case 65:
          this.$ = I[A - 4], this.$.value.push({ type: "FieldInit", left: I[A - 2], right: I[A] });
          break;
        case 66:
          this.$ = { type: "MapInits", value: [{ type: "MapInit", left: I[A - 2], right: I[A] }] };
          break;
        case 67:
          this.$ = I[A - 4], this.$.value.push({ type: "MapInit", left: I[A - 2], right: I[A] });
          break;
      }
    },
    table: [{ 3: 1, 4: 2, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 1: [3] }, { 5: [1, 35], 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 62: E, 63: C }, e(k, [2, 53], { 22: 47, 23: [1, 49], 24: [1, 50], 25: [1, 51], 26: [1, 52], 27: [1, 53], 28: [1, 54], 31: [1, 48], 40: x, 44: O, 46: Q }), e(k, [2, 54]), e(k, [2, 55]), e(k, [2, 56]), e(k, [2, 57]), e(k, [2, 58]), e(T, [2, 30]), e(T, [2, 31]), e(T, [2, 38], { 41: [1, 55] }), { 20: 56, 21: S }, { 4: 57, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, e(T, [2, 43]), e(T, [2, 44]), e(T, [2, 45]), { 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 32: 14, 33: 15, 35: [1, 59], 39: 58, 40: m, 41: N, 44: s, 46: g }, e([5, 23, 24, 25, 26, 27, 28, 31, 37, 40, 41, 43, 44, 45, 46, 49, 50, 53, 54, 55, 56, 60, 61, 62, 63], [2, 15]), { 4: 61, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 42: 60, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 63, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 51: 62, 52: 8, 57: 4, 58: 5, 59: 6 }, e(T, [2, 10]), e(T, [2, 11]), e(T, [2, 12]), e(T, [2, 13]), e(T, [2, 14]), e(P, [2, 25]), e(T, [2, 2]), e(T, [2, 5]), e(T, [2, 6]), e(T, [2, 7]), { 6: 64, 7: t }, { 6: 65, 7: t }, e(T, [2, 8]), e(T, [2, 9]), { 1: [2, 1] }, { 4: 66, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 67, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 68, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 69, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 70, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 71, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 72, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 73, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 20: 74, 21: S }, { 4: 75, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 20: 77, 21: S, 47: 76 }, { 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 30: 78, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g }, { 32: 79, 33: 80, 44: s, 46: g }, e(P, [2, 16]), e(P, [2, 17]), e(P, [2, 18]), e(P, [2, 19]), e(P, [2, 20]), e(P, [2, 21]), { 4: 61, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 42: 81, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, e(T, [2, 39], { 41: [1, 82] }), { 37: v, 43: [1, 83], 53: p, 54: y, 55: R, 56: h, 60: f, 62: E, 63: C }, e(T, [2, 29]), e(P, [2, 26]), { 45: w, 48: 84, 50: $ }, e(j, [2, 62], { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 62: E, 63: C }), { 48: 86, 49: w, 50: [1, 87] }, { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 61: [1, 88], 62: E, 63: C }, e(T, [2, 3]), e(T, [2, 4]), { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 61: [1, 89], 62: E, 63: C }, e([5, 43, 45, 49, 50, 61, 62, 63], [2, 60], { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f }), e([5, 43, 45, 49, 50, 61, 63], [2, 61], { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 62: E }), e(q, [2, 48], { 54: y, 55: R, 56: h, 60: f }), e(q, [2, 49], { 54: y, 55: R, 56: h, 60: f }), e(M, [2, 50], { 60: f }), e(M, [2, 51], { 60: f }), e(M, [2, 52], { 60: f }), e(T, [2, 32], { 41: [1, 90] }), { 37: v, 45: [1, 91], 53: p, 54: y, 55: R, 56: h, 60: f, 62: E, 63: C }, { 48: 92, 49: w, 50: [1, 93] }, { 61: [1, 94] }, e(k, [2, 22], { 40: x, 44: O, 46: Q }), e(k, [2, 23]), e(k, [2, 24]), { 43: w, 48: 95, 50: $ }, { 4: 61, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 42: 96, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, e(T, [2, 42]), { 45: [1, 97] }, e([43, 45], V, { 30: 3, 57: 4, 58: 5, 59: 6, 29: 7, 52: 8, 39: 9, 38: 10, 20: 11, 32: 14, 33: 15, 19: 16, 34: 17, 6: 21, 11: 22, 8: 23, 15: 24, 17: 25, 4: 98, 7: t, 9: n, 10: r, 12: o, 13: u, 14: _, 16: d, 18: c, 21: S, 35: b, 40: m, 41: N, 44: s, 46: g }), { 49: [1, 99] }, { 4: 100, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 49: V, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 101, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 102, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 61, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 42: 103, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, e(T, [2, 34]), { 49: [1, 104] }, { 20: 105, 21: S, 49: V }, { 4: 106, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 43: [1, 107] }, { 43: w, 48: 108, 50: $ }, e(T, [2, 46]), e(j, [2, 63], { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 62: E, 63: C }), e(T, [2, 47]), { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 61: [1, 109], 62: E, 63: C }, e(B, [2, 66], { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 62: E, 63: C }), e(k, [2, 59]), { 43: [1, 110], 50: [1, 111] }, e(T, [2, 35]), { 61: [1, 112] }, e(B, [2, 64], { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 62: E, 63: C }), e(T, [2, 40]), { 43: [1, 113] }, { 4: 114, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, e(T, [2, 33]), { 4: 98, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, { 4: 115, 6: 21, 7: t, 8: 23, 9: n, 10: r, 11: 22, 12: o, 13: u, 14: _, 15: 24, 16: d, 17: 25, 18: c, 19: 16, 20: 11, 21: S, 29: 7, 30: 3, 32: 14, 33: 15, 34: 17, 35: b, 38: 10, 39: 9, 40: m, 41: N, 44: s, 46: g, 52: 8, 57: 4, 58: 5, 59: 6 }, e(T, [2, 41]), e(B, [2, 67], { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 62: E, 63: C }), e(B, [2, 65], { 37: v, 53: p, 54: y, 55: R, 56: h, 60: f, 62: E, 63: C })],
    defaultActions: { 35: [2, 1] },
    parseError: function(W, Y) {
      if (Y.recoverable)
        this.trace(W);
      else {
        var te = new Error(W);
        throw te.hash = Y, te;
      }
    },
    parse: function(W) {
      var Y = this, te = [0], pe = [null], ee = [], I = this.table, ce = "", A = 0, z = 0, ue = 2, le = 1, ve = ee.slice.call(arguments, 1), se = Object.create(this.lexer), he = { yy: {} };
      for (var Ue in this.yy)
        Object.prototype.hasOwnProperty.call(this.yy, Ue) && (he.yy[Ue] = this.yy[Ue]);
      se.setInput(W, he.yy), he.yy.lexer = se, he.yy.parser = this, typeof se.yylloc > "u" && (se.yylloc = {});
      var Pe = se.yylloc;
      ee.push(Pe);
      var je = se.options && se.options.ranges;
      typeof he.yy.parseError == "function" ? this.parseError = he.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;
      for (var ge = function() {
        var K;
        return K = se.lex() || le, typeof K != "number" && (K = Y.symbols_[K] || K), K;
      }, Ee, Le, fe, Te, Ne = {}, Oe, $e, oe, re; ; ) {
        if (Le = te[te.length - 1], this.defaultActions[Le] ? fe = this.defaultActions[Le] : ((Ee === null || typeof Ee > "u") && (Ee = ge()), fe = I[Le] && I[Le][Ee]), typeof fe > "u" || !fe.length || !fe[0]) {
          var U = "";
          re = [];
          for (Oe in I[Le])
            this.terminals_[Oe] && Oe > ue && re.push("'" + this.terminals_[Oe] + "'");
          se.showPosition ? U = "Parse error on line " + (A + 1) + `:
` + se.showPosition() + `
Expecting ` + re.join(", ") + ", got '" + (this.terminals_[Ee] || Ee) + "'" : U = "Parse error on line " + (A + 1) + ": Unexpected " + (Ee == le ? "end of input" : "'" + (this.terminals_[Ee] || Ee) + "'"), this.parseError(U, {
            text: se.match,
            token: this.terminals_[Ee] || Ee,
            line: se.yylineno,
            loc: Pe,
            expected: re
          });
        }
        if (fe[0] instanceof Array && fe.length > 1)
          throw new Error("Parse Error: multiple actions possible at state: " + Le + ", token: " + Ee);
        switch (fe[0]) {
          case 1:
            te.push(Ee), pe.push(se.yytext), ee.push(se.yylloc), te.push(fe[1]), Ee = null, z = se.yyleng, ce = se.yytext, A = se.yylineno, Pe = se.yylloc;
            break;
          case 2:
            if ($e = this.productions_[fe[1]][1], Ne.$ = pe[pe.length - $e], Ne._$ = {
              first_line: ee[ee.length - ($e || 1)].first_line,
              last_line: ee[ee.length - 1].last_line,
              first_column: ee[ee.length - ($e || 1)].first_column,
              last_column: ee[ee.length - 1].last_column
            }, je && (Ne._$.range = [
              ee[ee.length - ($e || 1)].range[0],
              ee[ee.length - 1].range[1]
            ]), Te = this.performAction.apply(Ne, [
              ce,
              z,
              A,
              he.yy,
              fe[1],
              pe,
              ee
            ].concat(ve)), typeof Te < "u")
              return Te;
            $e && (te = te.slice(0, -1 * $e * 2), pe = pe.slice(0, -1 * $e), ee = ee.slice(0, -1 * $e)), te.push(this.productions_[fe[1]][0]), pe.push(Ne.$), ee.push(Ne._$), oe = I[te[te.length - 2]][te[te.length - 1]], te.push(oe);
            break;
          case 3:
            return !0;
        }
      }
      return !0;
    }
  }, X = function() {
    var F = {
      EOF: 1,
      parseError: function(Y, te) {
        if (this.yy.parser)
          this.yy.parser.parseError(Y, te);
        else
          throw new Error(Y);
      },
      setInput: function(W, Y) {
        return this.yy = Y || this.yy || {}, this._input = W, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
          first_line: 1,
          first_column: 0,
          last_line: 1,
          last_column: 0
        }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
      },
      input: function() {
        var W = this._input[0];
        this.yytext += W, this.yyleng++, this.offset++, this.match += W, this.matched += W;
        var Y = W.match(/(?:\r\n?|\n).*/g);
        return Y ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), W;
      },
      unput: function(W) {
        var Y = W.length, te = W.split(/(?:\r\n?|\n)/g);
        this._input = W + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - Y), this.offset -= Y;
        var pe = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), te.length - 1 && (this.yylineno -= te.length - 1);
        var ee = this.yylloc.range;
        return this.yylloc = {
          first_line: this.yylloc.first_line,
          last_line: this.yylineno + 1,
          first_column: this.yylloc.first_column,
          last_column: te ? (te.length === pe.length ? this.yylloc.first_column : 0) + pe[pe.length - te.length].length - te[0].length : this.yylloc.first_column - Y
        }, this.options.ranges && (this.yylloc.range = [ee[0], ee[0] + this.yyleng - Y]), this.yyleng = this.yytext.length, this;
      },
      more: function() {
        return this._more = !0, this;
      },
      reject: function() {
        if (this.options.backtrack_lexer)
          this._backtrack = !0;
        else
          return this.parseError("Lexical error on line " + (this.yylineno + 1) + `. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).
` + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        return this;
      },
      less: function(W) {
        this.unput(this.match.slice(W));
      },
      pastInput: function() {
        var W = this.matched.substr(0, this.matched.length - this.match.length);
        return (W.length > 20 ? "..." : "") + W.substr(-20).replace(/\n/g, "");
      },
      upcomingInput: function() {
        var W = this.match;
        return W.length < 20 && (W += this._input.substr(0, 20 - W.length)), (W.substr(0, 20) + (W.length > 20 ? "..." : "")).replace(/\n/g, "");
      },
      showPosition: function() {
        var W = this.pastInput(), Y = new Array(W.length + 1).join("-");
        return W + this.upcomingInput() + `
` + Y + "^";
      },
      test_match: function(W, Y) {
        var te, pe, ee;
        if (this.options.backtrack_lexer && (ee = {
          yylineno: this.yylineno,
          yylloc: {
            first_line: this.yylloc.first_line,
            last_line: this.last_line,
            first_column: this.yylloc.first_column,
            last_column: this.yylloc.last_column
          },
          yytext: this.yytext,
          match: this.match,
          matches: this.matches,
          matched: this.matched,
          yyleng: this.yyleng,
          offset: this.offset,
          _more: this._more,
          _input: this._input,
          yy: this.yy,
          conditionStack: this.conditionStack.slice(0),
          done: this.done
        }, this.options.ranges && (ee.yylloc.range = this.yylloc.range.slice(0))), pe = W[0].match(/(?:\r\n?|\n).*/g), pe && (this.yylineno += pe.length), this.yylloc = {
          first_line: this.yylloc.last_line,
          last_line: this.yylineno + 1,
          first_column: this.yylloc.last_column,
          last_column: pe ? pe[pe.length - 1].length - pe[pe.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + W[0].length
        }, this.yytext += W[0], this.match += W[0], this.matches = W, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(W[0].length), this.matched += W[0], te = this.performAction.call(this, this.yy, this, Y, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), te)
          return te;
        if (this._backtrack) {
          for (var I in ee)
            this[I] = ee[I];
          return !1;
        }
        return !1;
      },
      next: function() {
        if (this.done)
          return this.EOF;
        this._input || (this.done = !0);
        var W, Y, te, pe;
        this._more || (this.yytext = "", this.match = "");
        for (var ee = this._currentRules(), I = 0; I < ee.length; I++)
          if (te = this._input.match(this.rules[ee[I]]), te && (!Y || te[0].length > Y[0].length)) {
            if (Y = te, pe = I, this.options.backtrack_lexer) {
              if (W = this.test_match(te, ee[I]), W !== !1)
                return W;
              if (this._backtrack) {
                Y = !1;
                continue;
              } else
                return !1;
            } else if (!this.options.flex)
              break;
          }
        return Y ? (W = this.test_match(Y, ee[pe]), W !== !1 ? W : !1) : this._input === "" ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + `. Unrecognized text.
` + this.showPosition(), {
          text: "",
          token: null,
          line: this.yylineno
        });
      },
      lex: function() {
        var Y = this.next();
        return Y || this.lex();
      },
      begin: function(Y) {
        this.conditionStack.push(Y);
      },
      popState: function() {
        var Y = this.conditionStack.length - 1;
        return Y > 0 ? this.conditionStack.pop() : this.conditionStack[0];
      },
      _currentRules: function() {
        return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
      },
      topState: function(Y) {
        return Y = this.conditionStack.length - 1 - Math.abs(Y || 0), Y >= 0 ? this.conditionStack[Y] : "INITIAL";
      },
      pushState: function(Y) {
        this.begin(Y);
      },
      stateStackSize: function() {
        return this.conditionStack.length;
      },
      options: { flex: !0 },
      performAction: function(Y, te, pe, ee) {
        switch (pe) {
          case 0:
            break;
          case 1:
            break;
          case 2:
            return 31;
          case 3:
            return "as";
          case 4:
            return "break";
          case 5:
            return "const";
          case 6:
            return "continue";
          case 7:
            return "else";
          case 8:
            return "for";
          case 9:
            return "function";
          case 10:
            return "if";
          case 11:
            return "import";
          case 12:
            return "let";
          case 13:
            return "loop";
          case 14:
            return "package";
          case 15:
            return "namespace";
          case 16:
            return "return";
          case 17:
            return "var";
          case 18:
            return "void";
          case 19:
            return "while";
          case 20:
            return 18;
          case 21:
            return 16;
          case 22:
            return 16;
          case 23:
            return 40;
          case 24:
            return 60;
          case 25:
            return 61;
          case 26:
            return 50;
          case 27:
            return 44;
          case 28:
            return 45;
          case 29:
            return 41;
          case 30:
            return 43;
          case 31:
            return 28;
          case 32:
            return 35;
          case 33:
            return 53;
          case 34:
            return 37;
          case 35:
            return 54;
          case 36:
            return 55;
          case 37:
            return 56;
          case 38:
            return 23;
          case 39:
            return 24;
          case 40:
            return 25;
          case 41:
            return 26;
          case 42:
            return 27;
          case 43:
            return 46;
          case 44:
            return 49;
          case 45:
            return 62;
          case 46:
            return 63;
          case 47:
            return 21;
          case 48:
            return 7;
          case 49:
            return 7;
          case 50:
            return 7;
          case 51:
            return 7;
          case 52:
            return 12;
          case 53:
            return 13;
          case 54:
            return 14;
          case 55:
            return 5;
          case 56:
            return "INVALID";
          case 57:
            console.log(te.yytext);
            break;
        }
      },
      rules: [/^(?:[/][/]\s.*\n)/, /^(?:\s+)/, /^(?:in)/, /^(?:as)/, /^(?:break)/, /^(?:const)/, /^(?:continue)/, /^(?:else)/, /^(?:for)/, /^(?:function)/, /^(?:if)/, /^(?:import)/, /^(?:let)/, /^(?:loop)/, /^(?:package)/, /^(?:namespace)/, /^(?:return)/, /^(?:var)/, /^(?:void)/, /^(?:while)/, /^(?:null)/, /^(?:true)/, /^(?:false)/, /^(?:\.)/, /^(?:\?)/, /^(?::)/, /^(?:,)/, /^(?:\[)/, /^(?:\])/, /^(?:\()/, /^(?:\))/, /^(?:!=)/, /^(?:!)/, /^(?:\+)/, /^(?:-)/, /^(?:\*)/, /^(?:\/)/, /^(?:%)/, /^(?:==)/, /^(?:>=)/, /^(?:>)/, /^(?:<=)/, /^(?:<)/, /^(?:\{)/, /^(?:\})/, /^(?:&&)/, /^(?:\|\|)/, /^(?:[_a-zA-Z][_a-zA-Z0-9]*)/, /^(?:[rR]?['][']['](\.|[^'])*['][']['])/, /^(?:[rR]?["]["]["](\.|[^"])*["]["]["])/, /^(?:[rR]?['](\.|[^'\n\r])*['])/, /^(?:[rR]?["](\.|[^"\n\r])*["])/, /^(?:[-]?([0-9]+|0x[0-9a-fA-F]+))/, /^(?:([0-9]+|0x[0-9a-fA-F]+)[uU])/, /^(?:[-]?[0-9]+(\.[0-9]+)?([eE][+-]?[0-9]+(\.[0-9]+)?)?)/, /^(?:$)/, /^(?:.)/, /^(?:.)/],
      conditions: { INITIAL: { rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57], inclusive: !0 } }
    };
    return F;
  }();
  J.lexer = X;
  function be() {
    this.yy = {};
  }
  return be.prototype = J, J.Parser = be, new be();
}();
const Wn = (e) => e.type === "ExpressionGroup", ss = (e) => e.type === "ConditionalAnd", os = (e) => e.type === "ConditionalOr", Kn = (e) => e.type === "StringLiteral", Yt = (e) => Xs(e) || Kn(e) || e.type === "BooleanLiteral" || e.type === "NullLiteral" || e.type === "BytesLiteral", Xs = (e) => e.type === "FloatLiteral" || e.type === "IntegerLiteral" || e.type === "UnsignedIntegerLiteral", Ks = (e) => e.type === "Relation", Zs = (e) => e.type === "List", e1 = (e) => e.type === "Map", kt = (e) => e.type === "Identifier", t1 = (e) => e.type === "Negation", n1 = (e) => e.type === "Member", Nr = (e) => n1(e) && !!e.left && !!e.right && !!e.list && kt(e.left) && kt(e.right) && (e.right.value === "contains" || e.right.value === "startsWith" || e.right.value === "endsWith") && e.list.value.length === 1 && (Kn(e.list.value[0]) || kt(e.list.value[0]));
function zt(e) {
  return e.type === "StringLiteral" ? e.value.replace(/^((?:'''|"""|'|")?)([\s\S]*?)\1$/gm, "$2") : e.type === "BooleanLiteral" ? e.value : e.type === "NullLiteral" || e.type === "BytesLiteral" ? null : e.value;
}
const r1 = (e) => e === "||" ? "or" : "and", s1 = (e, t) => {
  if (t) {
    if (e === "<")
      return ">";
    if (e === "<=")
      return ">=";
    if (e === ">")
      return "<";
    if (e === ">=")
      return "<=";
  }
  return e === "==" ? "=" : e;
}, Zn = (e) => {
  const t = r1(e.type === "ConditionalAnd" ? "&&" : "||"), { left: n, right: r } = e;
  return ss(n) || os(n) ? [...Zn(n), t, r] : [n, t, r];
}, o1 = (e) => {
  const t = Zn(e), n = [];
  let r = 0;
  for (let o = 0; o < t.length; o += 2)
    if (t[o + 1] === "and") {
      r = o;
      let u = 1;
      for (; t[r + u] === "and"; )
        o += 2, u += 2;
      const _ = t.slice(r, o + 1);
      n.push(_), o -= 2;
    } else
      t[o + 1] === "or" && (o === 0 || o === t.length - 3 ? ((o === 0 || t[o - 1] === "or") && n.push(t[o]), n.push(t[o + 1]), o === t.length - 3 && n.push(t[o + 2])) : (t[o - 1] === "and" || n.push(t[o]), n.push(t[o + 1])));
  return n.length === 1 && Array.isArray(n[0]) ? n[0] : n;
};
function K1(e, t = {}) {
  const { fields: n, independentCombinators: r, listsAsArrays: o } = t, u = !!r, _ = En(n), d = (N, s, g) => _n({
    fieldName: N,
    fieldsFlat: _,
    operator: s,
    subordinateFieldName: g,
    getValueSources: t == null ? void 0 : t.getValueSources
  }), c = {
    rules: [],
    ...u ? {} : { combinator: "and" }
  }, S = (N, s = {}) => {
    const { forwardNegation: g, groupOnlyIfNecessary: v } = s;
    if (t1(N)) {
      const p = N.negations % 2 === 1, y = Wn(N.value) && Nr(N.value.value) ? S(N.value.value, { forwardNegation: p }) : S(N.value, {
        groupOnlyIfNecessary: !0,
        forwardNegation: p
      });
      if (y)
        return !p || p && !("rules" in y) && y.operator.startsWith("doesNot") ? u ? { rules: [y] } : {
          combinator: "and",
          rules: [y]
        } : u ? { rules: [y], not: !0 } : {
          combinator: "and",
          rules: [y],
          not: !0
        };
    } else if (Wn(N)) {
      const p = S(N.value, {
        groupOnlyIfNecessary: !0
      });
      if (p)
        return "rules" in p || v && Wn(N.value) ? p : u ? { rules: [p] } : { combinator: "and", rules: [p] };
    } else if (ss(N) || os(N)) {
      if (u) {
        const E = Zn(N).map((C) => typeof C == "string" ? C : S(C));
        return E.every(Boolean) ? {
          rules: E
        } : null;
      }
      const p = o1(N), y = p[1], h = p.filter((f) => Array.isArray(f) || !!f && typeof f != "string" && "type" in f).map(
        (f) => Array.isArray(f) ? f.filter((E) => !!f && typeof E != "string" && "type" in E) : f
      ).map((f) => Array.isArray(f) ? {
        combinator: "and",
        rules: f.map((E) => S(E)).filter((E) => !!E)
      } : S(f)).filter((f) => !!f);
      if (h.length > 0)
        return { combinator: y, rules: h };
    } else if (Nr(N)) {
      const {
        left: { value: p },
        right: { value: y }
      } = N, R = y === "startsWith" ? "beginsWith" : y, h = g ? `doesNot${R[0].toUpperCase()}${R.slice(1).replace("s", "")}` : R, f = N.list.value[0], E = Kn(f) ? zt(f) : f.value, C = N.list.value[0].type === "Identifier" ? "field" : void 0;
      if (d(p, h, C === "field" ? E : void 0))
        return C ? { field: p, operator: h, value: E, valueSource: C } : { field: p, operator: h, value: E };
    } else if (Ks(N)) {
      let p = null, y, R, h = !1;
      const { left: f, right: E } = N;
      kt(f) ? (p = f.value, kt(E) ? (y = E.value, R = "field") : Yt(E) && (y = zt(E))) : kt(E) && Yt(f) && N.operator !== "in" && (h = !0, p = E.value, y = zt(f));
      let C = s1(N.operator, h);
      if (y === null && (C === "=" || C === "!="))
        C = C === "=" ? "null" : "notNull";
      else if (C === "in" && Zs(E))
        E.value.value.every(Yt) ? y = E.value.value.map(zt) : E.value.value.every(kt) && (R = "field", y = E.value.value.map((k) => k.value)), y && !o && (y = y.map((k) => `${k}`).join(","));
      else if (C === "in" && e1(E)) {
        const k = E.value.value.map((x) => x.left);
        k.every((x) => Yt(x) || kt(x)) && (y = k.map(
          (x) => Yt(x) ? zt(x) : x.value
        )), y && !o && (y = y.map((x) => `${x}`).join(","));
      }
      if (p && d(p, C, R === "field" ? y : void 0) && typeof y < "u")
        return R ? { field: p, operator: C, value: y, valueSource: R } : { field: p, operator: C, value: y };
    }
    return null;
  };
  let b;
  try {
    b = zs.parse(e).value;
  } catch {
    return c;
  }
  const m = S(b);
  return m ? "rules" in m ? m : { rules: [m], ...u ? {} : { combinator: "and" } } : c;
}
const i1 = (e) => Ae(e) && "var" in e, pt = (e) => i1(e) && typeof e.var == "string", Cr = (e) => Ae(e) && "==" in e, Ar = (e) => Ae(e) && "===" in e, Or = (e) => Ae(e) && "!=" in e, kr = (e) => Ae(e) && "!==" in e, a1 = (e) => Ae(e) && "!" in e, l1 = (e) => Ae(e) && "!!" in e, c1 = (e) => Ae(e) && "or" in e, u1 = (e) => Ae(e) && "and" in e, f1 = (e) => Ae(e) && ">" in e, h1 = (e) => Ae(e) && ">=" in e, d1 = (e) => Ae(e) && "<" in e && e["<"].length === 2, p1 = (e) => Ae(e) && "<=" in e && e["<="].length === 2, y1 = (e) => Ae(e) && "in" in e && Array.isArray(e.in[1]), Ir = (e) => Ae(e) && "in" in e && !Array.isArray(e.in[1]), Lr = (e) => Ae(e) && "<" in e && Array.isArray(e["<"]) && e["<"].length === 3, m1 = (e) => Ae(e) && "<=" in e && Array.isArray(e["<="]) && e["<="].length === 3, Tr = (e) => Ae(e) && "startsWith" in e, wr = (e) => Ae(e) && "endsWith" in e, xr = { combinator: "and", rules: [] };
function Z1(e, t = {}) {
  const n = En(t.fields), { getValueSources: r, listsAsArrays: o, jsonLogicOperations: u } = t, _ = (m, N, s) => _n({
    fieldName: m,
    fieldsFlat: n,
    operator: N,
    subordinateFieldName: s,
    getValueSources: r
  });
  function d(m, N) {
    if (N && !Ae(m))
      return !1;
    const s = Object.keys(m)[0], g = m[s];
    if (u1(m))
      return {
        combinator: "and",
        rules: m.and.map((f) => d(f)).filter(Boolean)
      };
    if (c1(m))
      return {
        combinator: "or",
        rules: m.or.map((f) => d(f)).filter(Boolean)
      };
    if (a1(m)) {
      const f = d(m["!"]);
      if (f) {
        if (!hn(f) && (f.operator === "between" || f.operator === "in" || f.operator === "contains" || f.operator === "beginsWith" || f.operator === "endsWith")) {
          const E = { ...f, operator: Jr[f.operator] };
          return N ? { combinator: "and", rules: [E] } : E;
        } else if (Lr(m["!"]) && hn(f))
          return { ...f, not: !0 };
        return { combinator: "and", rules: [f], not: !0 };
      }
      return !1;
    } else if (l1(m))
      return d(m["!!"]) || !1;
    let v = !1, p = "", y = "=", R = "", h;
    if (u && et(u).includes(s))
      v = u[s](g);
    else if (Cr(m) || Ar(m) || Or(m) || kr(m) || f1(m) || h1(m) || d1(m) || p1(m) || Ir(m) || Tr(m) || wr(m)) {
      const [f, E] = g;
      if (pt(f) && !Ae(E))
        p = f.var, R = E;
      else if (!Ae(f) && pt(E))
        p = E.var, R = f;
      else if (pt(f) && pt(E))
        p = f.var, R = E.var, h = "field";
      else
        return !1;
      Cr(m) || Ar(m) ? y = R === null ? "null" : "=" : Or(m) || kr(m) ? y = R === null ? "notNull" : "!=" : Ir(m) ? y = "contains" : Tr(m) ? y = "beginsWith" : wr(m) ? y = "endsWith" : y = s, _(p, y, h === "field" ? R : void 0) && (v = { field: p, operator: y, value: R, valueSource: h });
    } else if (Lr(m) && pt(m["<"][1])) {
      p = m["<"][1].var;
      const f = [m["<"][0], m["<"][2]];
      if (f.every(pt) || f.every((E) => typeof E == "string") || f.every((E) => typeof E == "number") || f.every((E) => typeof E == "boolean"))
        return d({
          and: [{ ">": [{ var: p }, f[0]] }, { "<": [{ var: p }, f[1]] }]
        }) || !1;
    } else if (m1(m) && pt(m["<="][1])) {
      p = m["<="][1].var, y = "between";
      const f = [m["<="][0], m["<="][2]];
      if (m["<="].every(pt)) {
        const E = f;
        h = "field";
        const C = E.map((k) => k.var).filter((k) => _(p, y, k));
        R = o ? C : C.join(",");
      } else
        (f.every((E) => typeof E == "string") || f.every((E) => typeof E == "number") || f.every((E) => typeof E == "boolean")) && (R = o ? f : f.map((E) => `${E}`).join(","));
      _(p, y) && R.length >= 2 && (v = { field: p, operator: y, value: R, valueSource: h });
    } else if (y1(m) && pt(g[0])) {
      if (p = g[0].var, y = "in", m.in[1].every(pt)) {
        h = "field";
        const f = m.in[1].map((E) => E.var).filter((E) => _(p, y, E));
        R = o ? f : f.join(",");
      } else
        (m.in[1].every((f) => typeof f == "string") || m.in[1].every((f) => typeof f == "number") || m.in[1].every((f) => typeof f == "boolean")) && (R = o ? m.in[1] : m.in[1].map((f) => `${f}`).join(","));
      R.length > 0 && (v = { field: p, operator: y, value: R, valueSource: h });
    }
    return v ? N ? { combinator: "and", rules: [v] } : v : !1;
  }
  let c = e;
  if (typeof e == "string")
    try {
      c = JSON.parse(e);
    } catch {
      return xr;
    }
  const S = d(c, !0), b = S || xr;
  return t.independentCombinators ? vn(b) : b;
}
const Wt = (e) => typeof e == "string" ? e : e.source, b1 = (e) => typeof e == "string" || typeof e == "number" || typeof e == "boolean", g1 = {
  $eq: "=",
  $ne: "!=",
  $gt: ">",
  $gte: ">=",
  $lt: "<",
  $lte: "<="
}, jn = { combinator: "and", rules: [] };
function eo(e, t = {}) {
  const n = !!t.listsAsArrays, r = En(t.fields), o = t.getValueSources, u = (N, s, g) => _n({
    fieldName: N,
    fieldsFlat: r,
    operator: s,
    subordinateFieldName: g,
    getValueSources: o
  });
  function _(N, s, g) {
    let v = "=", p = "";
    if (s === "$eq" || s === "$ne" || s === "$gt" || s === "$gte" || s === "$lt" || s === "$lte") {
      if (s === "$ne" && g === null) {
        if (u(N, "notNull"))
          return { field: N, operator: "notNull", value: null };
      } else if (v = g1[s], u(N, v))
        return { field: N, operator: v, value: g };
    } else if (s === "$regex" && /^[^^].*[^$]$/.test(Wt(g))) {
      if (u(N, "contains"))
        return {
          field: N,
          operator: "contains",
          value: Wt(g)
        };
    } else if (s === "$regex" && /^\^.*[^$]/.test(Wt(g))) {
      if (u(N, "beginsWith"))
        return {
          field: N,
          operator: "beginsWith",
          value: Wt(g).replace(/^\^/, "")
        };
    } else if (s === "$regex" && /[^^].*\$/.test(Wt(g))) {
      if (u(N, "endsWith"))
        return {
          field: N,
          operator: "endsWith",
          value: Wt(g).replace(/\$$/, "")
        };
    } else if (s === "$in" && Array.isArray(g)) {
      if (u(N, "in"))
        return n ? p = g : p = g.map((y) => `${y}`).join(","), { field: N, operator: "in", value: p };
    } else if (s === "$nin" && Array.isArray(g) && u(N, "notIn"))
      return n ? p = g : p = g.map((y) => `${y}`).join(","), { field: N, operator: "notIn", value: p };
    return !1;
  }
  function d(N, s) {
    let g = "";
    if (N === "$and") {
      if (!Array.isArray(s) || s.length === 0 || !s.every(Ae))
        return !1;
      if (s.length === 2 && s.every((p) => et(p).length === 1)) {
        const [p, y] = s, [R, h] = s.map((f) => et(f)[0]);
        if (R === h && Ae(p[R]) && et(p[R]).length === 1 && Ae(y[h]) && et(y[h]).length === 1 && ("$gte" in p[R] && "$lte" in y[h] && y[h].$lte >= p[R].$gte || "$lte" in p[R] && "$gte" in y[h] && p[R].$lte >= y[h].$gte)) {
          const [f, E] = [
            p[R].$gte ?? p[R].$lte,
            y[h].$lte ?? y[h].$gte
          ];
          let C = n ? [f, E] : `${f},${E}`;
          return f > E && (C = n ? [E, f] : `${E},${f}`), { field: R, operator: "between", value: C };
        }
      }
      const v = s.map((p) => c(p)).filter(Boolean);
      return v.length > 0 ? { combinator: "and", rules: v } : !1;
    } else if (N === "$or") {
      if (!Array.isArray(s) || s.length === 0 || !s.every(Ae))
        return !1;
      if (s.length === 2 && s.every((p) => et(p).length === 1)) {
        const [p, y] = s, [R, h] = s.map((f) => et(f)[0]);
        if (R === h && Ae(p[R]) && et(p[R]).length === 1 && Ae(y[h]) && et(y[h]).length === 1 && ("$gt" in p[R] && "$lt" in y[h] && p[R].$gt >= y[h].$lt || "$lt" in p[R] && "$gt" in y[h] && y[h].$gt >= p[R].$lt)) {
          const [f, E] = [
            p[R].$gt ?? p[R].$lt,
            y[h].$lt ?? y[h].$gt
          ];
          let C = n ? [f, E] : `${f},${E}`;
          return f > E && (C = n ? [E, f] : `${E},${f}`), { field: R, operator: "notBetween", value: C };
        }
      }
      const v = s.map((p) => c(p)).filter(Boolean);
      return v.length > 0 ? { combinator: "or", rules: v } : !1;
    } else if (N === "$not" && Ae(s)) {
      const v = c(s);
      return v ? !hn(v) && (v.operator === "between" || v.operator === "in" || v.operator === "contains" || v.operator === "beginsWith" || v.operator === "endsWith") ? { ...v, operator: Jr[v.operator] } : { combinator: "and", rules: [v], not: !0 } : !1;
    } else if (N === "$expr") {
      const v = et(s)[0];
      if (/^\$(eq|gte?|lte?|n?in)$/.test(v) && Array.isArray(s[v]) && s[v].length === 2 && typeof s[v][0] == "string" && /^\$/.test(s[v][0])) {
        g = s[v][0].replace(/^\$/, "");
        const p = s[v][1];
        if (typeof p == "string" && /^\$/.test(p) || Array.isArray(p) && p.every((y) => typeof y == "string") && p.every((y) => /^\$/.test(y))) {
          const y = Array.isArray(p) ? p.map((h) => h.replace(/^\$/, "")) : p.replace(/^\$/, ""), R = _(g, v, y);
          if (R)
            return typeof R.value == "string" && !u(g, R.operator, R.value) ? !1 : { ...R, valueSource: "field" };
        }
        return _(g, v, s[v][1]);
      }
    } else if (/^[^$]/.test(N)) {
      if (g = N, b1(s)) {
        if (u(g, "="))
          return { field: g, operator: "=", value: s };
      } else if (s === null) {
        if (u(g, "null"))
          return { field: g, operator: "null", value: s };
      } else if (Ae(s)) {
        let v = !1;
        const p = et(s).filter((R) => /^\$(eq|ne|gte?|lte?|n?in|regex)$/.test(R)).sort();
        if (p.length === 0)
          return !1;
        "$gte" in s && "$lte" in s && (v = {
          field: g,
          operator: "between",
          value: n ? [s.$gte, s.$lte] : `${s.$gte},${s.$lte}`
        });
        const y = p.filter((R) => !(v && (R === "$gte" || R === "$lte"))).map((R) => _(g, R, s[R])).filter(Boolean);
        return v && y.unshift(v), y.length === 0 ? !1 : y.length === 1 ? y[0] : { combinator: "and", rules: y };
      }
    }
    return !1;
  }
  function c(N) {
    const s = et(N).map((g) => d(g, N[g])).filter(Boolean);
    return s.length === 1 ? s[0] : s.length > 1 ? { combinator: "and", rules: s } : !1;
  }
  let S = e;
  if (typeof e == "string")
    try {
      S = JSON.parse(e);
    } catch {
      return jn;
    }
  if (!Ae(S))
    return jn;
  const b = c(S), m = b ? hn(b) ? b : { combinator: "and", rules: [b] } : jn;
  return t.independentCombinators ? vn(m) : m;
}
var v1 = function() {
  var e = function(Ot, ne, ae, me) {
    for (ae = ae || {}, me = Ot.length; me--; ae[Ot[me]] = ne)
      ;
    return ae;
  }, t = [1, 8], n = [1, 4], r = [2, 4], o = [1, 11], u = [1, 10], _ = [2, 16], d = [1, 14], c = [1, 15], S = [1, 16], b = [6, 8], m = [2, 147], N = [1, 19], s = [1, 20], g = [16, 33, 35, 36, 37, 38, 39, 40, 41, 42, 45, 46, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 103, 195], v = [16, 18, 32, 33, 35, 36, 37, 38, 39, 40, 41, 42, 45, 46, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 103, 195], p = [2, 161], y = [1, 29], R = [6, 8, 14, 17, 146, 150, 152, 154], h = [1, 42], f = [1, 61], E = [1, 53], C = [1, 60], k = [1, 62], x = [1, 63], O = [1, 64], Q = [1, 65], T = [1, 66], P = [1, 59], w = [1, 54], $ = [1, 55], j = [1, 56], q = [1, 57], M = [1, 58], V = [1, 43], B = [1, 44], J = [1, 45], X = [1, 47], be = [1, 34], F = [1, 67], W = [16, 35, 36, 37, 38, 39, 40, 41, 42, 45, 46, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 103, 195], Y = [6, 8, 14, 17, 150, 152, 154], te = [2, 144], pe = [1, 76], ee = [1, 77], I = [6, 8, 14, 17, 43, 133, 138, 144, 146, 150, 152, 154], ce = [1, 80], A = [1, 79], z = [1, 81], ue = [6, 8, 14, 17, 36, 43, 49, 50, 51, 71, 72, 74, 77, 89, 109, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], le = [6, 8, 14, 17, 34, 36, 43, 49, 50, 51, 71, 72, 74, 77, 89, 109, 114, 115, 116, 117, 118, 119, 123, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], ve = [1, 102], se = [1, 100], he = [1, 101], Ue = [1, 96], Pe = [1, 97], je = [1, 98], ge = [1, 99], Ee = [1, 103], Le = [1, 104], fe = [1, 105], Te = [1, 106], Ne = [1, 107], Oe = [1, 108], $e = [2, 106], oe = [6, 8, 14, 17, 34, 36, 43, 45, 49, 50, 51, 71, 72, 74, 77, 79, 81, 89, 93, 94, 95, 96, 97, 98, 99, 100, 101, 103, 107, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 119, 123, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], re = [6, 8, 14, 17, 34, 36, 43, 45, 49, 50, 51, 71, 72, 74, 77, 79, 81, 89, 93, 94, 95, 96, 97, 98, 99, 100, 101, 103, 105, 107, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 119, 123, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], U = [1, 110], K = [1, 117], He = [2, 64], it = [1, 119], ut = [16, 35, 37, 38, 39, 40, 41, 42, 45, 46, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 103, 195], Xe = [16, 29, 35, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 121, 195], Be = [1, 164], Fe = [17, 43], at = [6, 8, 14, 16, 17, 34, 35, 36, 43, 45, 49, 50, 51, 54, 55, 57, 58, 60, 67, 71, 72, 74, 76, 77, 79, 81, 82, 83, 84, 86, 87, 88, 89, 90, 91, 93, 94, 95, 96, 97, 98, 99, 100, 101, 103, 105, 107, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 119, 123, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182, 192, 193, 194, 195], St = [2, 59], st = [1, 174], Nt = [1, 172], Ct = [1, 173], Tt = [6, 8, 138, 146], G = [16, 35, 38, 39, 40, 41, 42, 45, 46, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 103, 195], H = [6, 8, 14, 17, 138, 144, 146, 150, 152, 154], Z = [6, 8, 14, 17, 36, 43, 49, 50, 51, 71, 72, 74, 77, 89, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], ke = [6, 8, 14, 17, 34, 36, 43, 49, 50, 51, 71, 72, 74, 77, 89, 93, 94, 95, 96, 101, 103, 107, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 119, 123, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], nt = [6, 8, 14, 17, 34, 36, 43, 49, 50, 51, 71, 72, 74, 77, 79, 81, 89, 93, 94, 95, 96, 101, 103, 107, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 119, 123, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], ft = [16, 35, 39, 40, 41, 42, 45, 46, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 103, 195], At = [16, 35, 40, 41, 42, 45, 46, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 103, 195], bt = [16, 35, 42, 45, 46, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 103, 195], $t = [71, 74, 77], Zt = [16, 35, 45, 46, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 103, 195], en = [1, 236], tn = [1, 237], l = [6, 8, 14, 17], L = [6, 8, 14, 17, 43, 157], D = [1, 254], ie = [1, 250], Ce = [2, 198], Ie = [1, 258], _e = [1, 259], ye = [6, 8, 14, 17, 43, 129, 135, 138, 144, 146, 150, 152, 154, 182], Je = [1, 261], xe = [1, 264], Ve = [1, 265], Ke = [1, 266], ct = [1, 267], Gt = [2, 175], ot = [1, 263], Qe = [6, 8, 14, 17, 36, 43, 89, 129, 135, 138, 144, 146, 150, 152, 154, 164, 165, 167, 168, 173, 177, 179, 180, 182], tr = [6, 8, 14, 17, 135, 138, 144, 146, 150, 152, 154], nr = [1, 279], rr = [2, 180], sr = [170, 173], Sn = [6, 8, 14, 17, 36, 43, 89, 129, 135, 138, 144, 146, 150, 152, 154, 164, 165, 167, 168, 173, 177, 179, 180, 182, 192, 193, 194], or = [2, 200], ir = [1, 284], Nn = [1, 296], ar = [1, 304], lr = [1, 305], cr = [1, 306], ur = [6, 8, 14, 17, 138, 146, 150, 152, 154], fr = [1, 316], Cn = [1, 322], An = [1, 323], On = [2, 205], kn = [1, 334], hr = [16, 152], In = [6, 8, 14, 17, 152, 154], nn = [1, 350], Ln = {
    trace: function() {
    },
    yy: {},
    symbols_: { error: 2, main: 3, selectClause: 4, semicolonOpt: 5, EOF: 6, unionClause: 7, ";": 8, unionClauseNotParenthesized: 9, unionClauseParenthesized: 10, order_by_opt: 11, limit_opt: 12, selectClauseParenthesized: 13, UNION: 14, distinctOpt: 15, "(": 16, ")": 17, SELECT: 18, highPriorityOpt: 19, maxStateMentTimeOpt: 20, straightJoinOpt: 21, sqlSmallResultOpt: 22, sqlBigResultOpt: 23, sqlBufferResultOpt: 24, sqlCacheOpt: 25, sqlCalcFoundRowsOpt: 26, selectExprList: 27, selectDataSetOpt: 28, ALL: 29, DISTINCT: 30, DISTINCTROW: 31, HIGH_PRIORITY: 32, MAX_STATEMENT_TIME: 33, "=": 34, NUMERIC: 35, STRAIGHT_JOIN: 36, SQL_SMALL_RESULT: 37, SQL_BIG_RESULT: 38, SQL_BUFFER_RESULT: 39, SQL_CACHE: 40, SQL_NO_CACHE: 41, SQL_CALC_FOUND_ROWS: 42, ",": 43, selectExpr: 44, "*": 45, SELECT_EXPR_STAR: 46, expr: 47, selectExprAliasOpt: 48, AS: 49, IDENTIFIER: 50, STRING: 51, string: 52, number: 53, EXPONENT_NUMERIC: 54, HEX_NUMERIC: 55, boolean: 56, TRUE: 57, FALSE: 58, null: 59, NULL: 60, literal: 61, place_holder: 62, function_call: 63, function_call_param_list: 64, function_call_param: 65, identifier: 66, DOT: 67, identifier_list: 68, case_expr_opt: 69, when_then_list: 70, WHEN: 71, THEN: 72, case_when_else: 73, ELSE: 74, case_when: 75, CASE: 76, END: 77, simple_expr_prefix: 78, "+": 79, simple_expr: 80, "-": 81, "~": 82, "!": 83, BINARY: 84, expr_list: 85, ROW: 86, EXISTS: 87, "{": 88, "}": 89, "||": 90, WILDCARD: 91, bit_expr: 92, "|": 93, "&": 94, "<<": 95, ">>": 96, "/": 97, DIV: 98, MOD: 99, "%": 100, "^": 101, not_opt: 102, NOT: 103, escape_opt: 104, ESCAPE: 105, predicate: 106, IN: 107, BETWEEN: 108, AND: 109, SOUNDS: 110, LIKE: 111, REGEXP: 112, comparison_operator: 113, ">=": 114, ">": 115, "<=": 116, "<": 117, "<>": 118, "!=": 119, sub_query_data_set_opt: 120, ANY: 121, boolean_primary: 122, IS: 123, boolean_extra: 124, UNKNOWN: 125, OR: 126, XOR: 127, where_opt: 128, WHERE: 129, group_by_opt: 130, group_by: 131, roll_up_opt: 132, WITH: 133, ROLLUP: 134, GROUP_BY: 135, group_by_order_by_item_list: 136, order_by: 137, ORDER_BY: 138, group_by_order_by_item: 139, sort_opt: 140, ASC: 141, DESC: 142, having_opt: 143, HAVING: 144, limit: 145, LIMIT: 146, OFFSET: 147, procedure_opt: 148, procedure: 149, PROCEDURE: 150, for_update_lock_in_share_mode_opt: 151, FOR: 152, UPDATE: 153, LOCK: 154, SHARE: 155, MODE: 156, FROM: 157, table_references: 158, partitionOpt: 159, escaped_table_reference: 160, table_reference: 161, OJ: 162, join_inner_cross: 163, INNER: 164, CROSS: 165, left_right: 166, LEFT: 167, RIGHT: 168, out_opt: 169, OUTER: 170, left_right_out_opt: 171, join_table: 172, JOIN: 173, table_factor: 174, join_condition: 175, on_join_condition: 176, NATURAL: 177, join_condition_opt: 178, ON: 179, USING: 180, partition_names: 181, PARTITION: 182, aliasOpt: 183, index_or_key: 184, INDEX: 185, KEY: 186, for_opt: 187, identifier_list_opt: 188, index_hint_list_opt: 189, index_hint_list: 190, index_hint: 191, USE: 192, IGNORE: 193, FORCE: 194, PLACE_HOLDER: 195, $accept: 0, $end: 1 },
    terminals_: { 2: "error", 6: "EOF", 8: ";", 14: "UNION", 16: "(", 17: ")", 18: "SELECT", 29: "ALL", 30: "DISTINCT", 31: "DISTINCTROW", 32: "HIGH_PRIORITY", 33: "MAX_STATEMENT_TIME", 34: "=", 35: "NUMERIC", 36: "STRAIGHT_JOIN", 37: "SQL_SMALL_RESULT", 38: "SQL_BIG_RESULT", 39: "SQL_BUFFER_RESULT", 40: "SQL_CACHE", 41: "SQL_NO_CACHE", 42: "SQL_CALC_FOUND_ROWS", 43: ",", 45: "*", 46: "SELECT_EXPR_STAR", 49: "AS", 50: "IDENTIFIER", 51: "STRING", 54: "EXPONENT_NUMERIC", 55: "HEX_NUMERIC", 57: "TRUE", 58: "FALSE", 60: "NULL", 67: "DOT", 71: "WHEN", 72: "THEN", 74: "ELSE", 76: "CASE", 77: "END", 79: "+", 81: "-", 82: "~", 83: "!", 84: "BINARY", 86: "ROW", 87: "EXISTS", 88: "{", 89: "}", 90: "||", 91: "WILDCARD", 93: "|", 94: "&", 95: "<<", 96: ">>", 97: "/", 98: "DIV", 99: "MOD", 100: "%", 101: "^", 103: "NOT", 105: "ESCAPE", 107: "IN", 108: "BETWEEN", 109: "AND", 110: "SOUNDS", 111: "LIKE", 112: "REGEXP", 114: ">=", 115: ">", 116: "<=", 117: "<", 118: "<>", 119: "!=", 121: "ANY", 123: "IS", 125: "UNKNOWN", 126: "OR", 127: "XOR", 129: "WHERE", 133: "WITH", 134: "ROLLUP", 135: "GROUP_BY", 138: "ORDER_BY", 141: "ASC", 142: "DESC", 144: "HAVING", 146: "LIMIT", 147: "OFFSET", 150: "PROCEDURE", 152: "FOR", 153: "UPDATE", 154: "LOCK", 155: "SHARE", 156: "MODE", 157: "FROM", 162: "OJ", 164: "INNER", 165: "CROSS", 167: "LEFT", 168: "RIGHT", 170: "OUTER", 173: "JOIN", 177: "NATURAL", 179: "ON", 180: "USING", 182: "PARTITION", 185: "INDEX", 186: "KEY", 192: "USE", 193: "IGNORE", 194: "FORCE", 195: "PLACE_HOLDER" },
    productions_: [0, [3, 3], [3, 3], [5, 1], [5, 0], [7, 1], [7, 3], [10, 4], [10, 4], [13, 3], [9, 4], [9, 4], [4, 12], [15, 1], [15, 1], [15, 1], [15, 0], [19, 1], [19, 0], [20, 3], [20, 0], [21, 1], [21, 0], [22, 1], [22, 0], [23, 1], [23, 0], [24, 1], [24, 0], [25, 0], [25, 1], [25, 1], [26, 1], [26, 0], [27, 3], [27, 1], [44, 1], [44, 1], [44, 2], [48, 0], [48, 2], [48, 1], [48, 2], [48, 1], [52, 1], [53, 1], [53, 1], [53, 1], [56, 1], [56, 1], [59, 1], [61, 1], [61, 1], [61, 1], [61, 1], [61, 1], [63, 4], [64, 3], [64, 1], [65, 0], [65, 1], [65, 1], [65, 2], [65, 1], [66, 1], [66, 3], [68, 1], [68, 3], [69, 0], [69, 1], [70, 4], [70, 5], [73, 0], [73, 2], [75, 5], [78, 2], [78, 2], [78, 2], [78, 2], [78, 2], [80, 1], [80, 1], [80, 1], [80, 1], [80, 3], [80, 4], [80, 3], [80, 4], [80, 4], [80, 1], [80, 3], [80, 3], [80, 5], [92, 1], [92, 3], [92, 3], [92, 3], [92, 3], [92, 3], [92, 3], [92, 3], [92, 3], [92, 3], [92, 3], [92, 3], [92, 3], [102, 0], [102, 1], [104, 0], [104, 2], [106, 1], [106, 6], [106, 6], [106, 6], [106, 4], [106, 5], [106, 4], [113, 1], [113, 1], [113, 1], [113, 1], [113, 1], [113, 1], [113, 1], [120, 1], [120, 1], [122, 1], [122, 4], [122, 3], [122, 6], [124, 1], [124, 1], [47, 1], [47, 4], [47, 2], [47, 3], [47, 3], [47, 3], [85, 1], [85, 3], [128, 0], [128, 2], [130, 0], [130, 1], [132, 0], [132, 2], [131, 3], [11, 0], [11, 1], [137, 3], [136, 1], [136, 3], [139, 2], [140, 0], [140, 1], [140, 1], [143, 0], [143, 2], [145, 2], [145, 4], [145, 4], [12, 0], [12, 1], [148, 0], [148, 1], [149, 2], [151, 0], [151, 2], [151, 4], [28, 0], [28, 10], [158, 1], [158, 3], [160, 1], [160, 4], [163, 0], [163, 1], [163, 1], [166, 1], [166, 1], [169, 0], [169, 1], [171, 0], [171, 2], [172, 4], [172, 5], [172, 4], [172, 6], [172, 5], [178, 0], [178, 1], [176, 2], [175, 1], [175, 4], [161, 1], [161, 1], [181, 1], [181, 3], [159, 0], [159, 4], [183, 0], [183, 2], [183, 1], [184, 1], [184, 1], [187, 0], [187, 2], [187, 2], [187, 2], [188, 0], [188, 1], [189, 0], [189, 1], [190, 1], [190, 3], [191, 6], [191, 6], [191, 6], [174, 4], [174, 4], [174, 3], [62, 1]],
    performAction: function(ne, ae, me, we, Re, i, wn) {
      var a = i.length - 1;
      switch (Re) {
        case 1:
        case 2:
          return { nodeType: "Main", value: i[a - 2], hasSemicolon: i[a - 1] };
        case 3:
        case 145:
          this.$ = !0;
          break;
        case 4:
          this.$ = !1;
          break;
        case 5:
        case 13:
        case 14:
        case 15:
        case 17:
        case 19:
        case 21:
        case 23:
        case 25:
        case 27:
        case 30:
        case 31:
        case 32:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 60:
        case 61:
        case 63:
        case 69:
        case 73:
        case 80:
        case 81:
        case 82:
        case 83:
        case 89:
        case 93:
        case 107:
        case 109:
        case 110:
        case 117:
        case 118:
        case 119:
        case 120:
        case 121:
        case 122:
        case 123:
        case 124:
        case 125:
        case 126:
        case 130:
        case 132:
        case 141:
        case 143:
        case 148:
        case 154:
        case 155:
        case 157:
        case 162:
        case 164:
        case 165:
        case 176:
        case 177:
        case 178:
        case 179:
        case 181:
        case 190:
        case 192:
        case 194:
        case 195:
        case 203:
        case 204:
        case 210:
        case 212:
          this.$ = i[a];
          break;
        case 6:
          this.$ = i[a - 2], this.$.orderBy = i[a - 1], this.$.limit = i[a];
          break;
        case 7:
        case 8:
          this.$ = { type: "Union", left: i[a - 3], distinctOpt: i[a - 1], right: i[a] };
          break;
        case 9:
          this.$ = { type: "SelectParenthesized", value: i[a - 1] };
          break;
        case 10:
        case 11:
          this.$ = { type: "Union", left: i[a - 3], distinctOpt: i[a - 1], right: i[a] };
          break;
        case 12:
          this.$ = {
            type: "Select",
            distinctOpt: i[a - 10],
            highPriorityOpt: i[a - 9],
            maxStateMentTimeOpt: i[a - 8],
            straightJoinOpt: i[a - 7],
            sqlSmallResultOpt: i[a - 6],
            sqlBigResultOpt: i[a - 5],
            sqlBufferResultOpt: i[a - 4],
            sqlCacheOpt: i[a - 3],
            sqlCalcFoundRowsOpt: i[a - 2],
            selectItems: i[a - 1],
            from: i[a].from,
            partition: i[a].partition,
            where: i[a].where,
            groupBy: i[a].groupBy,
            having: i[a].having,
            orderBy: i[a].orderBy,
            limit: i[a].limit,
            procedure: i[a].procedure,
            updateLockMode: i[a].updateLockMode
          };
          break;
        case 16:
        case 18:
        case 20:
        case 22:
        case 24:
        case 26:
        case 28:
        case 29:
        case 33:
        case 59:
        case 68:
        case 72:
        case 106:
        case 108:
        case 140:
        case 142:
        case 144:
        case 147:
        case 153:
        case 156:
        case 161:
        case 163:
        case 166:
        case 175:
        case 180:
        case 189:
        case 198:
        case 205:
        case 209:
        case 211:
          this.$ = null;
          break;
        case 34:
          i[a - 2].value.push(i[a]);
          break;
        case 35:
          this.$ = { type: "SelectExpr", value: [i[a]] };
          break;
        case 36:
        case 37:
        case 64:
          this.$ = { type: "Identifier", value: i[a] };
          break;
        case 38:
          this.$ = i[a - 1], this.$.alias = i[a].alias, this.$.hasAs = i[a].hasAs;
          break;
        case 39:
        case 200:
          this.$ = { alias: null, hasAs: null };
          break;
        case 40:
        case 42:
          this.$ = { alias: i[a], hasAs: !0 };
          break;
        case 41:
          this.$ = { alias: i[a], hasAs: !1 };
          break;
        case 43:
          this.$ = { alias: i[$01], hasAs: !1 };
          break;
        case 44:
          this.$ = { type: "String", value: i[a] };
          break;
        case 45:
        case 46:
        case 47:
          this.$ = { type: "Number", value: i[a] };
          break;
        case 48:
          this.$ = { type: "Boolean", value: "TRUE" };
          break;
        case 49:
          this.$ = { type: "Boolean", value: "FALSE" };
          break;
        case 50:
          this.$ = { type: "Null", value: "null" };
          break;
        case 56:
          this.$ = { type: "FunctionCall", name: i[a - 3], params: i[a - 1] };
          break;
        case 57:
          i[a - 2].push(i[a]), this.$ = i[a - 2];
          break;
        case 58:
          this.$ = [i[a]];
          break;
        case 62:
          this.$ = { type: "FunctionCallParam", distinctOpt: i[a - 1], value: i[a] };
          break;
        case 65:
          this.$ = i[a - 2], i[a - 2].value += "." + i[a];
          break;
        case 66:
          this.$ = { type: "IdentifierList", value: [i[a]] };
          break;
        case 67:
        case 172:
          this.$ = i[a - 2], i[a - 2].value.push(i[a]);
          break;
        case 70:
          this.$ = { type: "WhenThenList", value: [{ when: i[a - 2], then: i[a] }] };
          break;
        case 71:
          this.$ = i[a - 4], this.$.value.push({ when: i[a - 2], then: i[a] });
          break;
        case 74:
          this.$ = { type: "CaseWhen", caseExprOpt: i[a - 3], whenThenList: i[a - 2], else: i[a - 1] };
          break;
        case 75:
        case 76:
        case 77:
        case 78:
        case 79:
          this.$ = { type: "Prefix", prefix: i[a - 1], value: i[a] };
          break;
        case 84:
          this.$ = { type: "SimpleExprParentheses", value: i[a - 1] };
          break;
        case 85:
          this.$ = { type: "SimpleExprParentheses", value: i[a - 2], hasRow: !0 };
          break;
        case 86:
          this.$ = { type: "SubQuery", value: i[a - 1] };
          break;
        case 87:
          this.$ = { type: "SubQuery", value: i[a - 1], hasExists: !0 };
          break;
        case 88:
          this.$ = { type: "IdentifierExpr", identifier: i[a - 2], value: i[a - 1] };
          break;
        case 90:
          this.$ = { type: "StartsWithExpr", value: i[a - 2] };
          break;
        case 91:
          this.$ = { type: "EndsWithExpr", value: i[a] };
          break;
        case 92:
          this.$ = { type: "ContainsExpr", value: i[a - 2] };
          break;
        case 94:
          this.$ = { type: "BitExpression", operator: "|", left: i[a - 2], right: i[a] };
          break;
        case 95:
          this.$ = { type: "BitExpression", operator: "&", left: i[a - 2], right: i[a] };
          break;
        case 96:
          this.$ = { type: "BitExpression", operator: "<<", left: i[a - 2], right: i[a] };
          break;
        case 97:
          this.$ = { type: "BitExpression", operator: ">>", left: i[a - 2], right: i[a] };
          break;
        case 98:
          this.$ = { type: "BitExpression", operator: "+", left: i[a - 2], right: i[a] };
          break;
        case 99:
          this.$ = { type: "BitExpression", operator: "-", left: i[a - 2], right: i[a] };
          break;
        case 100:
          this.$ = { type: "BitExpression", operator: "*", left: i[a - 2], right: i[a] };
          break;
        case 101:
          this.$ = { type: "BitExpression", operator: "/", left: i[a - 2], right: i[a] };
          break;
        case 102:
          this.$ = { type: "BitExpression", operator: "DIV", left: i[a - 2], right: i[a] };
          break;
        case 103:
          this.$ = { type: "BitExpression", operator: "MOD", left: i[a - 2], right: i[a] };
          break;
        case 104:
          this.$ = { type: "BitExpression", operator: "%", left: i[a - 2], right: i[a] };
          break;
        case 105:
          this.$ = { type: "BitExpression", operator: "^", left: i[a - 2], right: i[a] };
          break;
        case 111:
          this.$ = { type: "InSubQueryPredicate", hasNot: i[a - 4], left: i[a - 5], right: i[a - 1] };
          break;
        case 112:
          this.$ = { type: "InExpressionListPredicate", hasNot: i[a - 4], left: i[a - 5], right: i[a - 1] };
          break;
        case 113:
          this.$ = { type: "BetweenPredicate", hasNot: i[a - 4], left: i[a - 5], right: { left: i[a - 2], right: i[a] } };
          break;
        case 114:
          this.$ = { type: "SoundsLikePredicate", hasNot: !1, left: i[a - 3], right: i[a] };
          break;
        case 115:
          this.$ = { type: "LikePredicate", hasNot: i[a - 3], left: i[a - 4], right: i[a - 1], escape: i[a] };
          break;
        case 116:
          this.$ = { type: "RegexpPredicate", hasNot: i[a - 2], left: i[a - 3], right: i[a] };
          break;
        case 127:
          this.$ = { type: "IsNullBooleanPrimary", hasNot: i[a - 1], value: i[a - 3] };
          break;
        case 128:
          this.$ = { type: "ComparisonBooleanPrimary", left: i[a - 2], operator: i[a - 1], right: i[a] };
          break;
        case 129:
          this.$ = { type: "ComparisonSubQueryBooleanPrimary", operator: i[a - 4], subQueryOpt: i[a - 3], left: i[a - 5], right: i[a - 1] };
          break;
        case 131:
          this.$ = { type: "BooleanExtra", value: i[a] };
          break;
        case 133:
          this.$ = { type: "IsExpression", hasNot: i[a - 1], left: i[a - 3], right: i[a] };
          break;
        case 134:
          this.$ = { type: "NotExpression", value: i[a] };
          break;
        case 135:
          this.$ = { type: "OrExpression", operator: i[a - 1], left: i[a - 2], right: i[a] };
          break;
        case 136:
          this.$ = { type: "AndExpression", operator: i[a - 1], left: i[a - 2], right: i[a] };
          break;
        case 137:
          this.$ = { type: "XorExpression", operator: i[a - 1], left: i[a - 2], right: i[a] };
          break;
        case 138:
          this.$ = { type: "ExpressionList", value: [i[a]] };
          break;
        case 139:
        case 214:
          this.$ = i[a - 2], this.$.value.push(i[a]);
          break;
        case 146:
          this.$ = { type: "GroupBy", value: i[a - 1], rollUp: i[a] };
          break;
        case 149:
          this.$ = { type: "OrderBy", value: i[a - 1], rollUp: i[a] };
          break;
        case 150:
        case 196:
          this.$ = [i[a]];
          break;
        case 151:
          this.$ = i[a - 2], i[a - 2].push(i[a]);
          break;
        case 152:
          this.$ = { type: "GroupByOrderByItem", value: i[a - 1], sortOpt: i[a] };
          break;
        case 158:
          this.$ = { type: "Limit", value: [i[a]] };
          break;
        case 159:
          this.$ = { type: "Limit", value: [i[a - 2], i[a]] };
          break;
        case 160:
          this.$ = { type: "Limit", value: [i[a], i[a - 2]], offsetMode: !0 };
          break;
        case 167:
          this.$ = i[a - 1] + " " + i[a];
          break;
        case 168:
          this.$ = i[a - 3] + " " + i[a - 2] + " " + i[a - 1] + " " + i[a];
          break;
        case 169:
          this.$ = {};
          break;
        case 170:
          this.$ = { from: i[a - 8], partition: i[a - 7], where: i[a - 6], groupBy: i[a - 5], having: i[a - 4], orderBy: i[a - 3], limit: i[a - 2], procedure: i[a - 1], updateLockMode: i[a] };
          break;
        case 171:
          this.$ = { type: "TableReferences", value: [i[a]] };
          break;
        case 173:
          this.$ = { type: "TableReference", value: i[a] };
          break;
        case 174:
          this.$ = { type: "TableReference", hasOj: !0, value: i[a - 1] };
          break;
        case 182:
          this.$ = { leftRight: null, outOpt: null };
          break;
        case 183:
          this.$ = { leftRight: i[a - 1], outOpt: i[a] };
          break;
        case 184:
          this.$ = { type: "InnerCrossJoinTable", innerCrossOpt: i[a - 2], left: i[a - 3], right: i[a], condition: null };
          break;
        case 185:
          this.$ = { type: "InnerCrossJoinTable", innerCrossOpt: i[a - 3], left: i[a - 4], right: i[a - 1], condition: i[a] };
          break;
        case 186:
          this.$ = { type: "StraightJoinTable", left: i[a - 3], right: i[a - 1], condition: i[a] };
          break;
        case 187:
          this.$ = { type: "LeftRightJoinTable", leftRight: i[a - 4], outOpt: i[a - 3], left: i[a - 5], right: i[a - 1], condition: i[a] };
          break;
        case 188:
          this.$ = { type: "NaturalJoinTable", leftRight: i[a - 2].leftRight, outOpt: i[a - 2].outOpt, left: i[a - 4], right: i[a] };
          break;
        case 191:
          this.$ = { type: "OnJoinCondition", value: i[a] };
          break;
        case 193:
          this.$ = { type: "UsingJoinCondition", value: i[a - 1] };
          break;
        case 197:
          this.$ = i[a - 2], i[a - 2].push(i[a]);
          break;
        case 199:
          this.$ = { type: "Partitions", value: i[a - 1] };
          break;
        case 201:
          this.$ = { hasAs: !0, alias: i[a] };
          break;
        case 202:
          this.$ = { hasAs: !1, alias: i[a] };
          break;
        case 206:
        case 207:
        case 208:
          this.$ = { type: "ForOptIndexHint", value: i[a] };
          break;
        case 213:
          this.$ = { type: "IndexHintList", value: [i[a]] };
          break;
        case 215:
          this.$ = { type: "UseIndexHint", value: i[a - 1], forOpt: i[a - 3], indexOrKey: i[a - 4] };
          break;
        case 216:
          this.$ = { type: "IgnoreIndexHint", value: i[a - 1], forOpt: i[a - 3], indexOrKey: i[a - 4] };
          break;
        case 217:
          this.$ = { type: "ForceIndexHint", value: i[a - 1], forOpt: i[a - 3], indexOrKey: i[a - 4] };
          break;
        case 218:
          this.$ = { type: "TableFactor", value: i[a - 3], partition: i[a - 2], alias: i[a - 1].alias, hasAs: i[a - 1].hasAs, indexHintOpt: i[a] };
          break;
        case 219:
          this.$ = { type: "TableFactor", value: { type: "SubQuery", value: i[a - 2] }, alias: i[a].alias, hasAs: i[a].hasAs };
          break;
        case 220:
          this.$ = i[a - 1], this.$.hasParentheses = !0;
          break;
        case 221:
          this.$ = { type: "PlaceHolder", value: i[a], param: i[a].slice(2, -1) };
          break;
      }
    },
    table: [{ 3: 1, 4: 2, 7: 3, 9: 5, 10: 6, 13: 7, 16: t, 18: n }, { 1: [3] }, { 5: 9, 6: r, 8: o, 14: u }, { 5: 12, 6: r, 8: o }, e([16, 32, 33, 35, 36, 37, 38, 39, 40, 41, 42, 45, 46, 50, 51, 54, 55, 57, 58, 60, 76, 79, 81, 82, 83, 84, 86, 87, 88, 91, 103, 195], _, { 15: 13, 29: d, 30: c, 31: S }), e(b, [2, 5]), e([6, 8, 146], m, { 11: 17, 137: 18, 138: N }), { 14: s }, { 4: 21, 18: n }, { 6: [1, 22] }, { 15: 23, 18: _, 29: d, 30: c, 31: S }, { 6: [2, 3] }, { 6: [1, 24] }, e(g, [2, 18], { 19: 25, 32: [1, 26] }), e(v, [2, 13]), e(v, [2, 14]), e(v, [2, 15]), e(b, p, { 12: 27, 145: 28, 146: y }), e(R, [2, 148]), { 16: h, 35: f, 47: 32, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 136: 30, 139: 31, 195: F }, { 15: 68, 16: _, 29: d, 30: c, 31: S }, { 17: [1, 69] }, { 1: [2, 1] }, { 4: 70, 9: 71, 18: n }, { 1: [2, 2] }, e(W, [2, 20], { 20: 72, 33: [1, 73] }), e(g, [2, 17]), e(b, [2, 6]), e(Y, [2, 162]), { 35: [1, 74] }, e(R, te, { 132: 75, 43: pe, 133: ee }), e(I, [2, 150]), e(I, [2, 153], { 140: 78, 109: ce, 126: A, 127: z, 141: [1, 82], 142: [1, 83] }), e(ue, [2, 132], { 113: 85, 34: [1, 86], 114: [1, 87], 115: [1, 88], 116: [1, 89], 117: [1, 90], 118: [1, 91], 119: [1, 92], 123: [1, 84] }), { 16: h, 35: f, 47: 93, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(le, [2, 126]), e(le, [2, 110], { 102: 94, 45: ve, 79: se, 81: he, 93: Ue, 94: Pe, 95: je, 96: ge, 97: Ee, 98: Le, 99: fe, 100: Te, 101: Ne, 103: Oe, 107: $e, 108: $e, 111: $e, 112: $e, 110: [1, 95] }), e(oe, [2, 93]), e(re, [2, 80]), e(re, [2, 81], { 67: U, 90: [1, 109] }), e(re, [2, 82]), e(re, [2, 83]), { 4: 112, 16: h, 18: n, 35: f, 47: 113, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 85: 111, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, { 16: [1, 114] }, { 16: [1, 115] }, { 50: K, 66: 116 }, e(re, [2, 89]), { 90: [1, 118] }, e(re, [2, 51]), e(re, [2, 52]), e(re, [2, 53]), e(re, [2, 54]), e(re, [2, 55]), e([6, 8, 14, 17, 34, 36, 43, 45, 49, 50, 51, 67, 71, 72, 74, 77, 79, 81, 89, 90, 93, 94, 95, 96, 97, 98, 99, 100, 101, 103, 105, 107, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 119, 123, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], He, { 16: it }), { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 120, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 121, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 122, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 123, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 124, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 195: F }, { 16: h, 35: f, 47: 126, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 69: 125, 71: [2, 68], 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(re, [2, 44]), e(re, [2, 45]), e(re, [2, 46]), e(re, [2, 47]), e(re, [2, 48]), e(re, [2, 49]), e(re, [2, 50]), e(re, [2, 221]), { 10: 128, 13: 127, 16: t }, e([6, 8, 14, 138, 146], [2, 9]), e(b, [2, 10], { 14: u }), e(b, [2, 11]), e(ut, [2, 22], { 21: 129, 36: [1, 130] }), { 34: [1, 131] }, e(Y, [2, 158], { 43: [1, 132], 147: [1, 133] }), e(R, [2, 149]), { 16: h, 35: f, 47: 32, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 139: 134, 195: F }, { 134: [1, 135] }, e(I, [2, 152]), { 16: h, 35: f, 47: 136, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, { 16: h, 35: f, 47: 137, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, { 16: h, 35: f, 47: 138, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(I, [2, 154]), e(I, [2, 155]), e([57, 58, 60, 125], $e, { 102: 139, 103: Oe }), { 16: h, 29: [1, 142], 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 106: 140, 120: 141, 121: [1, 143], 195: F }, e(Xe, [2, 117]), e(Xe, [2, 118]), e(Xe, [2, 119]), e(Xe, [2, 120]), e(Xe, [2, 121]), e(Xe, [2, 122]), e(Xe, [2, 123]), e(ue, [2, 134]), { 107: [1, 144], 108: [1, 145], 111: [1, 146], 112: [1, 147] }, { 111: [1, 148] }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 149, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 150, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 151, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 152, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 153, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 154, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 155, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 156, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 157, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 158, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 159, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 160, 195: F }, e([57, 58, 60, 107, 108, 111, 112, 125], [2, 107]), { 91: [1, 161] }, { 50: [1, 162] }, { 17: [1, 163], 43: Be }, { 17: [1, 165] }, e(Fe, [2, 138], { 109: ce, 126: A, 127: z }), { 16: h, 35: f, 47: 113, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 85: 166, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, { 4: 167, 18: n }, { 16: h, 35: f, 47: 168, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 67: U, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(at, He), { 50: K, 66: 169 }, e(Fe, St, { 122: 33, 106: 35, 92: 36, 80: 37, 61: 38, 66: 39, 63: 40, 78: 41, 75: 46, 52: 48, 53: 49, 56: 50, 59: 51, 62: 52, 64: 170, 65: 171, 47: 175, 16: h, 30: st, 35: f, 45: Nt, 46: Ct, 50: E, 51: C, 54: k, 55: x, 57: O, 58: Q, 60: T, 76: P, 79: w, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 103: be, 195: F }), e(re, [2, 75]), e(re, [2, 76]), e(re, [2, 77]), e(re, [2, 78]), e(re, [2, 79]), { 70: 176, 71: [1, 177] }, { 71: [2, 69], 109: ce, 126: A, 127: z }, e(Tt, [2, 7], { 14: s }), e(Tt, [2, 8]), e(G, [2, 24], { 22: 178, 37: [1, 179] }), e(ut, [2, 21]), { 35: [1, 180] }, { 35: [1, 181] }, { 35: [1, 182] }, e(I, [2, 151]), e(H, [2, 145]), e(Z, [2, 135], { 109: ce }), e(ue, [2, 136]), e(Z, [2, 137], { 109: ce }), { 56: 185, 57: O, 58: Q, 60: [1, 184], 124: 183, 125: [1, 186] }, e(le, [2, 128]), { 16: [1, 187] }, { 16: [2, 124] }, { 16: [2, 125] }, { 16: [1, 188] }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 189, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 190, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 191, 195: F }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 192, 195: F }, e([6, 8, 14, 17, 34, 36, 43, 49, 50, 51, 71, 72, 74, 77, 89, 93, 103, 107, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 119, 123, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], [2, 94], { 45: ve, 79: se, 81: he, 94: Pe, 95: je, 96: ge, 97: Ee, 98: Le, 99: fe, 100: Te, 101: Ne }), e([6, 8, 14, 17, 34, 36, 43, 49, 50, 51, 71, 72, 74, 77, 89, 93, 94, 101, 103, 107, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 119, 123, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], [2, 95], { 45: ve, 79: se, 81: he, 95: je, 96: ge, 97: Ee, 98: Le, 99: fe, 100: Te }), e(ke, [2, 96], { 45: ve, 79: se, 81: he, 97: Ee, 98: Le, 99: fe, 100: Te }), e(ke, [2, 97], { 45: ve, 79: se, 81: he, 97: Ee, 98: Le, 99: fe, 100: Te }), e(nt, [2, 98], { 45: ve, 97: Ee, 98: Le, 99: fe, 100: Te }), e(nt, [2, 99], { 45: ve, 97: Ee, 98: Le, 99: fe, 100: Te }), e(oe, [2, 100]), e(oe, [2, 101]), e(oe, [2, 102]), e(oe, [2, 103]), e(oe, [2, 104]), e([6, 8, 14, 17, 34, 36, 43, 49, 50, 51, 71, 72, 74, 77, 89, 93, 101, 103, 107, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 119, 123, 126, 127, 129, 133, 135, 138, 141, 142, 144, 146, 150, 152, 154, 157, 164, 165, 167, 168, 173, 177, 179, 180, 182], [2, 105], { 45: ve, 79: se, 81: he, 94: Pe, 95: je, 96: ge, 97: Ee, 98: Le, 99: fe, 100: Te }), e(re, [2, 90]), e(at, [2, 65]), e(re, [2, 84]), { 16: h, 35: f, 47: 193, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(re, [2, 86]), { 17: [1, 194], 43: Be }, { 17: [1, 195] }, { 89: [1, 196], 109: ce, 126: A, 127: z }, e(re, [2, 91], { 67: U, 90: [1, 197] }), { 17: [1, 198], 43: [1, 199] }, e(Fe, [2, 58]), e(Fe, [2, 60]), e(Fe, [2, 61]), { 16: h, 35: f, 47: 200, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(Fe, [2, 63], { 109: ce, 126: A, 127: z }), { 71: [1, 202], 73: 201, 74: [1, 203], 77: [2, 72] }, { 16: h, 35: f, 47: 204, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(ft, [2, 26], { 23: 205, 38: [1, 206] }), e(G, [2, 23]), e(W, [2, 19]), e(Y, [2, 159]), e(Y, [2, 160]), e(ue, [2, 133]), e(le, [2, 127]), e(ue, [2, 130]), e(ue, [2, 131]), { 4: 207, 18: n }, { 4: 208, 16: h, 18: n, 35: f, 47: 113, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 85: 209, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, { 45: ve, 79: se, 81: he, 93: Ue, 94: Pe, 95: je, 96: ge, 97: Ee, 98: Le, 99: fe, 100: Te, 101: Ne, 109: [1, 210] }, e(le, [2, 108], { 104: 211, 105: [1, 212] }), e(le, [2, 116], { 45: ve, 79: se, 81: he, 93: Ue, 94: Pe, 95: je, 96: ge, 97: Ee, 98: Le, 99: fe, 100: Te, 101: Ne }), e(le, [2, 114], { 45: ve, 79: se, 81: he, 93: Ue, 94: Pe, 95: je, 96: ge, 97: Ee, 98: Le, 99: fe, 100: Te, 101: Ne }), e(Fe, [2, 139], { 109: ce, 126: A, 127: z }), e(re, [2, 85]), e(re, [2, 87]), e(re, [2, 88]), { 91: [1, 213] }, e(re, [2, 56]), e(Fe, St, { 122: 33, 106: 35, 92: 36, 80: 37, 61: 38, 66: 39, 63: 40, 78: 41, 75: 46, 52: 48, 53: 49, 56: 50, 59: 51, 62: 52, 47: 175, 65: 214, 16: h, 30: st, 35: f, 45: Nt, 46: Ct, 50: E, 51: C, 54: k, 55: x, 57: O, 58: Q, 60: T, 76: P, 79: w, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 103: be, 195: F }), e(Fe, [2, 62], { 109: ce, 126: A, 127: z }), { 77: [1, 215] }, { 16: h, 35: f, 47: 216, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, { 16: h, 35: f, 47: 217, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, { 72: [1, 218], 109: ce, 126: A, 127: z }, e(At, [2, 28], { 24: 219, 39: [1, 220] }), e(ft, [2, 25]), { 17: [1, 221] }, { 17: [1, 222] }, { 17: [1, 223], 43: Be }, { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 106: 224, 195: F }, e(le, [2, 115]), { 16: h, 35: f, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 225, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 195: F }, e(re, [2, 92]), e(Fe, [2, 57]), e(re, [2, 74]), { 72: [1, 226], 109: ce, 126: A, 127: z }, { 77: [2, 73], 109: ce, 126: A, 127: z }, { 16: h, 35: f, 47: 227, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(bt, [2, 29], { 25: 228, 40: [1, 229], 41: [1, 230] }), e(At, [2, 27]), e(le, [2, 129]), e(le, [2, 111]), e(le, [2, 112]), e(le, [2, 113]), e(le, [2, 109]), { 16: h, 35: f, 47: 231, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e($t, [2, 70], { 109: ce, 126: A, 127: z }), e(Zt, [2, 33], { 26: 232, 42: [1, 233] }), e(bt, [2, 30]), e(bt, [2, 31]), e($t, [2, 71], { 109: ce, 126: A, 127: z }), { 16: h, 27: 234, 35: f, 44: 235, 45: en, 46: tn, 47: 238, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(Zt, [2, 32]), e(l, [2, 169], { 28: 239, 43: [1, 240], 157: [1, 241] }), e(L, [2, 35]), e(L, [2, 36]), e(L, [2, 37]), e(L, [2, 39], { 48: 242, 49: [1, 243], 50: [1, 244], 51: [1, 245], 109: ce, 126: A, 127: z }), e(l, [2, 12]), { 16: h, 35: f, 44: 246, 45: en, 46: tn, 47: 238, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, { 16: D, 50: K, 66: 253, 88: ie, 158: 247, 160: 248, 161: 249, 172: 252, 174: 251 }, e(L, [2, 38]), { 50: [1, 255], 51: [1, 256] }, e(L, [2, 41]), e(L, [2, 43]), e(L, [2, 34]), e([6, 8, 14, 17, 129, 135, 138, 144, 146, 150, 152, 154], Ce, { 159: 257, 43: Ie, 182: _e }), e(ye, [2, 171]), e(ye, [2, 173], { 163: 260, 166: 262, 36: Je, 164: xe, 165: Ve, 167: Ke, 168: ct, 173: Gt, 177: ot }), { 162: [1, 268] }, e(Qe, [2, 194]), e(Qe, [2, 195]), e([6, 8, 14, 17, 36, 43, 49, 50, 89, 129, 135, 138, 144, 146, 150, 152, 154, 164, 165, 167, 168, 173, 177, 179, 180, 192, 193, 194], Ce, { 159: 269, 67: U, 182: _e }), { 4: 270, 16: D, 18: n, 50: K, 66: 253, 88: ie, 158: 271, 160: 248, 161: 249, 172: 252, 174: 251 }, e(L, [2, 40]), e(L, [2, 42]), e(tr, [2, 140], { 128: 272, 129: [1, 273] }), { 16: D, 50: K, 66: 253, 88: ie, 160: 274, 161: 249, 172: 252, 174: 251 }, { 16: [1, 275] }, { 173: [1, 276] }, { 16: D, 50: K, 66: 253, 174: 277 }, { 169: 278, 170: nr, 173: rr }, { 166: 281, 167: Ke, 168: ct, 171: 280, 173: [2, 182] }, { 173: [2, 176] }, { 173: [2, 177] }, e(sr, [2, 178]), e(sr, [2, 179]), { 16: D, 50: K, 66: 253, 161: 282, 172: 252, 174: 251 }, e(Sn, or, { 183: 283, 66: 285, 49: ir, 50: K }), { 17: [1, 286] }, { 17: [1, 287], 43: Ie }, e(H, [2, 142], { 130: 288, 131: 289, 135: [1, 290] }), { 16: h, 35: f, 47: 291, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(ye, [2, 172]), { 50: K, 66: 293, 181: 292 }, { 16: D, 50: K, 66: 253, 174: 294 }, { 176: 295, 179: Nn }, { 173: [1, 297] }, { 173: [2, 181] }, { 173: [1, 298] }, { 169: 299, 170: nr, 173: rr }, { 36: Je, 89: [1, 300], 163: 260, 164: xe, 165: Ve, 166: 262, 167: Ke, 168: ct, 173: Gt, 177: ot }, e(Qe, [2, 211], { 189: 301, 190: 302, 191: 303, 192: ar, 193: lr, 194: cr }), { 50: K, 66: 307 }, e(Sn, [2, 202], { 67: U }), e(Qe, or, { 66: 285, 183: 308, 49: ir, 50: K }), e(Qe, [2, 220]), e(ur, [2, 156], { 143: 309, 144: [1, 310] }), e(H, [2, 143]), { 16: h, 35: f, 47: 32, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 136: 311, 139: 31, 195: F }, e(tr, [2, 141], { 109: ce, 126: A, 127: z }), { 17: [1, 312], 43: [1, 313] }, e(Fe, [2, 196], { 67: U }), e([6, 8, 14, 17, 36, 43, 89, 129, 135, 138, 144, 146, 150, 152, 154, 164, 165, 167, 168, 173, 177, 182], [2, 184], { 175: 314, 176: 315, 179: Nn, 180: fr }), e(Qe, [2, 186]), { 16: h, 35: f, 47: 317, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, { 16: D, 50: K, 66: 253, 161: 318, 172: 252, 174: 251 }, { 16: D, 50: K, 66: 253, 174: 319 }, { 173: [2, 183] }, e(ye, [2, 174]), e(Qe, [2, 218]), e(Qe, [2, 212]), e(Qe, [2, 213]), { 184: 321, 185: Cn, 186: An }, { 184: 324, 185: Cn, 186: An }, { 184: 325, 185: Cn, 186: An }, e(Sn, [2, 201], { 67: U }), e(Qe, [2, 219]), e(R, m, { 137: 18, 11: 326, 138: N }), { 16: h, 35: f, 47: 327, 50: E, 51: C, 52: 48, 53: 49, 54: k, 55: x, 56: 50, 57: O, 58: Q, 59: 51, 60: T, 61: 38, 62: 52, 63: 40, 66: 39, 75: 46, 76: P, 78: 41, 79: w, 80: 37, 81: $, 82: j, 83: q, 84: M, 86: V, 87: B, 88: J, 91: X, 92: 36, 103: be, 106: 35, 122: 33, 195: F }, e(H, te, { 132: 328, 43: pe, 133: ee }), e([6, 8, 14, 17, 36, 43, 49, 50, 89, 129, 135, 138, 144, 146, 150, 152, 154, 164, 165, 167, 168, 173, 177, 179, 180, 182, 192, 193, 194], [2, 199]), { 50: K, 66: 329 }, e(Qe, [2, 185]), e(Qe, [2, 192]), { 16: [1, 330] }, e(Qe, [2, 191], { 109: ce, 126: A, 127: z }), { 36: Je, 163: 260, 164: xe, 165: Ve, 166: 262, 167: Ke, 168: ct, 173: Gt, 175: 331, 176: 315, 177: ot, 179: Nn, 180: fr }, e(Qe, [2, 188]), { 191: 332, 192: ar, 193: lr, 194: cr }, { 16: On, 152: kn, 187: 333 }, e(hr, [2, 203]), e(hr, [2, 204]), { 16: On, 152: kn, 187: 335 }, { 16: On, 152: kn, 187: 336 }, e(Y, p, { 145: 28, 12: 337, 146: y }), e(ur, [2, 157], { 109: ce, 126: A, 127: z }), e(H, [2, 146]), e(Fe, [2, 197], { 67: U }), { 50: K, 66: 339, 68: 338 }, e(Qe, [2, 187]), e(Qe, [2, 214]), { 16: [1, 340] }, { 135: [1, 343], 138: [1, 342], 173: [1, 341] }, { 16: [1, 344] }, { 16: [1, 345] }, e(In, [2, 163], { 148: 346, 149: 347, 150: [1, 348] }), { 17: [1, 349], 43: nn }, e(Fe, [2, 66], { 67: U }), { 17: [2, 209], 50: K, 66: 339, 68: 352, 188: 351 }, { 16: [2, 206] }, { 16: [2, 207] }, { 16: [2, 208] }, { 50: K, 66: 339, 68: 353 }, { 50: K, 66: 339, 68: 354 }, e(l, [2, 166], { 151: 355, 152: [1, 356], 154: [1, 357] }), e(In, [2, 164]), { 50: [1, 359], 63: 358 }, e(Qe, [2, 193]), { 50: K, 66: 360 }, { 17: [1, 361] }, { 17: [2, 210], 43: nn }, { 17: [1, 362], 43: nn }, { 17: [1, 363], 43: nn }, e(l, [2, 170]), { 153: [1, 364] }, { 107: [1, 365] }, e(In, [2, 165]), { 16: it }, e(Fe, [2, 67], { 67: U }), e(Qe, [2, 215]), e(Qe, [2, 216]), e(Qe, [2, 217]), e(l, [2, 167]), { 155: [1, 366] }, { 156: [1, 367] }, e(l, [2, 168])],
    defaultActions: { 11: [2, 3], 22: [2, 1], 24: [2, 2], 142: [2, 124], 143: [2, 125], 264: [2, 176], 265: [2, 177], 279: [2, 181], 299: [2, 183], 341: [2, 206], 342: [2, 207], 343: [2, 208] },
    parseError: function(ne, ae) {
      if (ae.recoverable)
        this.trace(ne);
      else {
        var me = new Error(ne);
        throw me.hash = ae, me;
      }
    },
    parse: function(ne) {
      var ae = this, me = [0], we = [null], Re = [], i = this.table, wn = "", a = 0, dr = 0, Rs = 2, pr = 1, Ss = Re.slice.call(arguments, 1), Ye = Object.create(this.lexer), wt = { yy: {} };
      for (var xn in this.yy)
        Object.prototype.hasOwnProperty.call(this.yy, xn) && (wt.yy[xn] = this.yy[xn]);
      Ye.setInput(ne, wt.yy), wt.yy.lexer = Ye, wt.yy.parser = this, typeof Ye.yylloc > "u" && (Ye.yylloc = {});
      var Pn = Ye.yylloc;
      Re.push(Pn);
      var Ns = Ye.options && Ye.options.ranges;
      typeof wt.yy.parseError == "function" ? this.parseError = wt.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;
      for (var Cs = function() {
        var Ft;
        return Ft = Ye.lex() || pr, typeof Ft != "number" && (Ft = ae.symbols_[Ft] || Ft), Ft;
      }, rt, xt, lt, Vn, Bt = {}, rn, gt, yr, sn; ; ) {
        if (xt = me[me.length - 1], this.defaultActions[xt] ? lt = this.defaultActions[xt] : ((rt === null || typeof rt > "u") && (rt = Cs()), lt = i[xt] && i[xt][rt]), typeof lt > "u" || !lt.length || !lt[0]) {
          var Dn = "";
          sn = [];
          for (rn in i[xt])
            this.terminals_[rn] && rn > Rs && sn.push("'" + this.terminals_[rn] + "'");
          Ye.showPosition ? Dn = "Parse error on line " + (a + 1) + `:
` + Ye.showPosition() + `
Expecting ` + sn.join(", ") + ", got '" + (this.terminals_[rt] || rt) + "'" : Dn = "Parse error on line " + (a + 1) + ": Unexpected " + (rt == pr ? "end of input" : "'" + (this.terminals_[rt] || rt) + "'"), this.parseError(Dn, {
            text: Ye.match,
            token: this.terminals_[rt] || rt,
            line: Ye.yylineno,
            loc: Pn,
            expected: sn
          });
        }
        if (lt[0] instanceof Array && lt.length > 1)
          throw new Error("Parse Error: multiple actions possible at state: " + xt + ", token: " + rt);
        switch (lt[0]) {
          case 1:
            me.push(rt), we.push(Ye.yytext), Re.push(Ye.yylloc), me.push(lt[1]), rt = null, dr = Ye.yyleng, wn = Ye.yytext, a = Ye.yylineno, Pn = Ye.yylloc;
            break;
          case 2:
            if (gt = this.productions_[lt[1]][1], Bt.$ = we[we.length - gt], Bt._$ = {
              first_line: Re[Re.length - (gt || 1)].first_line,
              last_line: Re[Re.length - 1].last_line,
              first_column: Re[Re.length - (gt || 1)].first_column,
              last_column: Re[Re.length - 1].last_column
            }, Ns && (Bt._$.range = [
              Re[Re.length - (gt || 1)].range[0],
              Re[Re.length - 1].range[1]
            ]), Vn = this.performAction.apply(Bt, [
              wn,
              dr,
              a,
              wt.yy,
              lt[1],
              we,
              Re
            ].concat(Ss)), typeof Vn < "u")
              return Vn;
            gt && (me = me.slice(0, -1 * gt * 2), we = we.slice(0, -1 * gt), Re = Re.slice(0, -1 * gt)), me.push(this.productions_[lt[1]][0]), we.push(Bt.$), Re.push(Bt._$), yr = i[me[me.length - 2]][me[me.length - 1]], me.push(yr);
            break;
          case 3:
            return !0;
        }
      }
      return !0;
    }
  }, _s = function() {
    var Ot = {
      EOF: 1,
      parseError: function(ae, me) {
        if (this.yy.parser)
          this.yy.parser.parseError(ae, me);
        else
          throw new Error(ae);
      },
      setInput: function(ne, ae) {
        return this.yy = ae || this.yy || {}, this._input = ne, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
          first_line: 1,
          first_column: 0,
          last_line: 1,
          last_column: 0
        }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
      },
      input: function() {
        var ne = this._input[0];
        this.yytext += ne, this.yyleng++, this.offset++, this.match += ne, this.matched += ne;
        var ae = ne.match(/(?:\r\n?|\n).*/g);
        return ae ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), ne;
      },
      unput: function(ne) {
        var ae = ne.length, me = ne.split(/(?:\r\n?|\n)/g);
        this._input = ne + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - ae), this.offset -= ae;
        var we = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), me.length - 1 && (this.yylineno -= me.length - 1);
        var Re = this.yylloc.range;
        return this.yylloc = {
          first_line: this.yylloc.first_line,
          last_line: this.yylineno + 1,
          first_column: this.yylloc.first_column,
          last_column: me ? (me.length === we.length ? this.yylloc.first_column : 0) + we[we.length - me.length].length - me[0].length : this.yylloc.first_column - ae
        }, this.options.ranges && (this.yylloc.range = [Re[0], Re[0] + this.yyleng - ae]), this.yyleng = this.yytext.length, this;
      },
      more: function() {
        return this._more = !0, this;
      },
      reject: function() {
        if (this.options.backtrack_lexer)
          this._backtrack = !0;
        else
          return this.parseError("Lexical error on line " + (this.yylineno + 1) + `. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).
` + this.showPosition(), {
            text: "",
            token: null,
            line: this.yylineno
          });
        return this;
      },
      less: function(ne) {
        this.unput(this.match.slice(ne));
      },
      pastInput: function() {
        var ne = this.matched.substr(0, this.matched.length - this.match.length);
        return (ne.length > 20 ? "..." : "") + ne.substr(-20).replace(/\n/g, "");
      },
      upcomingInput: function() {
        var ne = this.match;
        return ne.length < 20 && (ne += this._input.substr(0, 20 - ne.length)), (ne.substr(0, 20) + (ne.length > 20 ? "..." : "")).replace(/\n/g, "");
      },
      showPosition: function() {
        var ne = this.pastInput(), ae = new Array(ne.length + 1).join("-");
        return ne + this.upcomingInput() + `
` + ae + "^";
      },
      test_match: function(ne, ae) {
        var me, we, Re;
        if (this.options.backtrack_lexer && (Re = {
          yylineno: this.yylineno,
          yylloc: {
            first_line: this.yylloc.first_line,
            last_line: this.last_line,
            first_column: this.yylloc.first_column,
            last_column: this.yylloc.last_column
          },
          yytext: this.yytext,
          match: this.match,
          matches: this.matches,
          matched: this.matched,
          yyleng: this.yyleng,
          offset: this.offset,
          _more: this._more,
          _input: this._input,
          yy: this.yy,
          conditionStack: this.conditionStack.slice(0),
          done: this.done
        }, this.options.ranges && (Re.yylloc.range = this.yylloc.range.slice(0))), we = ne[0].match(/(?:\r\n?|\n).*/g), we && (this.yylineno += we.length), this.yylloc = {
          first_line: this.yylloc.last_line,
          last_line: this.yylineno + 1,
          first_column: this.yylloc.last_column,
          last_column: we ? we[we.length - 1].length - we[we.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + ne[0].length
        }, this.yytext += ne[0], this.match += ne[0], this.matches = ne, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(ne[0].length), this.matched += ne[0], me = this.performAction.call(this, this.yy, this, ae, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), me)
          return me;
        if (this._backtrack) {
          for (var i in Re)
            this[i] = Re[i];
          return !1;
        }
        return !1;
      },
      next: function() {
        if (this.done)
          return this.EOF;
        this._input || (this.done = !0);
        var ne, ae, me, we;
        this._more || (this.yytext = "", this.match = "");
        for (var Re = this._currentRules(), i = 0; i < Re.length; i++)
          if (me = this._input.match(this.rules[Re[i]]), me && (!ae || me[0].length > ae[0].length)) {
            if (ae = me, we = i, this.options.backtrack_lexer) {
              if (ne = this.test_match(me, Re[i]), ne !== !1)
                return ne;
              if (this._backtrack) {
                ae = !1;
                continue;
              } else
                return !1;
            } else if (!this.options.flex)
              break;
          }
        return ae ? (ne = this.test_match(ae, Re[we]), ne !== !1 ? ne : !1) : this._input === "" ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + `. Unrecognized text.
` + this.showPosition(), {
          text: "",
          token: null,
          line: this.yylineno
        });
      },
      lex: function() {
        var ae = this.next();
        return ae || this.lex();
      },
      begin: function(ae) {
        this.conditionStack.push(ae);
      },
      popState: function() {
        var ae = this.conditionStack.length - 1;
        return ae > 0 ? this.conditionStack.pop() : this.conditionStack[0];
      },
      _currentRules: function() {
        return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
      },
      topState: function(ae) {
        return ae = this.conditionStack.length - 1 - Math.abs(ae || 0), ae >= 0 ? this.conditionStack[ae] : "INITIAL";
      },
      pushState: function(ae) {
        this.begin(ae);
      },
      stateStackSize: function() {
        return this.conditionStack.length;
      },
      options: { "case-insensitive": !0 },
      performAction: function(ae, me, we, Re) {
        switch (we) {
          case 0:
            break;
          case 1:
            break;
          case 2:
            break;
          case 3:
            break;
          case 4:
            return 195;
          case 5:
            return 50;
          case 6:
            return 50;
          case 7:
            return 50;
          case 8:
            return 18;
          case 9:
            return 29;
          case 10:
            return 121;
          case 11:
            return 30;
          case 12:
            return 31;
          case 13:
            return 32;
          case 14:
            return 33;
          case 15:
            return 36;
          case 16:
            return 37;
          case 17:
            return 38;
          case 18:
            return 39;
          case 19:
            return 40;
          case 20:
            return 41;
          case 21:
            return 42;
          case 22:
            return 46;
          case 23:
            return 49;
          case 24:
            return 57;
          case 25:
            return 58;
          case 26:
            return 60;
          case 27:
            return "COLLATE";
          case 28:
            return 84;
          case 29:
            return 86;
          case 30:
            return 87;
          case 31:
            return 76;
          case 32:
            return 71;
          case 33:
            return 72;
          case 34:
            return 74;
          case 35:
            return 77;
          case 36:
            return 98;
          case 37:
            return 99;
          case 38:
            return 103;
          case 39:
            return 108;
          case 40:
            return 107;
          case 41:
            return 110;
          case 42:
            return 111;
          case 43:
            return 105;
          case 44:
            return 112;
          case 45:
            return 123;
          case 46:
            return 125;
          case 47:
            return 109;
          case 48:
            return 126;
          case 49:
            return 127;
          case 50:
            return 157;
          case 51:
            return 182;
          case 52:
            return 192;
          case 53:
            return 185;
          case 54:
            return 186;
          case 55:
            return 152;
          case 56:
            return 173;
          case 57:
            return 138;
          case 58:
            return 135;
          case 59:
            return 193;
          case 60:
            return 194;
          case 61:
            return 164;
          case 62:
            return 165;
          case 63:
            return 179;
          case 64:
            return 180;
          case 65:
            return 167;
          case 66:
            return 168;
          case 67:
            return 170;
          case 68:
            return 177;
          case 69:
            return 129;
          case 70:
            return 141;
          case 71:
            return 142;
          case 72:
            return 133;
          case 73:
            return 134;
          case 74:
            return 144;
          case 75:
            return 147;
          case 76:
            return 150;
          case 77:
            return 153;
          case 78:
            return 154;
          case 79:
            return 155;
          case 80:
            return 156;
          case 81:
            return 162;
          case 82:
            return 146;
          case 83:
            return 14;
          case 84:
            return 43;
          case 85:
            return 34;
          case 86:
            return 16;
          case 87:
            return 17;
          case 88:
            return 82;
          case 89:
            return 119;
          case 90:
            return 83;
          case 91:
            return 90;
          case 92:
            return 93;
          case 93:
            return 94;
          case 94:
            return 79;
          case 95:
            return 81;
          case 96:
            return 45;
          case 97:
            return 97;
          case 98:
            return 100;
          case 99:
            return 101;
          case 100:
            return 96;
          case 101:
            return 114;
          case 102:
            return 115;
          case 103:
            return 95;
          case 104:
            return "<=>";
          case 105:
            return 116;
          case 106:
            return 118;
          case 107:
            return 117;
          case 108:
            return 88;
          case 109:
            return 89;
          case 110:
            return 8;
          case 111:
            return 91;
          case 112:
            return 51;
          case 113:
            return 51;
          case 114:
            return 55;
          case 115:
            return 35;
          case 116:
            return 54;
          case 117:
            return 50;
          case 118:
            return 67;
          case 119:
            return 51;
          case 120:
            return 51;
          case 121:
            return 50;
          case 122:
            return 6;
          case 123:
            return "INVALID";
        }
      },
      rules: [/^(?:[/][*](.|\n)*?[*][/])/i, /^(?:[-][-]\s.*\n)/i, /^(?:[#]\s.*\n)/i, /^(?:\s+)/i, /^(?:[$][{](.*?)[}])/i, /^(?:[`][a-zA-Z_\u4e00-\u9fa5][a-zA-Z0-9_\u4e00-\u9fa5]*[`])/i, /^(?:[\w]+[\u4e00-\u9fa5]+[0-9a-zA-Z_\u4e00-\u9fa5]*)/i, /^(?:[\u4e00-\u9fa5][0-9a-zA-Z_\u4e00-\u9fa5]*)/i, /^(?:SELECT\b)/i, /^(?:ALL\b)/i, /^(?:ANY\b)/i, /^(?:DISTINCT\b)/i, /^(?:DISTINCTROW\b)/i, /^(?:HIGH_PRIORITY\b)/i, /^(?:MAX_STATEMENT_TIME\b)/i, /^(?:STRAIGHT_JOIN\b)/i, /^(?:SQL_SMALL_RESULT\b)/i, /^(?:SQL_BIG_RESULT\b)/i, /^(?:SQL_BUFFER_RESULT\b)/i, /^(?:SQL_CACHE\b)/i, /^(?:SQL_NO_CACHE\b)/i, /^(?:SQL_CALC_FOUND_ROWS\b)/i, /^(?:([a-zA-Z_\u4e00-\u9fa5][a-zA-Z0-9_\u4e00-\u9fa5]*\.){1,2}\*)/i, /^(?:AS\b)/i, /^(?:TRUE\b)/i, /^(?:FALSE\b)/i, /^(?:NULL\b)/i, /^(?:COLLATE\b)/i, /^(?:BINARY\b)/i, /^(?:ROW\b)/i, /^(?:EXISTS\b)/i, /^(?:CASE\b)/i, /^(?:WHEN\b)/i, /^(?:THEN\b)/i, /^(?:ELSE\b)/i, /^(?:END\b)/i, /^(?:DIV\b)/i, /^(?:MOD\b)/i, /^(?:NOT\b)/i, /^(?:BETWEEN\b)/i, /^(?:IN\b)/i, /^(?:SOUNDS\b)/i, /^(?:LIKE\b)/i, /^(?:ESCAPE\b)/i, /^(?:REGEXP\b)/i, /^(?:IS\b)/i, /^(?:UNKNOWN\b)/i, /^(?:AND\b)/i, /^(?:OR\b)/i, /^(?:XOR\b)/i, /^(?:FROM\b)/i, /^(?:PARTITION\b)/i, /^(?:USE\b)/i, /^(?:INDEX\b)/i, /^(?:KEY\b)/i, /^(?:FOR\b)/i, /^(?:JOIN\b)/i, /^(?:ORDER\s+BY\b)/i, /^(?:GROUP\s+BY\b)/i, /^(?:IGNORE\b)/i, /^(?:FORCE\b)/i, /^(?:INNER\b)/i, /^(?:CROSS\b)/i, /^(?:ON\b)/i, /^(?:USING\b)/i, /^(?:LEFT\b)/i, /^(?:RIGHT\b)/i, /^(?:OUTER\b)/i, /^(?:NATURAL\b)/i, /^(?:WHERE\b)/i, /^(?:ASC\b)/i, /^(?:DESC\b)/i, /^(?:WITH\b)/i, /^(?:ROLLUP\b)/i, /^(?:HAVING\b)/i, /^(?:OFFSET\b)/i, /^(?:PROCEDURE\b)/i, /^(?:UPDATE\b)/i, /^(?:LOCK\b)/i, /^(?:SHARE\b)/i, /^(?:MODE\b)/i, /^(?:OJ\b)/i, /^(?:LIMIT\b)/i, /^(?:UNION\b)/i, /^(?:,)/i, /^(?:=)/i, /^(?:\()/i, /^(?:\))/i, /^(?:~)/i, /^(?:!=)/i, /^(?:!)/i, /^(?:\|\|)/i, /^(?:\|)/i, /^(?:&)/i, /^(?:\+)/i, /^(?:-)/i, /^(?:\*)/i, /^(?:\/)/i, /^(?:%)/i, /^(?:\^)/i, /^(?:>>)/i, /^(?:>=)/i, /^(?:>)/i, /^(?:<<)/i, /^(?:<=>)/i, /^(?:<=)/i, /^(?:<>)/i, /^(?:<)/i, /^(?:\{)/i, /^(?:\})/i, /^(?:;)/i, /^(?:['](%+)['])/i, /^(?:['](\\.|[^'])*['])/i, /^(?:["](\\.|[^"])*["])/i, /^(?:[0][x][0-9a-fA-F]+)/i, /^(?:[-]?[0-9]+(\.[0-9]+)?)/i, /^(?:[-]?[0-9]+(\.[0-9]+)?[eE][-][0-9]+(\.[0-9]+)?)/i, /^(?:[a-zA-Z_\u4e00-\u9fa5][a-zA-Z0-9_\u4e00-\u9fa5]*)/i, /^(?:\.)/i, /^(?:["][a-zA-Z_\u4e00-\u9fa5][a-zA-Z0-9_\u4e00-\u9fa5]*["])/i, /^(?:['][a-zA-Z_\u4e00-\u9fa5][a-zA-Z0-9_\u4e00-\u9fa5]*['])/i, /^(?:([`])(?:(?=(\\?))\2.)*?\1)/i, /^(?:$)/i, /^(?:.)/i],
      conditions: { INITIAL: { rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123], inclusive: !0 } }
    };
    return Ot;
  }();
  Ln.lexer = _s;
  function Tn() {
    this.yy = {};
  }
  return Tn.prototype = Ln, Ln.Parser = Tn, new Tn();
}();
const ln = (e) => !!e && (e.type === "String" || e.type === "Number" || e.type === "Boolean"), Me = (e) => !!e && e.type === "Identifier", Pr = (e) => {
  switch (typeof e) {
    case "number":
      return `${e}`;
    case "boolean":
      return e ? "TRUE" : "FALSE";
    default:
      return `'${e}'`;
  }
}, Ze = (e) => (typeof e == "string" ? e : e.value).replace(/(^`|`$)/g, ""), E1 = (e) => e.replace("&&", "and").replace("||", "or").toLowerCase(), Vr = (e, t) => {
  if (t) {
    if (e === "<")
      return ">";
    if (e === "<=")
      return ">=";
    if (e === ">")
      return "<";
    if (e === ">=")
      return "<=";
  }
  return e === "<>" ? "!=" : e;
}, cn = (e) => e.type === "String" ? e.value.replace(/^(['"]?)(.+?)\1$/, "$2") : e.type === "Boolean" ? e.value.toLowerCase() === "true" : parseFloat(e.value), er = (e) => {
  const t = E1(e.operator);
  return e.left.type === "AndExpression" || e.left.type === "OrExpression" || e.left.type === "XorExpression" ? [...er(e.left), t, e.right] : [e.left, t, e.right];
}, _1 = (e) => {
  const t = er(e);
  let n = 0;
  const r = { combinator: "or", expressions: [] };
  let o = { combinator: "xor", expressions: [] }, u = { combinator: "and", expressions: [] };
  for (let d = 0; d < t.length - 2; d += 2) {
    let c = 0;
    if (t[d + 1] === "and" ? c = 2 - n : t[d + 1] === "xor" ? c = 1 - n : t[d + 1] === "or" && (c = 0 - n), c > 0)
      for (let S = 0; S < c; S++)
        n += 1, n === 1 ? (o = { combinator: "xor", expressions: [] }, c === 1 && (o.expressions.push(t[d]), (d >= t.length - 3 || t[d + 3] === "xor") && o.expressions.push(t[d + 2]))) : n === 2 && (u = { combinator: "and", expressions: [] }, u.expressions.push(t[d], t[d + 2]));
    else if (c < 0)
      for (let S = 0; S > c; S--)
        n -= 1, n === 1 ? (o.expressions.push(u), c === -1 && o.expressions.push(t[d + 2])) : n === 0 && (r.expressions.push(o), d >= t.length - 3 && r.expressions.push(t[d + 2]));
    else
      n === 0 ? ((d === 0 || d > 3 && t[d - 3] !== "or") && r.expressions.push(t[d]), (d >= t.length - 3 || t[d + 3] === "or") && r.expressions.push(t[d + 2])) : n === 1 ? o.expressions.push(t[d + 2]) : n === 2 && u.expressions.push(t[d + 2]);
  }
  if (n === 2 && (o.expressions.push(u), n -= 1), n === 1 && (r.expressions.push(o), n -= 1), r.expressions.length === 1 && "combinator" in r.expressions[0])
    return r.expressions[0].expressions.length === 1 && "combinator" in r.expressions[0].expressions[0] ? r.expressions[0].expressions[0] : r.expressions[0];
  const _ = { combinator: "or", expressions: [] };
  for (const d of r.expressions)
    "combinator" in d && "combinator" in d.expressions[0] && d.expressions.length === 1 ? _.expressions.push(d.expressions[0]) : _.expressions.push(d);
  return _;
};
function to(e, t = {}) {
  const { params: n, paramPrefix: r, independentCombinators: o, fields: u, getValueSources: _ } = t;
  let d = /^[ \t\n\r\s]*SELECT\b/i.test(e) ? e : /^[ \t\n\r\s]*WHERE\b/i.test(e) ? `SELECT * FROM t ${e}` : `SELECT * FROM t WHERE ${e}`, c = !1;
  const S = En(u);
  if (c = !!o, n)
    if (Array.isArray(n)) {
      let s = 0;
      d = d.replace(/\?/g, () => {
        const g = Pr(n[s]);
        return s++, g;
      });
    } else {
      const s = Object.keys(n), g = r ?? ":";
      s.forEach((v) => {
        d = d.replace(
          new RegExp(`\\${g}${v}\\b`, "ig"),
          Pr(n[v])
        );
      });
    }
  const b = (s, g, v) => _n({
    fieldName: s,
    fieldsFlat: S,
    operator: g,
    subordinateFieldName: v,
    getValueSources: _
  }), m = (s) => {
    if (s.type === "NotExpression") {
      const g = s.value.type === "SimpleExprParentheses" ? s.value.value.value[0] : s.value, v = m(g);
      if (v)
        return "rules" in v ? { ...v, not: !0 } : {
          rules: [v],
          not: !0,
          ...!c && { combinator: "and" }
        };
    } else if (s.type === "SimpleExprParentheses") {
      const g = s.value.value[0];
      if (g.type === "AndExpression" || g.type === "OrExpression" || g.type === "XorExpression")
        return m(g);
      const v = m(g);
      return v ? { rules: [v], ...c ? {} : { combinator: "and" } } : null;
    } else if (s.type === "AndExpression" || s.type === "OrExpression" || s.type === "XorExpression") {
      if (c) {
        const R = er(s).map((h) => typeof h == "string" ? h : m(h));
        return R.includes(null) ? null : {
          rules: R
        };
      }
      const g = _1(s), { combinator: v } = g, p = g.expressions.map((y) => "combinator" in y ? {
        combinator: y.combinator,
        rules: y.expressions.map((R) => "combinator" in R ? {
          combinator: R.combinator,
          rules: R.expressions.map((h) => m(h)).filter(Boolean)
        } : m(R)).filter(Boolean)
      } : m(y)).filter(Boolean);
      if (p.length > 0)
        return { combinator: v, rules: p };
    } else if (s.type === "IsNullBooleanPrimary") {
      if (Me(s.value)) {
        const g = Ze(s.value), v = s.hasNot ? "notNull" : "null";
        if (b(g, v))
          return {
            field: g,
            operator: v,
            value: null
          };
      }
    } else if (s.type === "ComparisonBooleanPrimary") {
      if (Me(s.left) && !Me(s.right) || !Me(s.left) && Me(s.right)) {
        const g = Me(s.left) ? s.left.value : s.right.value, v = [s.left, s.right].find((p) => !Me(p));
        if (ln(v)) {
          const p = Ze(g), y = Vr(s.operator, Me(s.right));
          if (b(p, y))
            return {
              field: p,
              operator: y,
              value: cn(v)
            };
        }
      } else if (Me(s.left) && Me(s.right)) {
        const g = Ze(s.left), v = Ze(s.right), p = Vr(s.operator);
        if (b(g, p, v))
          return {
            field: g,
            operator: p,
            value: v,
            valueSource: "field"
          };
      }
    } else if (s.type === "InExpressionListPredicate") {
      if (Me(s.left)) {
        const g = Ze(s.left), v = s.right.value.filter(ln).map(cn), p = s.hasNot ? "notIn" : "in", y = s.right.value.filter(Me).filter((R) => b(g, p, R.value)).map(Ze);
        if (v.length > 0) {
          const R = t != null && t.listsAsArrays ? v : v.join(", ");
          return { field: Ze(s.left), operator: p, value: R };
        } else if (y.length > 0) {
          const R = t != null && t.listsAsArrays ? y : y.join(", ");
          return {
            field: Ze(s.left),
            operator: p,
            value: R,
            valueSource: "field"
          };
        }
      }
    } else if (s.type === "BetweenPredicate") {
      if (Me(s.left) && ln(s.right.left) && ln(s.right.right)) {
        const g = [s.right.left, s.right.right].map(cn), v = t != null && t.listsAsArrays ? g : g.join(", "), p = s.hasNot ? "notBetween" : "between";
        return { field: Ze(s.left), operator: p, value: v };
      } else if (Me(s.left) && Me(s.right.left) && Me(s.right.right)) {
        const g = Ze(s.left), v = [s.right.left, s.right.right].map(Ze), p = s.hasNot ? "notBetween" : "between";
        if (v.every((y) => b(g, p, y))) {
          const y = t != null && t.listsAsArrays ? v : v.join(", ");
          return { field: g, operator: p, value: y, valueSource: "field" };
        }
      }
    } else if (s.type === "LikePredicate") {
      if (Me(s.left) && s.right.type === "String") {
        const g = cn(s.right), v = g.replace(/(^%)|(%$)/g, "");
        let p = "=";
        /^%.*%$/.test(g) || g === "%" ? p = s.hasNot ? "doesNotContain" : "contains" : /%$/.test(g) ? p = s.hasNot ? "doesNotBeginWith" : "beginsWith" : /^%/.test(g) && (p = s.hasNot ? "doesNotEndWith" : "endsWith");
        const y = Ze(s.left);
        if (b(y, p))
          return { field: y, operator: p, value: v };
      } else if (Me(s.left) && (s.right.type === "StartsWithExpr" || s.right.type === "EndsWithExpr" || s.right.type === "ContainsExpr")) {
        let g = "", v = "=";
        Me(s.right.value) && (g = Ze(s.right.value)), s.right.type === "EndsWithExpr" ? v = s.hasNot ? "doesNotEndWith" : "endsWith" : s.right.type === "StartsWithExpr" ? v = s.hasNot ? "doesNotBeginWith" : "beginsWith" : s.right.type === "ContainsExpr" && (v = s.hasNot ? "doesNotContain" : "contains");
        const p = Ze(s.left);
        if (v !== "=" && b(p, v, g))
          return {
            field: p,
            operator: v,
            value: g,
            valueSource: "field"
          };
      } else if (Me(s.left) && Me(s.right)) {
        const g = Ze(s.left), v = Ze(s.right), p = "=";
        if (b(g, p, v))
          return {
            field: g,
            operator: p,
            value: v,
            valueSource: "field"
          };
      }
    }
    return null;
  }, { where: N } = v1.parse(d).value;
  if (N) {
    const s = m(N);
    if (s)
      return "rules" in s ? s : { rules: [s], ...c ? {} : { combinator: "and" } };
  }
  return { rules: [], ...c ? {} : { combinator: "and" } };
}
const Rt = (e, t) => {
  let n = t, r = 0;
  for (; r < e.length && n && "rules" in n; ) {
    const o = n.rules[e[r]];
    typeof o != "string" ? n = o : n = null, r++;
  }
  return n;
}, Lt = (e) => e.slice(0, e.length - 1), is = (e, t) => e.length === t.length && e.every((n, r) => n === t[r]), no = (e, t) => e.length < t.length && RegExp(`^${e.join("-")}`).test(t.join("-")), R1 = (e, t) => {
  const n = [], r = Lt(e), o = Lt(t);
  let u = 0;
  for (; u < r.length && u < o.length && r[u] === o[u]; )
    n.push(o[u]), u++;
  return n;
}, Xt = (e, t) => {
  let n = !!t.disabled, r = t, o = 0;
  for (; o < e.length && !n && "rules" in r; ) {
    const u = r.rules[e[o]];
    Ae(u) && ("rules" in u || "field" in u) && (n = !!u.disabled, r = u), o++;
  }
  return n;
}, as = (e, { idGenerator: t = mt } = {}) => Ut(e, (n) => {
  n.id || (n.id = t());
}), bn = (e, { idGenerator: t = mt } = {}) => Ut(e, (n) => {
  n.id || (n.id = t()), n.rules = n.rules.map(
    (r) => typeof r == "string" ? r : "rules" in r ? bn(r, { idGenerator: t }) : as(r, { idGenerator: t })
  );
}), S1 = (e, { idGenerator: t = mt } = {}) => "rules" in e ? bn(e, { idGenerator: t }) : as(e, { idGenerator: t }), Dr = (e, t, n, {
  combinators: r = Dt,
  combinatorPreceding: o,
  idGenerator: u = mt
} = {}) => Ut(e, (_) => {
  const d = Rt(n, _);
  if (!("combinator" in d) && d.rules.length > 0) {
    const c = d.rules[d.rules.length - 2];
    d.rules.push(
      o ?? (typeof c == "string" ? c : Pt(r))
    );
  }
  d.rules.push(S1(t, { idGenerator: u }));
}), N1 = (e, t, n, r, {
  resetOnFieldChange: o = !0,
  resetOnOperatorChange: u = !1,
  getRuleDefaultOperator: _ = () => "=",
  getValueSources: d = () => ["value"],
  getRuleDefaultValue: c = () => ""
} = {}) => Ut(e, (S) => {
  if (t === "combinator" && !("combinator" in S)) {
    const b = Rt(Lt(r), S).rules;
    r[r.length - 1] % 2 === 1 && (b[r[r.length - 1]] = n);
    return;
  } else {
    const b = Rt(r, S), m = "rules" in b;
    if (b[t] !== n && (t !== "valueSource" && (b[t] = n), !m)) {
      let N = !1, s = !1;
      o && t === "field" && (b.operator = _(n), N = !0, s = !0), u && t === "operator" && (N = !0, s = !0);
      const g = d(b.field, b.operator)[0];
      (N && b.valueSource && g !== b.valueSource || t === "valueSource" && n !== b.valueSource) && (s = !!b.valueSource || !b.valueSource && n !== g, b.valueSource = N ? g : n), s && (b.value = c(b));
    }
  }
}), C1 = (e, t) => t.length === 0 || !("combinator" in e) && !Rt(t, e) ? e : Ut(e, (n) => {
  const r = t[t.length - 1], o = Rt(Lt(t), n);
  if (!("combinator" in o) && o.rules.length > 1) {
    const u = r === 0 ? 0 : r - 1;
    o.rules.splice(u, 2);
  } else
    o.rules.splice(r, 1);
}), A1 = (e, t, n, { clone: r = !1, combinators: o = Dt, idGenerator: u = mt } = {}) => {
  if (is(t, n))
    return e;
  const _ = Rt(t, e);
  if (!_)
    return e;
  const d = r ? "rules" in _ ? Yn(_, { idGenerator: u }) : Jn(_, { idGenerator: u }) : _;
  return Ut(e, (c) => {
    const S = !("combinator" in c), b = Rt(Lt(t), c), m = t[t.length - 1], N = S && m > 0 ? b.rules[m - 1] : null, s = S && m < b.rules.length - 1 ? b.rules[m + 1] : null;
    if (!r) {
      const f = S ? Math.max(0, m - 1) : m, E = S ? 2 : 1;
      b.rules.splice(f, E);
    }
    const g = [...n], v = R1(t, n);
    !r && t.length === v.length + 1 && n[v.length] > t[v.length] && (g[v.length] -= S ? 2 : 1);
    const p = Lt(g), y = Rt(p, c), R = g[g.length - 1], h = (...f) => y.rules.splice(R, 0, ...f);
    if (y.rules.length === 0 || !S)
      h(d);
    else if (R === 0)
      if (m === 0 && s)
        h(d, s);
      else {
        const f = y.rules[1] || N || Pt(o);
        h(d, f);
      }
    else if (N)
      h(N, d);
    else {
      const f = y.rules[R - 2] || s || Pt(o);
      h(f, d);
    }
  });
}, O1 = (e) => yt(e) ? e.map((t) => /* @__PURE__ */ de("optgroup", { label: t.label, children: t.options.map((n) => /* @__PURE__ */ de("option", { value: n.name, children: n.label }, n.name)) }, t.label)) : Array.isArray(e) ? e.map((t) => /* @__PURE__ */ de("option", { value: t.name, children: t.label }, t.name)) : null, $r = (e, t, n) => Is(e, (r) => {
  for (const [o, u] of Object.entries(t))
    r[u] = r[o], n && delete r[o];
});
function ro(e, t = {}) {
  const {
    ruleProcessor: n = (S) => S,
    ruleGroupProcessor: r = (S) => S,
    propertyMap: o = {},
    combinatorMap: u = {},
    operatorMap: _ = {},
    deleteRemappedProperties: d = !0
  } = t, c = (S) => ({
    ...r(
      $r(
        {
          ...S,
          ..."combinator" in S ? { combinator: u[S.combinator] ?? S.combinator } : {}
        },
        o,
        d
      )
    ),
    rules: S.rules.map((b, m) => typeof b == "string" ? u[b] ?? b : "rules" in b ? c({ ...b, path: [...S.path, m] }) : n(
      $r(
        {
          ...b,
          path: [...S.path, m],
          operator: _[b.operator] ?? b.operator
        },
        o,
        d
      )
    ))
  });
  return c({ ...e, path: [] });
}
const Jn = (e, { idGenerator: t = mt } = {}) => JSON.parse(JSON.stringify({ ...e, id: t() })), Yn = (e, { idGenerator: t = mt } = {}) => {
  if ("combinator" in e) {
    const { combinator: o, not: u } = e, _ = e.rules.map(
      (d) => "rules" in d ? Yn(d, { idGenerator: t }) : Jn(d, { idGenerator: t })
    );
    return { id: t(), combinator: o, rules: _, not: u };
  }
  const { not: n } = e, r = e.rules.map(
    (o) => typeof o == "string" ? o : "rules" in o ? Yn(o, { idGenerator: t }) : Jn(o, { idGenerator: t })
  );
  return { id: t(), rules: r, not: n };
}, ls = "A custom RuleGroup component has rendered a standard RuleGroup component with deprecated props. The combinator, not, and rules props should not be used. Instead, the full group object should be passed as the ruleGroup prop.", cs = "A custom RuleGroup component has rendered a standard Rule component with deprecated props. The field, operator, value, and valueSource props should not be used. Instead, the full rule object should be passed as the rule prop.", us = "QueryBuilder was rendered with both query and defaultQuery props. QueryBuilder must be either controlled or uncontrolled (specify either the query prop, or the defaultQuery prop, but not both). Decide between using a controlled or uncontrolled query builder and remove one of these props. More info: https://reactjs.org/link/controlled-components", fs = "QueryBuilder is changing from an uncontrolled component to be controlled. This is likely caused by the query changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled query builder for the lifetime of the component. More info: https://reactjs.org/link/controlled-components", hs = "QueryBuilder is changing from a controlled component to be uncontrolled. This is likely caused by the query changing from defined to undefined, which should not happen. Decide between using a controlled or uncontrolled query builder for the lifetime of the component. More info: https://reactjs.org/link/controlled-components", ds = "QueryBuilder was rendered with the enableDragAndDrop prop set to true, but either react-dnd or react-dnd-html5-backend (or both) was not installed. To enable drag-and-drop functionality, install both packages and wrap QueryBuilder in QueryBuilderDnD from @react-querybuilder/dnd.", so = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  errorDeprecatedRuleGroupProps: ls,
  errorDeprecatedRuleProps: cs,
  errorBothQueryDefaultQuery: us,
  errorUncontrolledToControlled: fs,
  errorControlledToUncontrolled: hs,
  errorEnabledDndWithoutReactDnD: ds
}, Symbol.toStringTag, { value: "Module" })), k1 = (e) => {
  const t = Qr(null);
  return Vt(() => {
    t.current = e;
  }, [e]), t.current;
};
let Gr = !1, Br = !1, Fr = !1;
const I1 = ({
  defaultQuery: e,
  queryProp: t,
  isFirstRender: n
}) => {
  const r = k1(!!t);
  Vt(() => {
    process.env.NODE_ENV !== "production" && (!!t && !!e && !Gr ? (console.error(us), Gr = !0) : r && !t && !!e && !Fr ? (console.error(hs), Fr = !0) : !(r || n) && !!t && !e && !Br && (console.error(fs), Br = !0));
  }, [e, r, t, n]);
};
let Wr = !1, jr = !1;
const ps = (e, t) => {
  Vt(() => {
    process.env.NODE_ENV !== "production" && e === "rule" && !t && !Wr && (console.error(cs), Wr = !0), process.env.NODE_ENV !== "production" && e === "ruleGroup" && !t && !jr && (console.error(ls), jr = !0);
  }, [t, e]);
};
let Mr = !1;
const ys = (e, t) => {
  Vt(() => {
    process.env.NODE_ENV !== "production" && !Mr && e && !t && (console.error(ds), Mr = !0);
  }, []);
}, ms = ({
  id: e,
  path: t,
  rule: n,
  translations: r,
  schema: o,
  actions: u,
  disabled: _,
  parentDisabled: d,
  context: c,
  field: S,
  operator: b,
  value: m,
  valueSource: N,
  dragMonitorId: s = "",
  dropMonitorId: g = "",
  dndRef: v = null,
  dragRef: p = null,
  isDragging: y = !1,
  isOver: R = !1
}) => {
  const {
    classNames: h,
    controls: {
      dragHandle: f,
      fieldSelector: E,
      operatorSelector: C,
      valueSourceSelector: k,
      valueEditor: x,
      cloneRuleAction: O,
      lockRuleAction: Q,
      removeRuleAction: T
    },
    fields: P,
    fieldMap: w,
    getInputType: $,
    getOperators: j,
    getValueEditorType: q,
    getValueSources: M,
    getValues: V,
    autoSelectField: B,
    autoSelectOperator: J,
    showCloneButtons: X,
    showLockButtons: be,
    listsAsArrays: F,
    validationMap: W,
    enableDragAndDrop: Y,
    getRuleClassname: te
  } = o, { moveRule: pe, onPropChange: ee, onRuleRemove: I } = u, ce = !!d || !!_, A = n || {
    field: S,
    operator: b,
    value: m,
    valueSource: N
  }, { field: z, operator: ue, value: le, valueSource: ve } = A;
  ps("rule", !!n), ys(Y, !!(s || g || v || p));
  const se = We(
    () => ({
      dragHandle: De(Se.dragHandle, h.dragHandle),
      fields: De(Se.fields, h.fields),
      operators: De(Se.operators, h.operators),
      valueSource: De(Se.valueSource, h.valueSource),
      value: De(Se.value, h.value),
      cloneRule: De(Se.cloneRule, h.cloneRule),
      lockRule: De(Se.lockRule, h.lockRule),
      removeRule: De(Se.removeRule, h.removeRule)
    }),
    [h]
  ), he = (Be) => (Fe) => {
    ce || ee(Be, Fe, t);
  }, Ue = (Be) => {
    if (Be.preventDefault(), Be.stopPropagation(), !ce) {
      const Fe = [...Lt(t), t[t.length - 1] + 1];
      pe(t, Fe, !0);
    }
  }, Pe = (Be) => {
    Be.preventDefault(), Be.stopPropagation(), ee("disabled", !ce, t);
  }, je = (Be) => {
    Be.preventDefault(), Be.stopPropagation(), ce || I(t);
  }, ge = (w == null ? void 0 : w[z]) ?? { name: z, label: z }, Ee = ge.inputType ?? $(z, ue), Le = j(z), fe = Xr(Le, ue), Te = fe == null ? void 0 : fe.arity, Ne = typeof Te == "string" && Te === "unary" || typeof Te == "number" && Te < 2, Oe = typeof ge.valueSources == "function" ? ge.valueSources(ue) : ge.valueSources ?? M(z, ue), $e = ve === "field" ? "select" : (typeof ge.valueEditorType == "function" ? ge.valueEditorType(ue) : ge.valueEditorType) ?? q(z, ue), oe = ve === "field" ? Xn(ge, P, ue) : ge.values ?? V(z, ue), re = t.length, U = Oe.map((Be) => ({ name: Be, label: Be })), K = W[e ?? ""] ?? (typeof ge.validator == "function" ? ge.validator({ id: e, field: z, operator: ue, value: le }) : null), He = Kr(K), it = We(() => (ge == null ? void 0 : ge.className) ?? "", [ge == null ? void 0 : ge.className]), ut = We(
    () => (fe == null ? void 0 : fe.className) ?? "",
    [fe == null ? void 0 : fe.className]
  ), Xe = De(
    te(A),
    it,
    ut,
    Se.rule,
    h.rule,
    {
      [Se.disabled]: ce,
      [Se.dndDragging]: y,
      [Se.dndOver]: R
    },
    He
  );
  return /* @__PURE__ */ _t(
    "div",
    {
      ref: v,
      "data-testid": qe.rule,
      "data-dragmonitorid": s,
      "data-dropmonitorid": g,
      className: Xe,
      "data-rule-id": e,
      "data-level": re,
      "data-path": JSON.stringify(t),
      children: [
        /* @__PURE__ */ de(
          f,
          {
            testID: qe.dragHandle,
            ref: p,
            level: re,
            path: t,
            title: r.dragHandle.title,
            label: r.dragHandle.label,
            className: se.dragHandle,
            disabled: ce,
            context: c,
            validation: K
          }
        ),
        /* @__PURE__ */ de(
          E,
          {
            testID: qe.fields,
            options: P,
            title: r.fields.title,
            value: z,
            operator: ue,
            className: se.fields,
            handleOnChange: he("field"),
            level: re,
            path: t,
            disabled: ce,
            context: c,
            validation: K
          }
        ),
        (B || z !== r.fields.placeholderName) && /* @__PURE__ */ _t(gr, { children: [
          /* @__PURE__ */ de(
            C,
            {
              testID: qe.operators,
              field: z,
              fieldData: ge,
              title: r.operators.title,
              options: Le,
              value: ue,
              className: se.operators,
              handleOnChange: he("operator"),
              level: re,
              path: t,
              disabled: ce,
              context: c,
              validation: K
            }
          ),
          (J || ue !== r.operators.placeholderName) && !Ne && /* @__PURE__ */ _t(gr, { children: [
            !["null", "notNull"].includes(ue) && Oe.length > 1 && /* @__PURE__ */ de(
              k,
              {
                testID: qe.valueSourceSelector,
                field: z,
                fieldData: ge,
                title: r.valueSourceSelector.title,
                options: U,
                value: ve ?? "value",
                className: se.valueSource,
                handleOnChange: he("valueSource"),
                level: re,
                path: t,
                disabled: ce,
                context: c,
                validation: K
              }
            ),
            /* @__PURE__ */ de(
              x,
              {
                testID: qe.valueEditor,
                field: z,
                fieldData: ge,
                title: r.value.title,
                operator: ue,
                value: le,
                valueSource: ve ?? "value",
                type: $e,
                inputType: Ee,
                values: oe,
                listsAsArrays: F,
                className: se.value,
                handleOnChange: he("value"),
                level: re,
                path: t,
                disabled: ce,
                context: c,
                validation: K
              }
            )
          ] })
        ] }),
        X && /* @__PURE__ */ de(
          O,
          {
            testID: qe.cloneRule,
            label: r.cloneRule.label,
            title: r.cloneRule.title,
            className: se.cloneRule,
            handleOnClick: Ue,
            level: re,
            path: t,
            disabled: ce,
            context: c,
            validation: K,
            ruleOrGroup: A
          }
        ),
        be && /* @__PURE__ */ de(
          Q,
          {
            testID: qe.lockRule,
            label: r.lockRule.label,
            title: r.lockRule.title,
            className: se.lockRule,
            handleOnClick: Pe,
            level: re,
            path: t,
            disabled: ce,
            disabledTranslation: d ? void 0 : r.lockRuleDisabled,
            context: c,
            validation: K,
            ruleOrGroup: A
          }
        ),
        /* @__PURE__ */ de(
          T,
          {
            testID: qe.removeRule,
            label: r.removeRule.label,
            title: r.removeRule.title,
            className: se.removeRule,
            handleOnClick: je,
            level: re,
            path: t,
            disabled: ce,
            context: c,
            validation: K,
            ruleOrGroup: A
          }
        )
      ]
    }
  );
};
ms.displayName = "Rule";
const bs = ({
  id: e,
  path: t,
  ruleGroup: n,
  translations: r,
  schema: o,
  actions: u,
  disabled: _,
  parentDisabled: d,
  context: c,
  combinator: S,
  rules: b,
  not: m,
  dragMonitorId: N = "",
  dropMonitorId: s = "",
  previewRef: g = null,
  dragRef: v = null,
  dropRef: p = null,
  isDragging: y = !1,
  isOver: R = !1
}) => {
  const {
    classNames: h,
    combinators: f,
    controls: {
      dragHandle: E,
      combinatorSelector: C,
      inlineCombinator: k,
      notToggle: x,
      addRuleAction: O,
      addGroupAction: Q,
      cloneGroupAction: T,
      lockGroupAction: P,
      removeGroupAction: w,
      ruleGroup: $,
      rule: j
    },
    createRule: q,
    createRuleGroup: M,
    independentCombinators: V,
    showCombinatorsBetweenRules: B,
    showNotToggle: J,
    showCloneButtons: X,
    showLockButtons: be,
    validationMap: F,
    disabledPaths: W,
    enableDragAndDrop: Y,
    getRuleGroupClassname: te
  } = o, { onGroupAdd: pe, onGroupRemove: ee, onPropChange: I, onRuleAdd: ce, moveRule: A } = u, z = !!d || !!_, ue = n ? { ...n } : { rules: b, not: m }, { rules: le, not: ve } = ue;
  let se = Dt[0].name;
  n && "combinator" in n ? se = n.combinator : n || (se = S ?? se), V || (ue.combinator = se), ps("ruleGroup", !!n);
  const he = We(
    () => ({
      header: De(Se.header, h.header, {
        [Se.dndOver]: R
      }),
      dragHandle: De(Se.dragHandle, h.dragHandle),
      combinators: De(Se.combinators, h.combinators),
      notToggle: De(Se.notToggle, h.notToggle),
      addRule: De(Se.addRule, h.addRule),
      addGroup: De(Se.addGroup, h.addGroup),
      cloneGroup: De(Se.cloneGroup, h.cloneGroup),
      lockGroup: De(Se.lockGroup, h.lockGroup),
      removeGroup: De(Se.removeGroup, h.removeGroup),
      body: De(Se.body, h.body)
    }),
    [
      h.addGroup,
      h.addRule,
      h.body,
      h.cloneGroup,
      h.combinators,
      h.dragHandle,
      h.header,
      h.lockGroup,
      h.notToggle,
      h.removeGroup,
      R
    ]
  );
  ys(
    Y,
    !!(N || s || g || v || p)
  );
  const Ue = (U) => {
    z || I("combinator", U, t);
  }, Pe = (U, K) => {
    z || I("combinator", U, t.concat([K]));
  }, je = (U) => {
    z || I("not", U, t);
  }, ge = (U, K) => {
    if (U.preventDefault(), U.stopPropagation(), !z) {
      const He = q();
      ce(He, t, K);
    }
  }, Ee = (U, K) => {
    if (U.preventDefault(), U.stopPropagation(), !z) {
      const He = M();
      pe(He, t, K);
    }
  }, Le = (U) => {
    if (U.preventDefault(), U.stopPropagation(), !z) {
      const K = [...Lt(t), t[t.length - 1] + 1];
      A(t, K, !0);
    }
  }, fe = (U) => {
    U.preventDefault(), U.stopPropagation(), I("disabled", !z, t);
  }, Te = (U) => {
    U.preventDefault(), U.stopPropagation(), z || ee(t);
  }, Ne = t.length, Oe = F[e ?? ""], $e = Kr(Oe), oe = We(
    () => {
      var U;
      return V ? null : ((U = Xr(f, se)) == null ? void 0 : U.className) ?? "";
    },
    [se, f, V]
  ), re = De(
    te(ue),
    oe,
    Se.ruleGroup,
    h.ruleGroup,
    {
      [Se.disabled]: z,
      [Se.dndDragging]: y
    },
    $e
  );
  return /* @__PURE__ */ _t(
    "div",
    {
      ref: g,
      className: re,
      "data-testid": qe.ruleGroup,
      "data-dragmonitorid": N,
      "data-dropmonitorid": s,
      "data-rule-group-id": e,
      "data-level": Ne,
      "data-path": JSON.stringify(t),
      children: [
        /* @__PURE__ */ _t("div", { ref: p, className: he.header, children: [
          Ne > 0 && /* @__PURE__ */ de(
            E,
            {
              testID: qe.dragHandle,
              ref: v,
              level: Ne,
              path: t,
              title: r.dragHandle.title,
              label: r.dragHandle.label,
              className: he.dragHandle,
              disabled: z,
              context: c,
              validation: Oe
            }
          ),
          !B && !V && /* @__PURE__ */ de(
            C,
            {
              testID: qe.combinators,
              options: f,
              value: se,
              title: r.combinators.title,
              className: he.combinators,
              handleOnChange: Ue,
              rules: le,
              level: Ne,
              path: t,
              disabled: z,
              context: c,
              validation: Oe
            }
          ),
          J && /* @__PURE__ */ de(
            x,
            {
              testID: qe.notToggle,
              className: he.notToggle,
              title: r.notToggle.title,
              label: r.notToggle.label,
              checked: ve,
              handleOnChange: je,
              level: Ne,
              disabled: z,
              path: t,
              context: c,
              validation: Oe
            }
          ),
          /* @__PURE__ */ de(
            O,
            {
              testID: qe.addRule,
              label: r.addRule.label,
              title: r.addRule.title,
              className: he.addRule,
              handleOnClick: ge,
              rules: le,
              level: Ne,
              path: t,
              disabled: z,
              context: c,
              validation: Oe,
              ruleOrGroup: ue
            }
          ),
          /* @__PURE__ */ de(
            Q,
            {
              testID: qe.addGroup,
              label: r.addGroup.label,
              title: r.addGroup.title,
              className: he.addGroup,
              handleOnClick: Ee,
              rules: le,
              level: Ne,
              path: t,
              disabled: z,
              context: c,
              validation: Oe,
              ruleOrGroup: ue
            }
          ),
          X && t.length >= 1 && /* @__PURE__ */ de(
            T,
            {
              testID: qe.cloneGroup,
              label: r.cloneRuleGroup.label,
              title: r.cloneRuleGroup.title,
              className: he.cloneGroup,
              handleOnClick: Le,
              rules: le,
              level: Ne,
              path: t,
              disabled: z,
              context: c,
              validation: Oe,
              ruleOrGroup: ue
            }
          ),
          be && /* @__PURE__ */ de(
            P,
            {
              testID: qe.lockGroup,
              label: r.lockGroup.label,
              title: r.lockGroup.title,
              className: he.lockGroup,
              handleOnClick: fe,
              rules: le,
              level: Ne,
              path: t,
              disabled: z,
              disabledTranslation: d ? void 0 : r.lockGroupDisabled,
              context: c,
              validation: Oe,
              ruleOrGroup: ue
            }
          ),
          t.length >= 1 && /* @__PURE__ */ de(
            w,
            {
              testID: qe.removeGroup,
              label: r.removeGroup.label,
              title: r.removeGroup.title,
              className: he.removeGroup,
              handleOnClick: Te,
              rules: le,
              level: Ne,
              path: t,
              disabled: z,
              context: c,
              validation: Oe,
              ruleOrGroup: ue
            }
          )
        ] }),
        /* @__PURE__ */ de("div", { className: he.body, children: le.map((U, K) => {
          const He = [...t, K], it = z || typeof U != "string" && U.disabled || W.some((Xe) => is(He, Xe)), ut = typeof U == "string" ? [...He, U].join("-") : U.id;
          return /* @__PURE__ */ _t(As, { children: [
            K > 0 && !V && B && /* @__PURE__ */ de(
              k,
              {
                options: f,
                value: se,
                title: r.combinators.title,
                className: he.combinators,
                handleOnChange: Ue,
                rules: le,
                level: Ne,
                context: c,
                validation: Oe,
                component: C,
                path: He,
                disabled: z,
                independentCombinators: V
              }
            ),
            typeof U == "string" ? /* @__PURE__ */ de(
              k,
              {
                options: f,
                value: U,
                title: r.combinators.title,
                className: he.combinators,
                handleOnChange: (Xe) => Pe(Xe, K),
                rules: le,
                level: Ne,
                context: c,
                validation: Oe,
                component: C,
                path: He,
                disabled: it,
                independentCombinators: V
              }
            ) : "rules" in U ? /* @__PURE__ */ de(
              $,
              {
                id: U.id,
                schema: o,
                actions: u,
                path: He,
                translations: r,
                ruleGroup: U,
                rules: U.rules,
                combinator: "combinator" in U ? U.combinator : void 0,
                not: !!U.not,
                disabled: it,
                parentDisabled: d || z,
                context: c
              }
            ) : /* @__PURE__ */ de(
              j,
              {
                id: U.id,
                rule: U,
                field: U.field,
                operator: U.operator,
                value: U.value,
                valueSource: U.valueSource,
                schema: o,
                actions: u,
                path: He,
                disabled: it,
                parentDisabled: d || z,
                translations: r,
                context: c
              }
            )
          ] }, ut);
        }) })
      ]
    }
  );
};
bs.displayName = "RuleGroup";
const gs = Os(
  ({ className: e, label: t, title: n, testID: r }, o) => /* @__PURE__ */ de("span", { "data-testid": r, ref: o, className: e, title: n, children: t })
);
gs.displayName = "DragHandle";
const vs = ({
  className: e,
  handleOnChange: t,
  title: n,
  label: r,
  checked: o,
  disabled: u,
  testID: _
}) => /* @__PURE__ */ _t("label", { "data-testid": _, className: e, title: n, children: [
  /* @__PURE__ */ de(
    "input",
    {
      type: "checkbox",
      onChange: (d) => t(d.target.checked),
      checked: !!o,
      disabled: u
    }
  ),
  r
] });
vs.displayName = "NotToggle";
const It = ({
  className: e,
  handleOnChange: t,
  options: n,
  title: r,
  value: o,
  multiple: u,
  listsAsArrays: _,
  disabled: d,
  testID: c
}) => {
  const S = We(
    () => u ? (b) => {
      const m = Array.from(b.target.selectedOptions).map((N) => N.value);
      t(_ ? m : fn(m, ","));
    } : (b) => t(b.target.value),
    [t, _, u]
  );
  return /* @__PURE__ */ de(
    "select",
    {
      "data-testid": c,
      className: e,
      value: u ? tt(o) : o,
      title: r,
      disabled: d,
      multiple: !!u,
      onChange: S,
      children: O1(n)
    }
  );
};
It.displayName = "ValueSelector";
const Es = ({
  operator: e,
  value: t,
  handleOnChange: n,
  title: r,
  className: o,
  type: u,
  inputType: _,
  values: d = [],
  listsAsArrays: c,
  fieldData: S,
  disabled: b,
  testID: m,
  ...N
}) => {
  if (Ys({ handleOnChange: n, inputType: _, operator: e, value: t }), e === "null" || e === "notNull")
    return null;
  const s = (S == null ? void 0 : S.placeholder) ?? "", g = ["between", "notBetween", "in", "notIn"].includes(e) ? "text" : _ || "text";
  if ((e === "between" || e === "notBetween") && u === "select") {
    const v = tt(t), p = (R) => {
      var f;
      const h = [R, v[1] ?? ((f = d[0]) == null ? void 0 : f.name), ...v.slice(2)];
      n(c ? h : fn(h, ","));
    }, y = (R) => {
      const h = [v[0], R, ...v.slice(2)];
      n(c ? h : fn(h, ","));
    };
    return /* @__PURE__ */ _t("span", { "data-testid": m, className: o, title: r, children: [
      /* @__PURE__ */ de(
        It,
        {
          ...N,
          className: Se.valueListItem,
          handleOnChange: p,
          disabled: b,
          value: v[0],
          options: d,
          listsAsArrays: c
        }
      ),
      /* @__PURE__ */ de(
        It,
        {
          ...N,
          className: Se.valueListItem,
          handleOnChange: y,
          disabled: b,
          value: v[1],
          options: d,
          listsAsArrays: c
        }
      )
    ] });
  }
  switch (u) {
    case "select":
    case "multiselect":
      return /* @__PURE__ */ de(
        It,
        {
          ...N,
          testID: m,
          className: o,
          title: r,
          handleOnChange: n,
          disabled: b,
          value: t,
          options: d,
          multiple: u === "multiselect",
          listsAsArrays: c
        }
      );
    case "textarea":
      return /* @__PURE__ */ de(
        "textarea",
        {
          "data-testid": m,
          placeholder: s,
          value: t,
          title: r,
          className: o,
          disabled: b,
          onChange: (v) => n(v.target.value)
        }
      );
    case "switch":
    case "checkbox":
      return /* @__PURE__ */ de(
        "input",
        {
          "data-testid": m,
          type: "checkbox",
          className: o,
          title: r,
          onChange: (v) => n(v.target.checked),
          checked: !!t,
          disabled: b
        }
      );
    case "radio":
      return /* @__PURE__ */ de("span", { "data-testid": m, className: o, title: r, children: d.map((v) => /* @__PURE__ */ _t("label", { children: [
        /* @__PURE__ */ de(
          "input",
          {
            type: "radio",
            value: v.name,
            disabled: b,
            checked: t === v.name,
            onChange: (p) => n(p.target.value)
          }
        ),
        v.label
      ] }, v.name)) });
  }
  return /* @__PURE__ */ de(
    "input",
    {
      "data-testid": m,
      type: g,
      placeholder: s,
      value: t,
      title: r,
      className: o,
      disabled: b,
      onChange: (v) => n(v.target.value)
    }
  );
};
Es.displayName = "ValueEditor";
const L1 = {
  addGroupAction: Et,
  removeGroupAction: Et,
  cloneGroupAction: Et,
  cloneRuleAction: Et,
  addRuleAction: Et,
  removeRuleAction: Et,
  combinatorSelector: It,
  inlineCombinator: Yr,
  fieldSelector: It,
  operatorSelector: It,
  valueEditor: Es,
  notToggle: vs,
  ruleGroup: bs,
  rule: ms,
  dragHandle: gs,
  lockRuleAction: Et,
  lockGroupAction: Et,
  valueSourceSelector: It
}, T1 = () => {
}, w1 = ({
  defaultQuery: e,
  query: t,
  fields: n,
  operators: r = $s,
  combinators: o = Dt,
  translations: u = Hn,
  enableMountQueryChange: _ = !0,
  controlClassnames: d,
  controlElements: c,
  getDefaultField: S,
  getDefaultOperator: b,
  getDefaultValue: m,
  getOperators: N,
  getValueEditorType: s,
  getValueSources: g,
  getInputType: v,
  getValues: p,
  getRuleClassname: y = () => "",
  getRuleGroupClassname: R = () => "",
  onAddRule: h = (Y) => Y,
  onAddGroup: f = (Y) => Y,
  onRemove: E = () => !0,
  onQueryChange: C = T1,
  showCombinatorsBetweenRules: k = !1,
  showNotToggle: x = !1,
  showCloneButtons: O = !1,
  showLockButtons: Q = !1,
  resetOnFieldChange: T = !0,
  resetOnOperatorChange: P = !1,
  autoSelectField: w = !0,
  autoSelectOperator: $ = !0,
  addRuleToNewGroups: j = !1,
  enableDragAndDrop: q,
  independentCombinators: M,
  listsAsArrays: V = !1,
  disabled: B = !1,
  validator: J,
  context: X,
  debugMode: be = !1,
  onLog: F = console.log,
  idGenerator: W = mt
}) => {
  const Y = Js({
    controlClassnames: d,
    controlElements: c,
    debugMode: be,
    enableDragAndDrop: q,
    enableMountQueryChange: _,
    translations: u
  }), {
    controlClassnames: te,
    controlElements: pe,
    debugMode: ee,
    enableDragAndDrop: I,
    enableMountQueryChange: ce,
    translations: A
  } = Y, z = We(
    () => ({
      id: A.fields.placeholderName,
      name: A.fields.placeholderName,
      label: A.fields.placeholderLabel
    }),
    [A.fields.placeholderLabel, A.fields.placeholderName]
  ), ue = We(
    () => n ?? [z],
    [z, n]
  ), le = We(() => {
    const G = Array.isArray(ue) ? ue : et(ue).map((H) => ({ ...ue[H], name: H })).sort((H, Z) => H.label.localeCompare(Z.label));
    return yt(G) ? Bn(w ? G : [
      {
        label: A.fields.placeholderGroupLabel,
        options: [z]
      },
      ...G
    ]) : jt(w ? G : [z, ...G]);
  }, [w, z, ue, A.fields.placeholderGroupLabel]), ve = We(() => {
    if (!Array.isArray(ue)) {
      const H = {};
      return et(ue).forEach((Z) => H[Z] = { ...ue[Z], name: Z }), w ? H : { ...H, [A.fields.placeholderName]: z };
    }
    const G = {};
    return yt(le) ? le.forEach((H) => H.options.forEach((Z) => G[Z.name] = Z)) : le.forEach((H) => G[H.name] = H), G;
  }, [w, z, le, ue, A.fields.placeholderName]), se = We(
    () => ({
      id: A.operators.placeholderName,
      name: A.operators.placeholderName,
      label: A.operators.placeholderLabel
    }),
    [A.operators.placeholderLabel, A.operators.placeholderName]
  ), he = ht(
    (G) => {
      const H = ve[G];
      let Z = r;
      if (H != null && H.operators)
        Z = H.operators;
      else if (N) {
        const ke = N(G);
        ke && (Z = ke);
      }
      return $ || (yt(Z) ? Z = [
        {
          label: A.operators.placeholderGroupLabel,
          options: [se]
        },
        ...Z
      ] : Z = [se, ...Z]), yt(Z) ? Bn(Z) : jt(Z);
    },
    [
      $,
      se,
      ve,
      N,
      r,
      A.operators.placeholderGroupLabel
    ]
  ), Ue = ht(
    (G) => {
      const H = ve[G];
      if (H != null && H.defaultOperator)
        return H.defaultOperator;
      if (b)
        return typeof b == "function" ? b(G) : b;
      const Z = he(G) ?? [];
      return Z.length ? Pt(Z) ?? "" : "";
    },
    [ve, b, he]
  ), Pe = ht(
    (G, H) => {
      if (s) {
        const Z = s(G, H);
        if (Z)
          return Z;
      }
      return "text";
    },
    [s]
  ), je = ht(
    (G, H) => Qn(ve[G], H, g),
    [ve, g]
  ), ge = ht(
    (G, H) => {
      const Z = ve[G];
      if (Z != null && Z.values)
        return Z.values;
      if (p) {
        const ke = p(G, H);
        if (ke)
          return ke;
      }
      return [];
    },
    [ve, p]
  ), Ee = ht(
    (G) => {
      const H = ve[G.field];
      if ((H == null ? void 0 : H.defaultValue) !== void 0 && H.defaultValue !== null)
        return H.defaultValue;
      if (m)
        return m(G);
      let Z = "";
      const ke = ge(G.field, G.operator), nt = (ft) => {
        const At = Pt(ft);
        if (G.operator === "between" || G.operator === "notBetween") {
          const bt = [At, At];
          return V ? bt : fn(
            bt.map(($t) => $t ?? ""),
            ","
          );
        } else
          return At;
      };
      if (G.valueSource === "field") {
        const ft = Xn(H, le, G.operator);
        ft.length > 0 ? Z = nt(ft) : Z = "";
      } else
        ke.length ? Z = nt(ke) : Pe(G.field, G.operator) === "checkbox" && (Z = !1);
      return Z;
    },
    [ve, le, m, Pe, ge, V]
  ), Le = ht(
    (G, H) => {
      if (v) {
        const Z = v(G, H);
        if (Z)
          return Z;
      }
      return "text";
    },
    [v]
  ), fe = ht(() => {
    let G = "";
    (le == null ? void 0 : le.length) > 0 && le[0] && (G = Pt(le) ?? ""), S && (typeof S == "function" ? G = S(le) : G = S);
    const H = Ue(G), Z = je(G, H)[0] ?? "value", ke = {
      id: W(),
      field: G,
      operator: H,
      valueSource: Z,
      value: ""
    }, nt = Ee(ke);
    return { ...ke, value: nt };
  }, [
    le,
    S,
    Ue,
    Ee,
    je,
    W
  ]), Te = ht(() => M ? {
    id: W(),
    rules: j ? [fe()] : [],
    not: !1
  } : {
    id: W(),
    rules: j ? [fe()] : [],
    combinator: Pt(o) ?? "",
    not: !1
  }, [j, o, fe, W, M]), Ne = Qr(!0), [Oe, $e] = ks(
    e ? bn(e, { idGenerator: W }) : Te()
  ), oe = t ? Ne.current ? bn(t, { idGenerator: W }) : t : Oe;
  I1({
    defaultQuery: e,
    queryProp: t,
    isFirstRender: Ne.current
  }), Ne.current = !1, Vt(() => {
    ce && C(oe);
  }, []);
  const re = !t, U = ht(
    (G) => {
      re && $e(G), C(G);
    },
    [C, re]
  ), K = We(
    () => B === !0 || Array.isArray(B) && B.some((G) => G.length === 0),
    [B]
  ), He = We(() => Array.isArray(B) && B || [], [B]), it = (G, H, Z) => {
    if (Xt(H, oe) || K) {
      ee && F({ type: vt.parentPathDisabled, rule: G, parentPath: H, query: oe });
      return;
    }
    const ke = h(G, H, oe, Z);
    if (!ke) {
      ee && F({ type: vt.onAddRuleFalse, rule: G, parentPath: H, query: oe });
      return;
    }
    const nt = Dr(oe, ke, H, {
      combinators: o,
      combinatorPreceding: ke.combinatorPreceding ?? void 0
    });
    U(nt);
  }, ut = (G, H, Z) => {
    if (Xt(H, oe) || K) {
      ee && F({
        type: vt.parentPathDisabled,
        ruleGroup: G,
        parentPath: H,
        query: oe
      });
      return;
    }
    const ke = f(G, H, oe, Z);
    if (!ke) {
      ee && F({ type: vt.onAddGroupFalse, ruleGroup: G, parentPath: H, query: oe });
      return;
    }
    const nt = Dr(oe, ke, H, {
      combinators: o,
      combinatorPreceding: ke.combinatorPreceding ?? void 0
    });
    U(nt);
  }, Xe = (G, H, Z) => {
    if (Xt(Z, oe) && G !== "disabled" || K) {
      ee && F({ type: vt.pathDisabled, path: Z, prop: G, value: H, query: oe });
      return;
    }
    const ke = N1(oe, G, H, Z, {
      resetOnFieldChange: T,
      resetOnOperatorChange: P,
      getRuleDefaultOperator: Ue,
      getValueSources: je,
      getRuleDefaultValue: Ee
    });
    U(ke);
  }, Be = (G, H) => {
    if (Xt(G, oe) || K) {
      ee && F({ type: vt.pathDisabled, path: G, query: oe });
      return;
    }
    const Z = Rt(G, oe);
    if (Z)
      if (E(Z, G, oe, H)) {
        const ke = C1(oe, G);
        U(ke);
      } else
        ee && F({ type: vt.onRemoveFalse, ruleOrGroup: Z, path: G, query: oe });
  }, Fe = (G, H, Z) => {
    if (Xt(G, oe) || K) {
      ee && F({ type: vt.pathDisabled, oldPath: G, newPath: H, query: oe });
      return;
    }
    const ke = A1(oe, G, H, { clone: Z, combinators: o });
    U(ke);
  }, { validationResult: at, validationMap: St } = We(() => {
    const G = typeof J == "function" ? J(oe) : {};
    return { validationResult: G, validationMap: typeof G == "object" ? G : {} };
  }, [oe, J]), st = We(
    () => ({
      fields: le,
      fieldMap: ve,
      combinators: o,
      classNames: te,
      createRule: fe,
      createRuleGroup: Te,
      controls: pe,
      getOperators: he,
      getValueEditorType: Pe,
      getValueSources: je,
      getInputType: Le,
      getValues: ge,
      getRuleClassname: y,
      getRuleGroupClassname: R,
      showCombinatorsBetweenRules: k,
      showNotToggle: x,
      showCloneButtons: O,
      showLockButtons: Q,
      autoSelectField: w,
      autoSelectOperator: $,
      addRuleToNewGroups: j,
      enableDragAndDrop: I,
      independentCombinators: !!M,
      listsAsArrays: V,
      validationMap: St,
      disabledPaths: He
    }),
    [
      j,
      w,
      $,
      o,
      te,
      pe,
      fe,
      Te,
      He,
      I,
      ve,
      le,
      Le,
      he,
      y,
      R,
      Pe,
      ge,
      je,
      M,
      V,
      O,
      k,
      Q,
      x,
      St
    ]
  ), Nt = {
    onRuleAdd: it,
    onGroupAdd: ut,
    onRuleRemove: Be,
    onGroupRemove: Be,
    onPropChange: Xe,
    moveRule: Fe
  }, Ct = We(
    () => De(Se.queryBuilder, De(te.queryBuilder), {
      [Se.disabled]: oe.disabled || K,
      [Se.valid]: typeof at == "boolean" && at,
      [Se.invalid]: typeof at == "boolean" && !at
    }),
    [te.queryBuilder, K, oe.disabled, at]
  );
  Vt(() => {
    ee && F({ type: vt.queryUpdate, query: oe, queryState: Oe, schema: st });
  }, [ee, F, Oe, oe, st]);
  const { ruleGroup: Tt } = pe;
  return /* @__PURE__ */ de(un.Provider, { value: Y, children: /* @__PURE__ */ de(
    "div",
    {
      className: Ct,
      "data-dnd": I ? "enabled" : "disabled",
      "data-inlinecombinators": M || k ? "enabled" : "disabled",
      children: /* @__PURE__ */ de(
        Tt,
        {
          translations: A,
          ruleGroup: oe,
          rules: oe.rules,
          combinator: "combinator" in oe ? oe.combinator : void 0,
          not: !!oe.not,
          schema: st,
          actions: Nt,
          id: oe.id,
          path: [],
          disabled: !!oe.disabled || K,
          parentDisabled: K,
          context: X
        }
      )
    }
  ) }, I ? "dnd" : "no-dnd");
};
w1.displayName = "QueryBuilder";
export {
  Et as ActionElement,
  gs as DragHandle,
  Yr as InlineCombinator,
  vt as LogType,
  vs as NotToggle,
  w1 as QueryBuilder,
  ms as Rule,
  bs as RuleGroup,
  qe as TestID,
  Es as ValueEditor,
  It as ValueSelector,
  Dr as add,
  B1 as c,
  dn as convertFromIC,
  F1 as convertQuery,
  vn as convertToIC,
  w1 as default,
  Q1 as defaultCELValueProcessor,
  Dt as defaultCombinators,
  $1 as defaultCombinatorsExtended,
  Gs as defaultControlClassnames,
  L1 as defaultControlElements,
  zn as defaultJoinChar,
  H1 as defaultMongoDBValueProcessor,
  Jr as defaultOperatorNegationMap,
  $s as defaultOperators,
  Ps as defaultPlaceholderFieldGroupLabel,
  xs as defaultPlaceholderFieldLabel,
  Mn as defaultPlaceholderFieldName,
  Ds as defaultPlaceholderOperatorGroupLabel,
  Vs as defaultPlaceholderOperatorLabel,
  Un as defaultPlaceholderOperatorName,
  pn as defaultRuleProcessorCEL,
  Rr as defaultRuleProcessorJsonLogic,
  yn as defaultRuleProcessorMongoDB,
  mn as defaultRuleProcessorSpEL,
  q1 as defaultSpELValueProcessor,
  Hn as defaultTranslations,
  W1 as defaultValidator,
  U1 as defaultValueProcessor,
  qn as defaultValueProcessorByRule,
  J1 as defaultValueProcessorCELByRule,
  Y1 as defaultValueProcessorMongoDBByRule,
  z1 as defaultValueProcessorSpELByRule,
  Rt as findPath,
  M1 as formatQuery,
  mt as generateID,
  R1 as getCommonAncestorPath,
  X1 as getCompatContextProvider,
  Pt as getFirstOption,
  Xr as getOption,
  Lt as getParentPath,
  $n as groupInvalidReasons,
  no as isAncestor,
  yt as isOptionGroupArray,
  Zr as isRuleGroup,
  hn as isRuleGroupType,
  Fs as isRuleGroupTypeIC,
  dt as isRuleOrGroupValid,
  Sr as isValidationResult,
  fn as joinWith,
  j1 as jsonLogicAdditionalOperators,
  rs as mergeClassnames,
  so as messages,
  A1 as move,
  G1 as nullFreeArray,
  et as objectKeys,
  K1 as parseCEL,
  Z1 as parseJsonLogic,
  eo as parseMongoDB,
  to as parseSQL,
  Xt as pathIsDisabled,
  is as pathsAreEqual,
  as as prepareRule,
  bn as prepareRuleGroup,
  S1 as prepareRuleOrGroup,
  C1 as remove,
  Bs as splitBy,
  Se as standardClassnames,
  tt as toArray,
  O1 as toOptions,
  ro as transformQuery,
  ze as trimIfString,
  N1 as update,
  Js as useMergedContext,
  Fn as usePreferProp,
  Ys as useValueEditor,
  D1 as version
};
//# sourceMappingURL=index.es.js.map
